
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireefef"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireefef"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6PK7Y", function(module, exports) {
/*!
 * Materialize v1.0.0 (http://materializecss.com)
 * Copyright 2014-2017 Materialize
 * MIT License (https://raw.githubusercontent.com/Dogfalo/materialize/master/LICENSE)
 */ var _get = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object, property);
    if (desc === undefined) {
        var parent = Object.getPrototypeOf(object);
        if (parent === null) return undefined;
        else return get(parent, property, receiver);
    } else if ("value" in desc) return desc.value;
    else {
        var getter = desc.get;
        if (getter === undefined) return undefined;
        return getter.call(receiver);
    }
};
var _createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function _possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/*! cash-dom 1.3.5, https://github.com/kenwheeler/cash @license MIT */ (function(factory) {
    window.cash = factory();
})(function() {
    var doc = document, win = window, ArrayProto = Array.prototype, slice = ArrayProto.slice, filter = ArrayProto.filter, push = ArrayProto.push;
    var noop = function() {}, isFunction = function(item) {
        // @see https://crbug.com/568448
        return typeof item === typeof noop && item.call;
    }, isString = function(item) {
        return typeof item === "string";
    };
    var idMatch = /^#[\w-]*$/, classMatch = /^\.[\w-]*$/, htmlMatch = /<.+>/, singlet = /^\w+$/;
    function find(selector, context) {
        context = context || doc;
        var elems = classMatch.test(selector) ? context.getElementsByClassName(selector.slice(1)) : singlet.test(selector) ? context.getElementsByTagName(selector) : context.querySelectorAll(selector);
        return elems;
    }
    var frag;
    function parseHTML(str) {
        if (!frag) {
            frag = doc.implementation.createHTMLDocument(null);
            var base = frag.createElement("base");
            base.href = doc.location.href;
            frag.head.appendChild(base);
        }
        frag.body.innerHTML = str;
        return frag.body.childNodes;
    }
    function onReady(fn) {
        if (doc.readyState !== "loading") fn();
        else doc.addEventListener("DOMContentLoaded", fn);
    }
    function Init(selector, context) {
        if (!selector) return this;
        // If already a cash collection, don't do any further processing
        if (selector.cash && selector !== win) return selector;
        var elems = selector, i = 0, length;
        if (isString(selector)) elems = idMatch.test(selector) ? // If an ID use the faster getElementById check
        doc.getElementById(selector.slice(1)) : htmlMatch.test(selector) ? // If HTML, parse it into real elements
        parseHTML(selector) : // else use `find`
        find(selector, context);
        else if (isFunction(selector)) {
            onReady(selector);
            return this;
        }
        if (!elems) return this;
        // If a single DOM element is passed in or received via ID, return the single element
        if (elems.nodeType || elems === win) {
            this[0] = elems;
            this.length = 1;
        } else {
            // Treat like an array and loop through each item.
            length = this.length = elems.length;
            for(; i < length; i++)this[i] = elems[i];
        }
        return this;
    }
    function cash1(selector, context) {
        return new Init(selector, context);
    }
    var fn = cash1.fn = cash1.prototype = Init.prototype = {
        cash: true,
        length: 0,
        push: push,
        splice: ArrayProto.splice,
        map: ArrayProto.map,
        init: Init
    };
    Object.defineProperty(fn, "constructor", {
        value: cash1
    });
    cash1.parseHTML = parseHTML;
    cash1.noop = noop;
    cash1.isFunction = isFunction;
    cash1.isString = isString;
    cash1.extend = fn.extend = function(target) {
        target = target || {};
        var args = slice.call(arguments), length = args.length, i = 1;
        if (args.length === 1) {
            target = this;
            i = 0;
        }
        for(; i < length; i++){
            if (!args[i]) continue;
            for(var key in args[i])if (args[i].hasOwnProperty(key)) target[key] = args[i][key];
        }
        return target;
    };
    function each(collection, callback) {
        var l = collection.length, i = 0;
        for(; i < l; i++){
            if (callback.call(collection[i], collection[i], i, collection) === false) break;
        }
    }
    function matches(el, selector) {
        var m = el && (el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector || el.oMatchesSelector);
        return !!m && m.call(el, selector);
    }
    function getCompareFunction(selector) {
        return /* Use browser's `matches` function if string */ isString(selector) ? matches : /* Match a cash element */ selector.cash ? function(el) {
            return selector.is(el);
        } : /* Direct comparison */ function(el, selector) {
            return el === selector;
        };
    }
    function unique(collection) {
        return cash1(slice.call(collection).filter(function(item, index, self) {
            return self.indexOf(item) === index;
        }));
    }
    cash1.extend({
        merge: function(first, second) {
            var len = +second.length, i = first.length, j = 0;
            for(; j < len; i++, j++)first[i] = second[j];
            first.length = i;
            return first;
        },
        each: each,
        matches: matches,
        unique: unique,
        isArray: Array.isArray,
        isNumeric: function(n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        }
    });
    var uid = cash1.uid = "_cash" + Date.now();
    function getDataCache(node) {
        return node[uid] = node[uid] || {};
    }
    function setData(node, key, value) {
        return getDataCache(node)[key] = value;
    }
    function getData(node, key) {
        var c = getDataCache(node);
        if (c[key] === undefined) c[key] = node.dataset ? node.dataset[key] : cash1(node).attr("data-" + key);
        return c[key];
    }
    function removeData(node, key) {
        var c = getDataCache(node);
        if (c) delete c[key];
        else if (node.dataset) delete node.dataset[key];
        else cash1(node).removeAttr("data-" + name);
    }
    fn.extend({
        data: function(name1, value) {
            if (isString(name1)) return value === undefined ? getData(this[0], name1) : this.each(function(v) {
                return setData(v, name1, value);
            });
            for(var key in name1)this.data(key, name1[key]);
            return this;
        },
        removeData: function(key) {
            return this.each(function(v) {
                return removeData(v, key);
            });
        }
    });
    var notWhiteMatch = /\S+/g;
    function getClasses(c) {
        return isString(c) && c.match(notWhiteMatch);
    }
    function hasClass(v, c) {
        return v.classList ? v.classList.contains(c) : new RegExp("(^| )" + c + "( |$)", "gi").test(v.className);
    }
    function addClass(v, c, spacedName) {
        if (v.classList) v.classList.add(c);
        else if (spacedName.indexOf(" " + c + " ")) v.className += " " + c;
    }
    function removeClass(v, c) {
        if (v.classList) v.classList.remove(c);
        else v.className = v.className.replace(c, "");
    }
    fn.extend({
        addClass: function(c) {
            var classes = getClasses(c);
            return classes ? this.each(function(v) {
                var spacedName = " " + v.className + " ";
                each(classes, function(c) {
                    addClass(v, c, spacedName);
                });
            }) : this;
        },
        attr: function(name1, value) {
            if (!name1) return undefined;
            if (isString(name1)) {
                if (value === undefined) return this[0] ? this[0].getAttribute ? this[0].getAttribute(name1) : this[0][name1] : undefined;
                return this.each(function(v) {
                    if (v.setAttribute) v.setAttribute(name1, value);
                    else v[name1] = value;
                });
            }
            for(var key in name1)this.attr(key, name1[key]);
            return this;
        },
        hasClass: function(c) {
            var check = false, classes = getClasses(c);
            if (classes && classes.length) this.each(function(v) {
                check = hasClass(v, classes[0]);
                return !check;
            });
            return check;
        },
        prop: function(name1, value) {
            if (isString(name1)) return value === undefined ? this[0][name1] : this.each(function(v) {
                v[name1] = value;
            });
            for(var key in name1)this.prop(key, name1[key]);
            return this;
        },
        removeAttr: function(name1) {
            return this.each(function(v) {
                if (v.removeAttribute) v.removeAttribute(name1);
                else delete v[name1];
            });
        },
        removeClass: function(c) {
            if (!arguments.length) return this.attr("class", "");
            var classes = getClasses(c);
            return classes ? this.each(function(v) {
                each(classes, function(c) {
                    removeClass(v, c);
                });
            }) : this;
        },
        removeProp: function(name1) {
            return this.each(function(v) {
                delete v[name1];
            });
        },
        toggleClass: function(c, state) {
            if (state !== undefined) return this[state ? "addClass" : "removeClass"](c);
            var classes = getClasses(c);
            return classes ? this.each(function(v) {
                var spacedName = " " + v.className + " ";
                each(classes, function(c) {
                    if (hasClass(v, c)) removeClass(v, c);
                    else addClass(v, c, spacedName);
                });
            }) : this;
        }
    });
    fn.extend({
        add: function(selector, context) {
            return unique(cash1.merge(this, cash1(selector, context)));
        },
        each: function(callback) {
            each(this, callback);
            return this;
        },
        eq: function(index) {
            return cash1(this.get(index));
        },
        filter: function(selector) {
            if (!selector) return this;
            var comparator = isFunction(selector) ? selector : getCompareFunction(selector);
            return cash1(filter.call(this, function(e) {
                return comparator(e, selector);
            }));
        },
        first: function() {
            return this.eq(0);
        },
        get: function(index) {
            if (index === undefined) return slice.call(this);
            return index < 0 ? this[index + this.length] : this[index];
        },
        index: function(elem) {
            var child = elem ? cash1(elem)[0] : this[0], collection = elem ? this : cash1(child).parent().children();
            return slice.call(collection).indexOf(child);
        },
        last: function() {
            return this.eq(-1);
        }
    });
    var camelCase = function() {
        var camelRegex = /(?:^\w|[A-Z]|\b\w)/g, whiteSpace = /[\s-_]+/g;
        return function(str) {
            return str.replace(camelRegex, function(letter, index) {
                return letter[index === 0 ? "toLowerCase" : "toUpperCase"]();
            }).replace(whiteSpace, "");
        };
    }();
    var getPrefixedProp = function() {
        var cache = {}, doc = document, div = doc.createElement("div"), style = div.style;
        return function(prop) {
            prop = camelCase(prop);
            if (cache[prop]) return cache[prop];
            var ucProp = prop.charAt(0).toUpperCase() + prop.slice(1), prefixes = [
                "webkit",
                "moz",
                "ms",
                "o"
            ], props = (prop + " " + prefixes.join(ucProp + " ") + ucProp).split(" ");
            each(props, function(p) {
                if (p in style) {
                    cache[p] = prop = cache[prop] = p;
                    return false;
                }
            });
            return cache[prop];
        };
    }();
    cash1.prefixedProp = getPrefixedProp;
    cash1.camelCase = camelCase;
    fn.extend({
        css: function(prop, value) {
            if (isString(prop)) {
                prop = getPrefixedProp(prop);
                return arguments.length > 1 ? this.each(function(v) {
                    return v.style[prop] = value;
                }) : win.getComputedStyle(this[0])[prop];
            }
            for(var key in prop)this.css(key, prop[key]);
            return this;
        }
    });
    function compute(el, prop) {
        return parseInt(win.getComputedStyle(el[0], null)[prop], 10) || 0;
    }
    each([
        "Width",
        "Height"
    ], function(v) {
        var lower = v.toLowerCase();
        fn[lower] = function() {
            return this[0].getBoundingClientRect()[lower];
        };
        fn["inner" + v] = function() {
            return this[0]["client" + v];
        };
        fn["outer" + v] = function(margins) {
            return this[0]["offset" + v] + (margins ? compute(this, "margin" + (v === "Width" ? "Left" : "Top")) + compute(this, "margin" + (v === "Width" ? "Right" : "Bottom")) : 0);
        };
    });
    function registerEvent(node, eventName, callback) {
        var eventCache = getData(node, "_cashEvents") || setData(node, "_cashEvents", {});
        eventCache[eventName] = eventCache[eventName] || [];
        eventCache[eventName].push(callback);
        node.addEventListener(eventName, callback);
    }
    function removeEvent(node, eventName, callback) {
        var events = getData(node, "_cashEvents"), eventCache = events && events[eventName], index;
        if (!eventCache) return;
        if (callback) {
            node.removeEventListener(eventName, callback);
            index = eventCache.indexOf(callback);
            if (index >= 0) eventCache.splice(index, 1);
        } else {
            each(eventCache, function(event) {
                node.removeEventListener(eventName, event);
            });
            eventCache = [];
        }
    }
    fn.extend({
        off: function(eventName, callback) {
            return this.each(function(v) {
                return removeEvent(v, eventName, callback);
            });
        },
        on: function(eventName, delegate, callback, runOnce) {
            // jshint ignore:line
            var originalCallback;
            if (!isString(eventName)) {
                for(var key in eventName)this.on(key, delegate, eventName[key]);
                return this;
            }
            if (isFunction(delegate)) {
                callback = delegate;
                delegate = null;
            }
            if (eventName === "ready") {
                onReady(callback);
                return this;
            }
            if (delegate) {
                originalCallback = callback;
                callback = function(e) {
                    var t = e.target;
                    while(!matches(t, delegate)){
                        if (t === this || t === null) return t = false;
                        t = t.parentNode;
                    }
                    if (t) originalCallback.call(t, e);
                };
            }
            return this.each(function(v) {
                var finalCallback = callback;
                if (runOnce) finalCallback = function() {
                    callback.apply(this, arguments);
                    removeEvent(v, eventName, finalCallback);
                };
                registerEvent(v, eventName, finalCallback);
            });
        },
        one: function(eventName, delegate, callback) {
            return this.on(eventName, delegate, callback, true);
        },
        ready: onReady,
        /**
     * Modified
     * Triggers browser event
     * @param String eventName
     * @param Object data - Add properties to event object
     */ trigger: function(eventName, data) {
            if (document.createEvent) {
                var evt = document.createEvent("HTMLEvents");
                evt.initEvent(eventName, true, false);
                evt = this.extend(evt, data);
                return this.each(function(v) {
                    return v.dispatchEvent(evt);
                });
            }
        }
    });
    function encode(name1, value) {
        return "&" + encodeURIComponent(name1) + "=" + encodeURIComponent(value).replace(/%20/g, "+");
    }
    function getSelectMultiple_(el) {
        var values = [];
        each(el.options, function(o) {
            if (o.selected) values.push(o.value);
        });
        return values.length ? values : null;
    }
    function getSelectSingle_(el) {
        var selectedIndex = el.selectedIndex;
        return selectedIndex >= 0 ? el.options[selectedIndex].value : null;
    }
    function getValue(el) {
        var type = el.type;
        if (!type) return null;
        switch(type.toLowerCase()){
            case "select-one":
                return getSelectSingle_(el);
            case "select-multiple":
                return getSelectMultiple_(el);
            case "radio":
                return el.checked ? el.value : null;
            case "checkbox":
                return el.checked ? el.value : null;
            default:
                return el.value ? el.value : null;
        }
    }
    fn.extend({
        serialize: function() {
            var query = "";
            each(this[0].elements || this, function(el) {
                if (el.disabled || el.tagName === "FIELDSET") return;
                var name1 = el.name;
                switch(el.type.toLowerCase()){
                    case "file":
                    case "reset":
                    case "submit":
                    case "button":
                        break;
                    case "select-multiple":
                        var values = getValue(el);
                        if (values !== null) each(values, function(value) {
                            query += encode(name1, value);
                        });
                        break;
                    default:
                        var value = getValue(el);
                        if (value !== null) query += encode(name1, value);
                }
            });
            return query.substr(1);
        },
        val: function(value) {
            if (value === undefined) return getValue(this[0]);
            return this.each(function(v) {
                return v.value = value;
            });
        }
    });
    function insertElement(el, child, prepend) {
        if (prepend) {
            var first = el.childNodes[0];
            el.insertBefore(child, first);
        } else el.appendChild(child);
    }
    function insertContent(parent, child, prepend) {
        var str = isString(child);
        if (!str && child.length) {
            each(child, function(v) {
                return insertContent(parent, v, prepend);
            });
            return;
        }
        each(parent, str ? function(v) {
            return v.insertAdjacentHTML(prepend ? "afterbegin" : "beforeend", child);
        } : function(v, i) {
            return insertElement(v, i === 0 ? child : child.cloneNode(true), prepend);
        });
    }
    fn.extend({
        after: function(selector) {
            cash1(selector).insertAfter(this);
            return this;
        },
        append: function(content) {
            insertContent(this, content);
            return this;
        },
        appendTo: function(parent) {
            insertContent(cash1(parent), this);
            return this;
        },
        before: function(selector) {
            cash1(selector).insertBefore(this);
            return this;
        },
        clone: function() {
            return cash1(this.map(function(v) {
                return v.cloneNode(true);
            }));
        },
        empty: function() {
            this.html("");
            return this;
        },
        html: function(content) {
            if (content === undefined) return this[0].innerHTML;
            var source = content.nodeType ? content[0].outerHTML : content;
            return this.each(function(v) {
                return v.innerHTML = source;
            });
        },
        insertAfter: function(selector) {
            var _this = this;
            cash1(selector).each(function(el, i) {
                var parent = el.parentNode, sibling = el.nextSibling;
                _this.each(function(v) {
                    parent.insertBefore(i === 0 ? v : v.cloneNode(true), sibling);
                });
            });
            return this;
        },
        insertBefore: function(selector) {
            var _this2 = this;
            cash1(selector).each(function(el, i) {
                var parent = el.parentNode;
                _this2.each(function(v) {
                    parent.insertBefore(i === 0 ? v : v.cloneNode(true), el);
                });
            });
            return this;
        },
        prepend: function(content) {
            insertContent(this, content, true);
            return this;
        },
        prependTo: function(parent) {
            insertContent(cash1(parent), this, true);
            return this;
        },
        remove: function() {
            return this.each(function(v) {
                if (!!v.parentNode) return v.parentNode.removeChild(v);
            });
        },
        text: function(content) {
            if (content === undefined) return this[0].textContent;
            return this.each(function(v) {
                return v.textContent = content;
            });
        }
    });
    var docEl = doc.documentElement;
    fn.extend({
        position: function() {
            var el = this[0];
            return {
                left: el.offsetLeft,
                top: el.offsetTop
            };
        },
        offset: function() {
            var rect = this[0].getBoundingClientRect();
            return {
                top: rect.top + win.pageYOffset - docEl.clientTop,
                left: rect.left + win.pageXOffset - docEl.clientLeft
            };
        },
        offsetParent: function() {
            return cash1(this[0].offsetParent);
        }
    });
    fn.extend({
        children: function(selector) {
            var elems = [];
            this.each(function(el) {
                push.apply(elems, el.children);
            });
            elems = unique(elems);
            return !selector ? elems : elems.filter(function(v) {
                return matches(v, selector);
            });
        },
        closest: function(selector) {
            if (!selector || this.length < 1) return cash1();
            if (this.is(selector)) return this.filter(selector);
            return this.parent().closest(selector);
        },
        is: function(selector) {
            if (!selector) return false;
            var match = false, comparator = getCompareFunction(selector);
            this.each(function(el) {
                match = comparator(el, selector);
                return !match;
            });
            return match;
        },
        find: function(selector) {
            if (!selector || selector.nodeType) return cash1(selector && this.has(selector).length ? selector : null);
            var elems = [];
            this.each(function(el) {
                push.apply(elems, find(selector, el));
            });
            return unique(elems);
        },
        has: function(selector) {
            var comparator = isString(selector) ? function(el) {
                return find(selector, el).length !== 0;
            } : function(el) {
                return el.contains(selector);
            };
            return this.filter(comparator);
        },
        next: function() {
            return cash1(this[0].nextElementSibling);
        },
        not: function(selector) {
            if (!selector) return this;
            var comparator = getCompareFunction(selector);
            return this.filter(function(el) {
                return !comparator(el, selector);
            });
        },
        parent: function() {
            var result = [];
            this.each(function(item) {
                if (item && item.parentNode) result.push(item.parentNode);
            });
            return unique(result);
        },
        parents: function(selector) {
            var last, result = [];
            this.each(function(item) {
                last = item;
                while(last && last.parentNode && last !== doc.body.parentNode){
                    last = last.parentNode;
                    if (!selector || selector && matches(last, selector)) result.push(last);
                }
            });
            return unique(result);
        },
        prev: function() {
            return cash1(this[0].previousElementSibling);
        },
        siblings: function(selector) {
            var collection = this.parent().children(selector), el = this[0];
            return collection.filter(function(i) {
                return i !== el;
            });
        }
    });
    return cash1;
});
var Component = function() {
    /**
   * Generic constructor for all components
   * @constructor
   * @param {Element} el
   * @param {Object} options
   */ function Component(classDef, el, options) {
        _classCallCheck(this, Component);
        // Display error if el is valid HTML Element
        if (!(el instanceof Element)) console.error(Error(el + " is not an HTML Element"));
        // If exists, destroy and reinitialize in child
        var ins = classDef.getInstance(el);
        if (!!ins) ins.destroy();
        this.el = el;
        this.$el = cash(el);
    }
    /**
   * Initializes components
   * @param {class} classDef
   * @param {Element | NodeList | jQuery} els
   * @param {Object} options
   */ _createClass(Component, null, [
        {
            key: "init",
            value: function init(classDef, els, options) {
                var instances = null;
                if (els instanceof Element) instances = new classDef(els, options);
                else if (!!els && (els.jquery || els.cash || els instanceof NodeList)) {
                    var instancesArr = [];
                    for(var i = 0; i < els.length; i++)instancesArr.push(new classDef(els[i], options));
                    instances = instancesArr;
                }
                return instances;
            }
        }
    ]);
    return Component;
}();
(function(window1) {
    if (window1.Package) M = {};
    else window1.M = {};
    // Check for jQuery
    M.jQueryLoaded = !!window1.jQuery;
})(window);
// AMD
if (typeof define === "function" && define.amd) define("M", [], function() {
    return M;
});
else if (!exports.nodeType) {
    if (!module.nodeType && module.exports) exports = module.exports = M;
    exports.default = M;
}
M.version = "1.0.0";
M.keys = {
    TAB: 9,
    ENTER: 13,
    ESC: 27,
    ARROW_UP: 38,
    ARROW_DOWN: 40
};
/**
 * TabPress Keydown handler
 */ M.tabPressed = false;
M.keyDown = false;
var docHandleKeydown = function(e) {
    M.keyDown = true;
    if (e.which === M.keys.TAB || e.which === M.keys.ARROW_DOWN || e.which === M.keys.ARROW_UP) M.tabPressed = true;
};
var docHandleKeyup = function(e) {
    M.keyDown = false;
    if (e.which === M.keys.TAB || e.which === M.keys.ARROW_DOWN || e.which === M.keys.ARROW_UP) M.tabPressed = false;
};
var docHandleFocus = function(e) {
    if (M.keyDown) document.body.classList.add("keyboard-focused");
};
var docHandleBlur = function(e) {
    document.body.classList.remove("keyboard-focused");
};
document.addEventListener("keydown", docHandleKeydown, true);
document.addEventListener("keyup", docHandleKeyup, true);
document.addEventListener("focus", docHandleFocus, true);
document.addEventListener("blur", docHandleBlur, true);
/**
 * Initialize jQuery wrapper for plugin
 * @param {Class} plugin  javascript class
 * @param {string} pluginName  jQuery plugin name
 * @param {string} classRef  Class reference name
 */ M.initializeJqueryWrapper = function(plugin, pluginName, classRef) {
    jQuery.fn[pluginName] = function(methodOrOptions) {
        // Call plugin method if valid method name is passed in
        if (plugin.prototype[methodOrOptions]) {
            var params = Array.prototype.slice.call(arguments, 1);
            // Getter methods
            if (methodOrOptions.slice(0, 3) === "get") {
                var instance = this.first()[0][classRef];
                return instance[methodOrOptions].apply(instance, params);
            }
            // Void methods
            return this.each(function() {
                var instance = this[classRef];
                instance[methodOrOptions].apply(instance, params);
            });
        // Initialize plugin if options or no argument is passed in
        } else if (typeof methodOrOptions === "object" || !methodOrOptions) {
            plugin.init(this, arguments[0]);
            return this;
        }
        // Return error if an unrecognized  method name is passed in
        jQuery.error("Method " + methodOrOptions + " does not exist on jQuery." + pluginName);
    };
};
/**
 * Automatically initialize components
 * @param {Element} context  DOM Element to search within for components
 */ M.AutoInit = function(context) {
    // Use document.body if no context is given
    var root = !!context ? context : document.body;
    var registry = {
        Autocomplete: root.querySelectorAll(".autocomplete:not(.no-autoinit)"),
        Carousel: root.querySelectorAll(".carousel:not(.no-autoinit)"),
        Chips: root.querySelectorAll(".chips:not(.no-autoinit)"),
        Collapsible: root.querySelectorAll(".collapsible:not(.no-autoinit)"),
        Datepicker: root.querySelectorAll(".datepicker:not(.no-autoinit)"),
        Dropdown: root.querySelectorAll(".dropdown-trigger:not(.no-autoinit)"),
        Materialbox: root.querySelectorAll(".materialboxed:not(.no-autoinit)"),
        Modal: root.querySelectorAll(".modal:not(.no-autoinit)"),
        Parallax: root.querySelectorAll(".parallax:not(.no-autoinit)"),
        Pushpin: root.querySelectorAll(".pushpin:not(.no-autoinit)"),
        ScrollSpy: root.querySelectorAll(".scrollspy:not(.no-autoinit)"),
        FormSelect: root.querySelectorAll("select:not(.no-autoinit)"),
        Sidenav: root.querySelectorAll(".sidenav:not(.no-autoinit)"),
        Tabs: root.querySelectorAll(".tabs:not(.no-autoinit)"),
        TapTarget: root.querySelectorAll(".tap-target:not(.no-autoinit)"),
        Timepicker: root.querySelectorAll(".timepicker:not(.no-autoinit)"),
        Tooltip: root.querySelectorAll(".tooltipped:not(.no-autoinit)"),
        FloatingActionButton: root.querySelectorAll(".fixed-action-btn:not(.no-autoinit)")
    };
    for(var pluginName in registry){
        var plugin = M[pluginName];
        plugin.init(registry[pluginName]);
    }
};
/**
 * Generate approximated selector string for a jQuery object
 * @param {jQuery} obj  jQuery object to be parsed
 * @returns {string}
 */ M.objectSelectorString = function(obj) {
    var tagStr = obj.prop("tagName") || "";
    var idStr = obj.attr("id") || "";
    var classStr = obj.attr("class") || "";
    return (tagStr + idStr + classStr).replace(/\s/g, "");
};
// Unique Random ID
M.guid = function() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
    return function() {
        return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
    };
}();
/**
 * Escapes hash from special characters
 * @param {string} hash  String returned from this.hash
 * @returns {string}
 */ M.escapeHash = function(hash) {
    return hash.replace(/(:|\.|\[|\]|,|=|\/)/g, "\\$1");
};
M.elementOrParentIsFixed = function(element) {
    var $element = $(element);
    var $checkElements = $element.add($element.parents());
    var isFixed = false;
    $checkElements.each(function() {
        if ($(this).css("position") === "fixed") {
            isFixed = true;
            return false;
        }
    });
    return isFixed;
};
/**
 * @typedef {Object} Edges
 * @property {Boolean} top  If the top edge was exceeded
 * @property {Boolean} right  If the right edge was exceeded
 * @property {Boolean} bottom  If the bottom edge was exceeded
 * @property {Boolean} left  If the left edge was exceeded
 */ /**
 * @typedef {Object} Bounding
 * @property {Number} left  left offset coordinate
 * @property {Number} top  top offset coordinate
 * @property {Number} width
 * @property {Number} height
 */ /**
 * Escapes hash from special characters
 * @param {Element} container  Container element that acts as the boundary
 * @param {Bounding} bounding  element bounding that is being checked
 * @param {Number} offset  offset from edge that counts as exceeding
 * @returns {Edges}
 */ M.checkWithinContainer = function(container, bounding, offset) {
    var edges = {
        top: false,
        right: false,
        bottom: false,
        left: false
    };
    var containerRect = container.getBoundingClientRect();
    // If body element is smaller than viewport, use viewport height instead.
    var containerBottom = container === document.body ? Math.max(containerRect.bottom, window.innerHeight) : containerRect.bottom;
    var scrollLeft = container.scrollLeft;
    var scrollTop = container.scrollTop;
    var scrolledX = bounding.left - scrollLeft;
    var scrolledY = bounding.top - scrollTop;
    // Check for container and viewport for each edge
    if (scrolledX < containerRect.left + offset || scrolledX < offset) edges.left = true;
    if (scrolledX + bounding.width > containerRect.right - offset || scrolledX + bounding.width > window.innerWidth - offset) edges.right = true;
    if (scrolledY < containerRect.top + offset || scrolledY < offset) edges.top = true;
    if (scrolledY + bounding.height > containerBottom - offset || scrolledY + bounding.height > window.innerHeight - offset) edges.bottom = true;
    return edges;
};
M.checkPossibleAlignments = function(el, container, bounding, offset) {
    var canAlign = {
        top: true,
        right: true,
        bottom: true,
        left: true,
        spaceOnTop: null,
        spaceOnRight: null,
        spaceOnBottom: null,
        spaceOnLeft: null
    };
    var containerAllowsOverflow = getComputedStyle(container).overflow === "visible";
    var containerRect = container.getBoundingClientRect();
    var containerHeight = Math.min(containerRect.height, window.innerHeight);
    var containerWidth = Math.min(containerRect.width, window.innerWidth);
    var elOffsetRect = el.getBoundingClientRect();
    var scrollLeft = container.scrollLeft;
    var scrollTop = container.scrollTop;
    var scrolledX = bounding.left - scrollLeft;
    var scrolledYTopEdge = bounding.top - scrollTop;
    var scrolledYBottomEdge = bounding.top + elOffsetRect.height - scrollTop;
    // Check for container and viewport for left
    canAlign.spaceOnRight = !containerAllowsOverflow ? containerWidth - (scrolledX + bounding.width) : window.innerWidth - (elOffsetRect.left + bounding.width);
    if (canAlign.spaceOnRight < 0) canAlign.left = false;
    // Check for container and viewport for Right
    canAlign.spaceOnLeft = !containerAllowsOverflow ? scrolledX - bounding.width + elOffsetRect.width : elOffsetRect.right - bounding.width;
    if (canAlign.spaceOnLeft < 0) canAlign.right = false;
    // Check for container and viewport for Top
    canAlign.spaceOnBottom = !containerAllowsOverflow ? containerHeight - (scrolledYTopEdge + bounding.height + offset) : window.innerHeight - (elOffsetRect.top + bounding.height + offset);
    if (canAlign.spaceOnBottom < 0) canAlign.top = false;
    // Check for container and viewport for Bottom
    canAlign.spaceOnTop = !containerAllowsOverflow ? scrolledYBottomEdge - (bounding.height - offset) : elOffsetRect.bottom - (bounding.height + offset);
    if (canAlign.spaceOnTop < 0) canAlign.bottom = false;
    return canAlign;
};
M.getOverflowParent = function(element) {
    if (element == null) return null;
    if (element === document.body || getComputedStyle(element).overflow !== "visible") return element;
    return M.getOverflowParent(element.parentElement);
};
/**
 * Gets id of component from a trigger
 * @param {Element} trigger  trigger
 * @returns {string}
 */ M.getIdFromTrigger = function(trigger) {
    var id = trigger.getAttribute("data-target");
    if (!id) {
        id = trigger.getAttribute("href");
        if (id) id = id.slice(1);
        else id = "";
    }
    return id;
};
/**
 * Multi browser support for document scroll top
 * @returns {Number}
 */ M.getDocumentScrollTop = function() {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
};
/**
 * Multi browser support for document scroll left
 * @returns {Number}
 */ M.getDocumentScrollLeft = function() {
    return window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
};
/**
 * @typedef {Object} Edges
 * @property {Boolean} top  If the top edge was exceeded
 * @property {Boolean} right  If the right edge was exceeded
 * @property {Boolean} bottom  If the bottom edge was exceeded
 * @property {Boolean} left  If the left edge was exceeded
 */ /**
 * @typedef {Object} Bounding
 * @property {Number} left  left offset coordinate
 * @property {Number} top  top offset coordinate
 * @property {Number} width
 * @property {Number} height
 */ /**
 * Get time in ms
 * @license https://raw.github.com/jashkenas/underscore/master/LICENSE
 * @type {function}
 * @return {number}
 */ var getTime = Date.now || function() {
    return new Date().getTime();
};
/**
 * Returns a function, that, when invoked, will only be triggered at most once
 * during a given window of time. Normally, the throttled function will run
 * as much as it can, without ever going more than once per `wait` duration;
 * but if you'd like to disable the execution on the leading edge, pass
 * `{leading: false}`. To disable execution on the trailing edge, ditto.
 * @license https://raw.github.com/jashkenas/underscore/master/LICENSE
 * @param {function} func
 * @param {number} wait
 * @param {Object=} options
 * @returns {Function}
 */ M.throttle = function(func, wait, options) {
    var context = void 0, args = void 0, result = void 0;
    var timeout = null;
    var previous = 0;
    options || (options = {});
    var later = function() {
        previous = options.leading === false ? 0 : getTime();
        timeout = null;
        result = func.apply(context, args);
        context = args = null;
    };
    return function() {
        var now = getTime();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0) {
            clearTimeout(timeout);
            timeout = null;
            previous = now;
            result = func.apply(context, args);
            context = args = null;
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
        return result;
    };
};
var $jscomp = {
    scope: {}
};
$jscomp.defineProperty = "function" == typeof Object.defineProperties ? Object.defineProperty : function(e, r, p) {
    if (p.get || p.set) throw new TypeError("ES3 does not support getters and setters.");
    e != Array.prototype && e != Object.prototype && (e[r] = p.value);
};
$jscomp.getGlobal = function(e) {
    return "undefined" != typeof window && window === e ? e : "undefined" != typeof $parcel$global && null != $parcel$global ? $parcel$global : e;
};
$jscomp.global = $jscomp.getGlobal(this);
$jscomp.SYMBOL_PREFIX = "jscomp_symbol_";
$jscomp.initSymbol = function() {
    $jscomp.initSymbol = function() {};
    $jscomp.global.Symbol || ($jscomp.global.Symbol = $jscomp.Symbol);
};
$jscomp.symbolCounter_ = 0;
$jscomp.Symbol = function(e) {
    return $jscomp.SYMBOL_PREFIX + (e || "") + $jscomp.symbolCounter_++;
};
$jscomp.initSymbolIterator = function() {
    $jscomp.initSymbol();
    var e = $jscomp.global.Symbol.iterator;
    e || (e = $jscomp.global.Symbol.iterator = $jscomp.global.Symbol("iterator"));
    "function" != typeof Array.prototype[e] && $jscomp.defineProperty(Array.prototype, e, {
        configurable: !0,
        writable: !0,
        value: function() {
            return $jscomp.arrayIterator(this);
        }
    });
    $jscomp.initSymbolIterator = function() {};
};
$jscomp.arrayIterator = function(e) {
    var r = 0;
    return $jscomp.iteratorPrototype(function() {
        return r < e.length ? {
            done: !1,
            value: e[r++]
        } : {
            done: !0
        };
    });
};
$jscomp.iteratorPrototype = function(e) {
    $jscomp.initSymbolIterator();
    e = {
        next: e
    };
    e[$jscomp.global.Symbol.iterator] = function() {
        return this;
    };
    return e;
};
$jscomp.array = $jscomp.array || {};
$jscomp.iteratorFromArray = function(e, r) {
    $jscomp.initSymbolIterator();
    e instanceof String && (e += "");
    var p = 0, m = {
        next: function() {
            if (p < e.length) {
                var u = p++;
                return {
                    value: r(u, e[u]),
                    done: !1
                };
            }
            m.next = function() {
                return {
                    done: !0,
                    value: void 0
                };
            };
            return m.next();
        }
    };
    m[Symbol.iterator] = function() {
        return m;
    };
    return m;
};
$jscomp.polyfill = function(e, r, p, m) {
    if (r) {
        p = $jscomp.global;
        e = e.split(".");
        for(m = 0; m < e.length - 1; m++){
            var u = e[m];
            u in p || (p[u] = {});
            p = p[u];
        }
        e = e[e.length - 1];
        m = p[e];
        r = r(m);
        r != m && null != r && $jscomp.defineProperty(p, e, {
            configurable: !0,
            writable: !0,
            value: r
        });
    }
};
$jscomp.polyfill("Array.prototype.keys", function(e) {
    return e ? e : function() {
        return $jscomp.iteratorFromArray(this, function(e) {
            return e;
        });
    };
}, "es6-impl", "es3");
var $jscomp$this = this;
(function(r) {
    M.anime = r();
})(function() {
    function e(a) {
        if (!h.col(a)) try {
            return document.querySelectorAll(a);
        } catch (c) {}
    }
    function r(a, c) {
        for(var d = a.length, b = 2 <= arguments.length ? arguments[1] : void 0, f = [], n = 0; n < d; n++)if (n in a) {
            var k = a[n];
            c.call(b, k, n, a) && f.push(k);
        }
        return f;
    }
    function p(a) {
        return a.reduce(function(a, d) {
            return a.concat(h.arr(d) ? p(d) : d);
        }, []);
    }
    function m(a) {
        if (h.arr(a)) return a;
        h.str(a) && (a = e(a) || a);
        return a instanceof NodeList || a instanceof HTMLCollection ? [].slice.call(a) : [
            a
        ];
    }
    function u(a, c) {
        return a.some(function(a) {
            return a === c;
        });
    }
    function C(a) {
        var c = {}, d;
        for(d in a)c[d] = a[d];
        return c;
    }
    function D(a, c) {
        var d = C(a), b;
        for(b in a)d[b] = c.hasOwnProperty(b) ? c[b] : a[b];
        return d;
    }
    function z(a, c) {
        var d = C(a), b;
        for(b in c)d[b] = h.und(a[b]) ? c[b] : a[b];
        return d;
    }
    function T(a) {
        a = a.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function(a, c, d, k) {
            return c + c + d + d + k + k;
        });
        var c = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(a);
        a = parseInt(c[1], 16);
        var d = parseInt(c[2], 16), c = parseInt(c[3], 16);
        return "rgba(" + a + "," + d + "," + c + ",1)";
    }
    function U(a) {
        function c(a, c, b) {
            0 > b && (b += 1);
            1 < b && --b;
            return b < 1 / 6 ? a + 6 * (c - a) * b : .5 > b ? c : b < 2 / 3 ? a + (c - a) * (2 / 3 - b) * 6 : a;
        }
        var d = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(a) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(a);
        a = parseInt(d[1]) / 360;
        var b = parseInt(d[2]) / 100, f = parseInt(d[3]) / 100, d = d[4] || 1;
        if (0 == b) f = b = a = f;
        else {
            var n = .5 > f ? f * (1 + b) : f + b - f * b, k = 2 * f - n, f = c(k, n, a + 1 / 3), b = c(k, n, a);
            a = c(k, n, a - 1 / 3);
        }
        return "rgba(" + 255 * f + "," + 255 * b + "," + 255 * a + "," + d + ")";
    }
    function y(a) {
        if (a = /([\+\-]?[0-9#\.]+)(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(a)) return a[2];
    }
    function V(a) {
        if (-1 < a.indexOf("translate") || "perspective" === a) return "px";
        if (-1 < a.indexOf("rotate") || -1 < a.indexOf("skew")) return "deg";
    }
    function I(a, c) {
        return h.fnc(a) ? a(c.target, c.id, c.total) : a;
    }
    function E(a, c) {
        if (c in a.style) return getComputedStyle(a).getPropertyValue(c.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()) || "0";
    }
    function J(a, c) {
        if (h.dom(a) && u(W, c)) return "transform";
        if (h.dom(a) && (a.getAttribute(c) || h.svg(a) && a[c])) return "attribute";
        if (h.dom(a) && "transform" !== c && E(a, c)) return "css";
        if (null != a[c]) return "object";
    }
    function X(a, c) {
        var d = V(c), d = -1 < c.indexOf("scale") ? 1 : 0 + d;
        a = a.style.transform;
        if (!a) return d;
        for(var b = [], f = [], n = [], k = /(\w+)\((.+?)\)/g; b = k.exec(a);)f.push(b[1]), n.push(b[2]);
        a = r(n, function(a, b) {
            return f[b] === c;
        });
        return a.length ? a[0] : d;
    }
    function K(a, c) {
        switch(J(a, c)){
            case "transform":
                return X(a, c);
            case "css":
                return E(a, c);
            case "attribute":
                return a.getAttribute(c);
        }
        return a[c] || 0;
    }
    function L(a, c) {
        var d = /^(\*=|\+=|-=)/.exec(a);
        if (!d) return a;
        var b = y(a) || 0;
        c = parseFloat(c);
        a = parseFloat(a.replace(d[0], ""));
        switch(d[0][0]){
            case "+":
                return c + a + b;
            case "-":
                return c - a + b;
            case "*":
                return c * a + b;
        }
    }
    function F(a, c) {
        return Math.sqrt(Math.pow(c.x - a.x, 2) + Math.pow(c.y - a.y, 2));
    }
    function M1(a) {
        a = a.points;
        for(var c = 0, d, b = 0; b < a.numberOfItems; b++){
            var f = a.getItem(b);
            0 < b && (c += F(d, f));
            d = f;
        }
        return c;
    }
    function N(a) {
        if (a.getTotalLength) return a.getTotalLength();
        switch(a.tagName.toLowerCase()){
            case "circle":
                return 2 * Math.PI * a.getAttribute("r");
            case "rect":
                return 2 * a.getAttribute("width") + 2 * a.getAttribute("height");
            case "line":
                return F({
                    x: a.getAttribute("x1"),
                    y: a.getAttribute("y1")
                }, {
                    x: a.getAttribute("x2"),
                    y: a.getAttribute("y2")
                });
            case "polyline":
                return M1(a);
            case "polygon":
                var c = a.points;
                return M1(a) + F(c.getItem(c.numberOfItems - 1), c.getItem(0));
        }
    }
    function Y(a, c) {
        function d(b) {
            b = void 0 === b ? 0 : b;
            return a.el.getPointAtLength(1 <= c + b ? c + b : 0);
        }
        var b = d(), f = d(-1), n = d(1);
        switch(a.property){
            case "x":
                return b.x;
            case "y":
                return b.y;
            case "angle":
                return 180 * Math.atan2(n.y - f.y, n.x - f.x) / Math.PI;
        }
    }
    function O(a, c) {
        var d = /-?\d*\.?\d+/g, b;
        b = h.pth(a) ? a.totalLength : a;
        if (h.col(b)) {
            if (h.rgb(b)) {
                var f = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(b);
                b = f ? "rgba(" + f[1] + ",1)" : b;
            } else b = h.hex(b) ? T(b) : h.hsl(b) ? U(b) : void 0;
        } else f = (f = y(b)) ? b.substr(0, b.length - f.length) : b, b = c && !/\s/g.test(b) ? f + c : f;
        b += "";
        return {
            original: b,
            numbers: b.match(d) ? b.match(d).map(Number) : [
                0
            ],
            strings: h.str(a) || c ? b.split(d) : []
        };
    }
    function P(a) {
        a = a ? p(h.arr(a) ? a.map(m) : m(a)) : [];
        return r(a, function(a, d, b) {
            return b.indexOf(a) === d;
        });
    }
    function Z(a) {
        var c = P(a);
        return c.map(function(a, b) {
            return {
                target: a,
                id: b,
                total: c.length
            };
        });
    }
    function aa(a, c) {
        var d = C(c);
        if (h.arr(a)) {
            var b = a.length;
            2 !== b || h.obj(a[0]) ? h.fnc(c.duration) || (d.duration = c.duration / b) : a = {
                value: a
            };
        }
        return m(a).map(function(a, b) {
            b = b ? 0 : c.delay;
            a = h.obj(a) && !h.pth(a) ? a : {
                value: a
            };
            h.und(a.delay) && (a.delay = b);
            return a;
        }).map(function(a) {
            return z(a, d);
        });
    }
    function ba(a, c) {
        var d = {}, b;
        for(b in a){
            var f = I(a[b], c);
            h.arr(f) && (f = f.map(function(a) {
                return I(a, c);
            }), 1 === f.length && (f = f[0]));
            d[b] = f;
        }
        d.duration = parseFloat(d.duration);
        d.delay = parseFloat(d.delay);
        return d;
    }
    function ca(a) {
        return h.arr(a) ? A.apply(this, a) : Q[a];
    }
    function da(a, c) {
        var d;
        return a.tweens.map(function(b) {
            b = ba(b, c);
            var f = b.value, e = K(c.target, a.name), k = d ? d.to.original : e, k = h.arr(f) ? f[0] : k, w = L(h.arr(f) ? f[1] : f, k), e = y(w) || y(k) || y(e);
            b.from = O(k, e);
            b.to = O(w, e);
            b.start = d ? d.end : a.offset;
            b.end = b.start + b.delay + b.duration;
            b.easing = ca(b.easing);
            b.elasticity = (1E3 - Math.min(Math.max(b.elasticity, 1), 999)) / 1E3;
            b.isPath = h.pth(f);
            b.isColor = h.col(b.from.original);
            b.isColor && (b.round = 1);
            return d = b;
        });
    }
    function ea(a, c) {
        return r(p(a.map(function(a) {
            return c.map(function(b) {
                var c = J(a.target, b.name);
                if (c) {
                    var d = da(b, a);
                    b = {
                        type: c,
                        property: b.name,
                        animatable: a,
                        tweens: d,
                        duration: d[d.length - 1].end,
                        delay: d[0].delay
                    };
                } else b = void 0;
                return b;
            });
        })), function(a) {
            return !h.und(a);
        });
    }
    function R(a, c, d, b) {
        var f = "delay" === a;
        return c.length ? (f ? Math.min : Math.max).apply(Math, c.map(function(b) {
            return b[a];
        })) : f ? b.delay : d.offset + b.delay + b.duration;
    }
    function fa(a) {
        var c = D(ga, a), d = D(S, a), b = Z(a.targets), f = [], e = z(c, d), k;
        for(k in a)e.hasOwnProperty(k) || "targets" === k || f.push({
            name: k,
            offset: e.offset,
            tweens: aa(a[k], d)
        });
        a = ea(b, f);
        return z(c, {
            children: [],
            animatables: b,
            animations: a,
            duration: R("duration", a, c, d),
            delay: R("delay", a, c, d)
        });
    }
    function q(a) {
        function c() {
            return window.Promise && new Promise(function(a) {
                return p = a;
            });
        }
        function d(a) {
            return g.reversed ? g.duration - a : a;
        }
        function b(a) {
            for(var b = 0, c = {}, d = g.animations, f = d.length; b < f;){
                var e = d[b], k = e.animatable, h = e.tweens, n = h.length - 1, l = h[n];
                n && (l = r(h, function(b) {
                    return a < b.end;
                })[0] || l);
                for(var h = Math.min(Math.max(a - l.start - l.delay, 0), l.duration) / l.duration, w = isNaN(h) ? 1 : l.easing(h, l.elasticity), h = l.to.strings, p = l.round, n = [], m = void 0, m = l.to.numbers.length, t = 0; t < m; t++){
                    var x = void 0, x = l.to.numbers[t], q = l.from.numbers[t], x = l.isPath ? Y(l.value, w * x) : q + w * (x - q);
                    p && (l.isColor && 2 < t || (x = Math.round(x * p) / p));
                    n.push(x);
                }
                if (l = h.length) for(m = h[0], w = 0; w < l; w++)p = h[w + 1], t = n[w], isNaN(t) || (m = p ? m + (t + p) : m + (t + " "));
                else m = n[0];
                ha[e.type](k.target, e.property, m, c, k.id);
                e.currentValue = m;
                b++;
            }
            if (b = Object.keys(c).length) for(d = 0; d < b; d++)H || (H = E(document.body, "transform") ? "transform" : "-webkit-transform"), g.animatables[d].target.style[H] = c[d].join(" ");
            g.currentTime = a;
            g.progress = a / g.duration * 100;
        }
        function f(a) {
            if (g[a]) g[a](g);
        }
        function e() {
            g.remaining && !0 !== g.remaining && g.remaining--;
        }
        function k(a) {
            var k = g.duration, n = g.offset, w = n + g.delay, r = g.currentTime, x = g.reversed, q = d(a);
            if (g.children.length) {
                var u = g.children, v = u.length;
                if (q >= g.currentTime) for(var G = 0; G < v; G++)u[G].seek(q);
                else for(; v--;)u[v].seek(q);
            }
            if (q >= w || !k) g.began || (g.began = !0, f("begin")), f("run");
            if (q > n && q < k) b(q);
            else if (q <= n && 0 !== r && (b(0), x && e()), q >= k && r !== k || !k) b(k), x || e();
            f("update");
            a >= k && (g.remaining ? (t = h, "alternate" === g.direction && (g.reversed = !g.reversed)) : (g.pause(), g.completed || (g.completed = !0, f("complete"), "Promise" in window && (p(), m = c()))), l = 0);
        }
        a = void 0 === a ? {} : a;
        var h, t, l = 0, p = null, m = c(), g = fa(a);
        g.reset = function() {
            var a = g.direction, c = g.loop;
            g.currentTime = 0;
            g.progress = 0;
            g.paused = !0;
            g.began = !1;
            g.completed = !1;
            g.reversed = "reverse" === a;
            g.remaining = "alternate" === a && 1 === c ? 2 : c;
            b(0);
            for(a = g.children.length; a--;)g.children[a].reset();
        };
        g.tick = function(a) {
            h = a;
            t || (t = h);
            k((l + h - t) * q.speed);
        };
        g.seek = function(a) {
            k(d(a));
        };
        g.pause = function() {
            var a = v.indexOf(g);
            -1 < a && v.splice(a, 1);
            g.paused = !0;
        };
        g.play = function() {
            g.paused && (g.paused = !1, t = 0, l = d(g.currentTime), v.push(g), B || ia());
        };
        g.reverse = function() {
            g.reversed = !g.reversed;
            t = 0;
            l = d(g.currentTime);
        };
        g.restart = function() {
            g.pause();
            g.reset();
            g.play();
        };
        g.finished = m;
        g.reset();
        g.autoplay && g.play();
        return g;
    }
    var ga = {
        update: void 0,
        begin: void 0,
        run: void 0,
        complete: void 0,
        loop: 1,
        direction: "normal",
        autoplay: !0,
        offset: 0
    }, S = {
        duration: 1E3,
        delay: 0,
        easing: "easeOutElastic",
        elasticity: 500,
        round: 0
    }, W = "translateX translateY translateZ rotate rotateX rotateY rotateZ scale scaleX scaleY scaleZ skewX skewY perspective".split(" "), H, h = {
        arr: function(a) {
            return Array.isArray(a);
        },
        obj: function(a) {
            return -1 < Object.prototype.toString.call(a).indexOf("Object");
        },
        pth: function(a) {
            return h.obj(a) && a.hasOwnProperty("totalLength");
        },
        svg: function(a) {
            return a instanceof SVGElement;
        },
        dom: function(a) {
            return a.nodeType || h.svg(a);
        },
        str: function(a) {
            return "string" === typeof a;
        },
        fnc: function(a) {
            return "function" === typeof a;
        },
        und: function(a) {
            return "undefined" === typeof a;
        },
        hex: function(a) {
            return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a);
        },
        rgb: function(a) {
            return /^rgb/.test(a);
        },
        hsl: function(a) {
            return /^hsl/.test(a);
        },
        col: function(a) {
            return h.hex(a) || h.rgb(a) || h.hsl(a);
        }
    }, A = function() {
        function a(a, d, b) {
            return (((1 - 3 * b + 3 * d) * a + (3 * b - 6 * d)) * a + 3 * d) * a;
        }
        return function(c, d, b, f) {
            if (0 <= c && 1 >= c && 0 <= b && 1 >= b) {
                var e = new Float32Array(11);
                if (c !== d || b !== f) for(var k = 0; 11 > k; ++k)e[k] = a(.1 * k, c, b);
                return function(k) {
                    if (c === d && b === f) return k;
                    if (0 === k) return 0;
                    if (1 === k) return 1;
                    for(var h = 0, l = 1; 10 !== l && e[l] <= k; ++l)h += .1;
                    --l;
                    var l = h + (k - e[l]) / (e[l + 1] - e[l]) * .1, n = 3 * (1 - 3 * b + 3 * c) * l * l + 2 * (3 * b - 6 * c) * l + 3 * c;
                    if (.001 <= n) {
                        for(h = 0; 4 > h; ++h){
                            n = 3 * (1 - 3 * b + 3 * c) * l * l + 2 * (3 * b - 6 * c) * l + 3 * c;
                            if (0 === n) break;
                            var m = a(l, c, b) - k, l = l - m / n;
                        }
                        k = l;
                    } else if (0 === n) k = l;
                    else {
                        var l = h, h = h + .1, g = 0;
                        do m = l + (h - l) / 2, n = a(m, c, b) - k, 0 < n ? h = m : l = m;
                        while (1e-7 < Math.abs(n) && 10 > ++g);
                        k = m;
                    }
                    return a(k, d, f);
                };
            }
        };
    }(), Q = function() {
        function a(a, b) {
            return 0 === a || 1 === a ? a : -Math.pow(2, 10 * (a - 1)) * Math.sin(2 * (a - 1 - b / (2 * Math.PI) * Math.asin(1)) * Math.PI / b);
        }
        var c = "Quad Cubic Quart Quint Sine Expo Circ Back Elastic".split(" "), d = {
            In: [
                [
                    .55,
                    .085,
                    .68,
                    .53
                ],
                [
                    .55,
                    .055,
                    .675,
                    .19
                ],
                [
                    .895,
                    .03,
                    .685,
                    .22
                ],
                [
                    .755,
                    .05,
                    .855,
                    .06
                ],
                [
                    .47,
                    0,
                    .745,
                    .715
                ],
                [
                    .95,
                    .05,
                    .795,
                    .035
                ],
                [
                    .6,
                    .04,
                    .98,
                    .335
                ],
                [
                    .6,
                    -0.28,
                    .735,
                    .045
                ],
                a
            ],
            Out: [
                [
                    .25,
                    .46,
                    .45,
                    .94
                ],
                [
                    .215,
                    .61,
                    .355,
                    1
                ],
                [
                    .165,
                    .84,
                    .44,
                    1
                ],
                [
                    .23,
                    1,
                    .32,
                    1
                ],
                [
                    .39,
                    .575,
                    .565,
                    1
                ],
                [
                    .19,
                    1,
                    .22,
                    1
                ],
                [
                    .075,
                    .82,
                    .165,
                    1
                ],
                [
                    .175,
                    .885,
                    .32,
                    1.275
                ],
                function(b, c) {
                    return 1 - a(1 - b, c);
                }
            ],
            InOut: [
                [
                    .455,
                    .03,
                    .515,
                    .955
                ],
                [
                    .645,
                    .045,
                    .355,
                    1
                ],
                [
                    .77,
                    0,
                    .175,
                    1
                ],
                [
                    .86,
                    0,
                    .07,
                    1
                ],
                [
                    .445,
                    .05,
                    .55,
                    .95
                ],
                [
                    1,
                    0,
                    0,
                    1
                ],
                [
                    .785,
                    .135,
                    .15,
                    .86
                ],
                [
                    .68,
                    -0.55,
                    .265,
                    1.55
                ],
                function(b, c) {
                    return .5 > b ? a(2 * b, c) / 2 : 1 - a(-2 * b + 2, c) / 2;
                }
            ]
        }, b = {
            linear: A(.25, .25, .75, .75)
        }, f = {}, e;
        for(e in d)f.type = e, d[f.type].forEach(function(a) {
            return function(d, f) {
                b["ease" + a.type + c[f]] = h.fnc(d) ? d : A.apply($jscomp$this, d);
            };
        }(f)), f = {
            type: f.type
        };
        return b;
    }(), ha = {
        css: function(a, c, d) {
            return a.style[c] = d;
        },
        attribute: function(a, c, d) {
            return a.setAttribute(c, d);
        },
        object: function(a, c, d) {
            return a[c] = d;
        },
        transform: function(a, c, d, b, f) {
            b[f] || (b[f] = []);
            b[f].push(c + "(" + d + ")");
        }
    }, v = [], B = 0, ia = function() {
        function a() {
            B = requestAnimationFrame(c);
        }
        function c(c) {
            var b = v.length;
            if (b) {
                for(var d = 0; d < b;)v[d] && v[d].tick(c), d++;
                a();
            } else cancelAnimationFrame(B), B = 0;
        }
        return a;
    }();
    q.version = "2.2.0";
    q.speed = 1;
    q.running = v;
    q.remove = function(a) {
        a = P(a);
        for(var c = v.length; c--;)for(var d = v[c], b = d.animations, f = b.length; f--;)u(a, b[f].animatable.target) && (b.splice(f, 1), b.length || d.pause());
    };
    q.getValue = K;
    q.path = function(a, c) {
        var d = h.str(a) ? e(a)[0] : a, b = c || 100;
        return function(a) {
            return {
                el: d,
                property: a,
                totalLength: N(d) * (b / 100)
            };
        };
    };
    q.setDashoffset = function(a) {
        var c = N(a);
        a.setAttribute("stroke-dasharray", c);
        return c;
    };
    q.bezier = A;
    q.easings = Q;
    q.timeline = function(a) {
        var c = q(a);
        c.pause();
        c.duration = 0;
        c.add = function(d) {
            c.children.forEach(function(a) {
                a.began = !0;
                a.completed = !0;
            });
            m(d).forEach(function(b) {
                var d = z(b, D(S, a || {}));
                d.targets = d.targets || a.targets;
                b = c.duration;
                var e = d.offset;
                d.autoplay = !1;
                d.direction = c.direction;
                d.offset = h.und(e) ? b : L(e, b);
                c.began = !0;
                c.completed = !0;
                c.seek(d.offset);
                d = q(d);
                d.began = !0;
                d.completed = !0;
                d.duration > b && (c.duration = d.duration);
                c.children.push(d);
            });
            c.seek(0);
            c.reset();
            c.autoplay && c.restart();
            return c;
        };
        return c;
    };
    q.random = function(a, c) {
        return Math.floor(Math.random() * (c - a + 1)) + a;
    };
    return q;
});
(function($1, anim) {
    "use strict";
    var _defaults = {
        accordion: true,
        onOpenStart: undefined,
        onOpenEnd: undefined,
        onCloseStart: undefined,
        onCloseEnd: undefined,
        inDuration: 300,
        outDuration: 300
    };
    /**
   * @class
   *
   */ var Collapsible = function(_Component) {
        _inherits(Collapsible, _Component);
        /**
     * Construct Collapsible instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function Collapsible(el, options) {
            _classCallCheck(this, Collapsible);
            var _this3 = _possibleConstructorReturn(this, (Collapsible.__proto__ || Object.getPrototypeOf(Collapsible)).call(this, Collapsible, el, options));
            _this3.el.M_Collapsible = _this3;
            /**
       * Options for the collapsible
       * @member Collapsible#options
       * @prop {Boolean} [accordion=false] - Type of the collapsible
       * @prop {Function} onOpenStart - Callback function called before collapsible is opened
       * @prop {Function} onOpenEnd - Callback function called after collapsible is opened
       * @prop {Function} onCloseStart - Callback function called before collapsible is closed
       * @prop {Function} onCloseEnd - Callback function called after collapsible is closed
       * @prop {Number} inDuration - Transition in duration in milliseconds.
       * @prop {Number} outDuration - Transition duration in milliseconds.
       */ _this3.options = $1.extend({}, Collapsible.defaults, options);
            // Setup tab indices
            _this3.$headers = _this3.$el.children("li").children(".collapsible-header");
            _this3.$headers.attr("tabindex", 0);
            _this3._setupEventHandlers();
            // Open first active
            var $activeBodies = _this3.$el.children("li.active").children(".collapsible-body");
            if (_this3.options.accordion) // Handle Accordion
            $activeBodies.first().css("display", "block");
            else // Handle Expandables
            $activeBodies.css("display", "block");
            return _this3;
        }
        _createClass(Collapsible, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this._removeEventHandlers();
                    this.el.M_Collapsible = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    var _this4 = this;
                    this._handleCollapsibleClickBound = this._handleCollapsibleClick.bind(this);
                    this._handleCollapsibleKeydownBound = this._handleCollapsibleKeydown.bind(this);
                    this.el.addEventListener("click", this._handleCollapsibleClickBound);
                    this.$headers.each(function(header) {
                        header.addEventListener("keydown", _this4._handleCollapsibleKeydownBound);
                    });
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    var _this5 = this;
                    this.el.removeEventListener("click", this._handleCollapsibleClickBound);
                    this.$headers.each(function(header) {
                        header.removeEventListener("keydown", _this5._handleCollapsibleKeydownBound);
                    });
                }
            },
            {
                key: "_handleCollapsibleClick",
                value: function _handleCollapsibleClick(e) {
                    var $header = $1(e.target).closest(".collapsible-header");
                    if (e.target && $header.length) {
                        var $collapsible = $header.closest(".collapsible");
                        if ($collapsible[0] === this.el) {
                            var $collapsibleLi = $header.closest("li");
                            var $collapsibleLis = $collapsible.children("li");
                            var isActive = $collapsibleLi[0].classList.contains("active");
                            var index = $collapsibleLis.index($collapsibleLi);
                            if (isActive) this.close(index);
                            else this.open(index);
                        }
                    }
                }
            },
            {
                key: "_handleCollapsibleKeydown",
                value: function _handleCollapsibleKeydown(e) {
                    if (e.keyCode === 13) this._handleCollapsibleClickBound(e);
                }
            },
            {
                key: "_animateIn",
                value: function _animateIn(index) {
                    var _this6 = this;
                    var $collapsibleLi = this.$el.children("li").eq(index);
                    if ($collapsibleLi.length) {
                        var $body = $collapsibleLi.children(".collapsible-body");
                        anim.remove($body[0]);
                        $body.css({
                            display: "block",
                            overflow: "hidden",
                            height: 0,
                            paddingTop: "",
                            paddingBottom: ""
                        });
                        var pTop = $body.css("padding-top");
                        var pBottom = $body.css("padding-bottom");
                        var finalHeight = $body[0].scrollHeight;
                        $body.css({
                            paddingTop: 0,
                            paddingBottom: 0
                        });
                        anim({
                            targets: $body[0],
                            height: finalHeight,
                            paddingTop: pTop,
                            paddingBottom: pBottom,
                            duration: this.options.inDuration,
                            easing: "easeInOutCubic",
                            complete: function(anim) {
                                $body.css({
                                    overflow: "",
                                    paddingTop: "",
                                    paddingBottom: "",
                                    height: ""
                                });
                                // onOpenEnd callback
                                if (typeof _this6.options.onOpenEnd === "function") _this6.options.onOpenEnd.call(_this6, $collapsibleLi[0]);
                            }
                        });
                    }
                }
            },
            {
                key: "_animateOut",
                value: function _animateOut(index) {
                    var _this7 = this;
                    var $collapsibleLi = this.$el.children("li").eq(index);
                    if ($collapsibleLi.length) {
                        var $body = $collapsibleLi.children(".collapsible-body");
                        anim.remove($body[0]);
                        $body.css("overflow", "hidden");
                        anim({
                            targets: $body[0],
                            height: 0,
                            paddingTop: 0,
                            paddingBottom: 0,
                            duration: this.options.outDuration,
                            easing: "easeInOutCubic",
                            complete: function() {
                                $body.css({
                                    height: "",
                                    overflow: "",
                                    padding: "",
                                    display: ""
                                });
                                // onCloseEnd callback
                                if (typeof _this7.options.onCloseEnd === "function") _this7.options.onCloseEnd.call(_this7, $collapsibleLi[0]);
                            }
                        });
                    }
                }
            },
            {
                key: "open",
                value: function open(index) {
                    var _this8 = this;
                    var $collapsibleLi = this.$el.children("li").eq(index);
                    if ($collapsibleLi.length && !$collapsibleLi[0].classList.contains("active")) {
                        // onOpenStart callback
                        if (typeof this.options.onOpenStart === "function") this.options.onOpenStart.call(this, $collapsibleLi[0]);
                        // Handle accordion behavior
                        if (this.options.accordion) {
                            var $collapsibleLis = this.$el.children("li");
                            var $activeLis = this.$el.children("li.active");
                            $activeLis.each(function(el) {
                                var index = $collapsibleLis.index($1(el));
                                _this8.close(index);
                            });
                        }
                        // Animate in
                        $collapsibleLi[0].classList.add("active");
                        this._animateIn(index);
                    }
                }
            },
            {
                key: "close",
                value: function close(index) {
                    var $collapsibleLi = this.$el.children("li").eq(index);
                    if ($collapsibleLi.length && $collapsibleLi[0].classList.contains("active")) {
                        // onCloseStart callback
                        if (typeof this.options.onCloseStart === "function") this.options.onCloseStart.call(this, $collapsibleLi[0]);
                        // Animate out
                        $collapsibleLi[0].classList.remove("active");
                        this._animateOut(index);
                    }
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Collapsible.__proto__ || Object.getPrototypeOf(Collapsible), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Collapsible;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Collapsible;
    }(Component);
    M.Collapsible = Collapsible;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Collapsible, "collapsible", "M_Collapsible");
})(cash, M.anime);
(function($1, anim) {
    "use strict";
    var _defaults = {
        alignment: "left",
        autoFocus: true,
        constrainWidth: true,
        container: null,
        coverTrigger: true,
        closeOnClick: true,
        hover: false,
        inDuration: 150,
        outDuration: 250,
        onOpenStart: null,
        onOpenEnd: null,
        onCloseStart: null,
        onCloseEnd: null,
        onItemClick: null
    };
    /**
   * @class
   */ var Dropdown = function(_Component2) {
        _inherits(Dropdown, _Component2);
        function Dropdown(el, options) {
            _classCallCheck(this, Dropdown);
            var _this9 = _possibleConstructorReturn(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, Dropdown, el, options));
            _this9.el.M_Dropdown = _this9;
            Dropdown._dropdowns.push(_this9);
            _this9.id = M.getIdFromTrigger(el);
            _this9.dropdownEl = document.getElementById(_this9.id);
            _this9.$dropdownEl = $1(_this9.dropdownEl);
            /**
       * Options for the dropdown
       * @member Dropdown#options
       * @prop {String} [alignment='left'] - Edge which the dropdown is aligned to
       * @prop {Boolean} [autoFocus=true] - Automatically focus dropdown el for keyboard
       * @prop {Boolean} [constrainWidth=true] - Constrain width to width of the button
       * @prop {Element} container - Container element to attach dropdown to (optional)
       * @prop {Boolean} [coverTrigger=true] - Place dropdown over trigger
       * @prop {Boolean} [closeOnClick=true] - Close on click of dropdown item
       * @prop {Boolean} [hover=false] - Open dropdown on hover
       * @prop {Number} [inDuration=150] - Duration of open animation in ms
       * @prop {Number} [outDuration=250] - Duration of close animation in ms
       * @prop {Function} onOpenStart - Function called when dropdown starts opening
       * @prop {Function} onOpenEnd - Function called when dropdown finishes opening
       * @prop {Function} onCloseStart - Function called when dropdown starts closing
       * @prop {Function} onCloseEnd - Function called when dropdown finishes closing
       */ _this9.options = $1.extend({}, Dropdown.defaults, options);
            /**
       * Describes open/close state of dropdown
       * @type {Boolean}
       */ _this9.isOpen = false;
            /**
       * Describes if dropdown content is scrollable
       * @type {Boolean}
       */ _this9.isScrollable = false;
            /**
       * Describes if touch moving on dropdown content
       * @type {Boolean}
       */ _this9.isTouchMoving = false;
            _this9.focusedIndex = -1;
            _this9.filterQuery = [];
            // Move dropdown-content after dropdown-trigger
            if (!!_this9.options.container) $1(_this9.options.container).append(_this9.dropdownEl);
            else _this9.$el.after(_this9.dropdownEl);
            _this9._makeDropdownFocusable();
            _this9._resetFilterQueryBound = _this9._resetFilterQuery.bind(_this9);
            _this9._handleDocumentClickBound = _this9._handleDocumentClick.bind(_this9);
            _this9._handleDocumentTouchmoveBound = _this9._handleDocumentTouchmove.bind(_this9);
            _this9._handleDropdownClickBound = _this9._handleDropdownClick.bind(_this9);
            _this9._handleDropdownKeydownBound = _this9._handleDropdownKeydown.bind(_this9);
            _this9._handleTriggerKeydownBound = _this9._handleTriggerKeydown.bind(_this9);
            _this9._setupEventHandlers();
            return _this9;
        }
        _createClass(Dropdown, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this._resetDropdownStyles();
                    this._removeEventHandlers();
                    Dropdown._dropdowns.splice(Dropdown._dropdowns.indexOf(this), 1);
                    this.el.M_Dropdown = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    // Trigger keydown handler
                    this.el.addEventListener("keydown", this._handleTriggerKeydownBound);
                    // Item click handler
                    this.dropdownEl.addEventListener("click", this._handleDropdownClickBound);
                    // Hover event handlers
                    if (this.options.hover) {
                        this._handleMouseEnterBound = this._handleMouseEnter.bind(this);
                        this.el.addEventListener("mouseenter", this._handleMouseEnterBound);
                        this._handleMouseLeaveBound = this._handleMouseLeave.bind(this);
                        this.el.addEventListener("mouseleave", this._handleMouseLeaveBound);
                        this.dropdownEl.addEventListener("mouseleave", this._handleMouseLeaveBound);
                    // Click event handlers
                    } else {
                        this._handleClickBound = this._handleClick.bind(this);
                        this.el.addEventListener("click", this._handleClickBound);
                    }
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    this.el.removeEventListener("keydown", this._handleTriggerKeydownBound);
                    this.dropdownEl.removeEventListener("click", this._handleDropdownClickBound);
                    if (this.options.hover) {
                        this.el.removeEventListener("mouseenter", this._handleMouseEnterBound);
                        this.el.removeEventListener("mouseleave", this._handleMouseLeaveBound);
                        this.dropdownEl.removeEventListener("mouseleave", this._handleMouseLeaveBound);
                    } else this.el.removeEventListener("click", this._handleClickBound);
                }
            },
            {
                key: "_setupTemporaryEventHandlers",
                value: function _setupTemporaryEventHandlers() {
                    // Use capture phase event handler to prevent click
                    document.body.addEventListener("click", this._handleDocumentClickBound, true);
                    document.body.addEventListener("touchend", this._handleDocumentClickBound);
                    document.body.addEventListener("touchmove", this._handleDocumentTouchmoveBound);
                    this.dropdownEl.addEventListener("keydown", this._handleDropdownKeydownBound);
                }
            },
            {
                key: "_removeTemporaryEventHandlers",
                value: function _removeTemporaryEventHandlers() {
                    // Use capture phase event handler to prevent click
                    document.body.removeEventListener("click", this._handleDocumentClickBound, true);
                    document.body.removeEventListener("touchend", this._handleDocumentClickBound);
                    document.body.removeEventListener("touchmove", this._handleDocumentTouchmoveBound);
                    this.dropdownEl.removeEventListener("keydown", this._handleDropdownKeydownBound);
                }
            },
            {
                key: "_handleClick",
                value: function _handleClick(e) {
                    e.preventDefault();
                    this.open();
                }
            },
            {
                key: "_handleMouseEnter",
                value: function _handleMouseEnter() {
                    this.open();
                }
            },
            {
                key: "_handleMouseLeave",
                value: function _handleMouseLeave(e) {
                    var toEl = e.toElement || e.relatedTarget;
                    var leaveToDropdownContent = !!$1(toEl).closest(".dropdown-content").length;
                    var leaveToActiveDropdownTrigger = false;
                    var $closestTrigger = $1(toEl).closest(".dropdown-trigger");
                    if ($closestTrigger.length && !!$closestTrigger[0].M_Dropdown && $closestTrigger[0].M_Dropdown.isOpen) leaveToActiveDropdownTrigger = true;
                    // Close hover dropdown if mouse did not leave to either active dropdown-trigger or dropdown-content
                    if (!leaveToActiveDropdownTrigger && !leaveToDropdownContent) this.close();
                }
            },
            {
                key: "_handleDocumentClick",
                value: function _handleDocumentClick(e) {
                    var _this10 = this;
                    var $target = $1(e.target);
                    if (this.options.closeOnClick && $target.closest(".dropdown-content").length && !this.isTouchMoving) // isTouchMoving to check if scrolling on mobile.
                    setTimeout(function() {
                        _this10.close();
                    }, 0);
                    else if ($target.closest(".dropdown-trigger").length || !$target.closest(".dropdown-content").length) setTimeout(function() {
                        _this10.close();
                    }, 0);
                    this.isTouchMoving = false;
                }
            },
            {
                key: "_handleTriggerKeydown",
                value: function _handleTriggerKeydown(e) {
                    // ARROW DOWN OR ENTER WHEN SELECT IS CLOSED - open Dropdown
                    if ((e.which === M.keys.ARROW_DOWN || e.which === M.keys.ENTER) && !this.isOpen) {
                        e.preventDefault();
                        this.open();
                    }
                }
            },
            {
                key: "_handleDocumentTouchmove",
                value: function _handleDocumentTouchmove(e) {
                    var $target = $1(e.target);
                    if ($target.closest(".dropdown-content").length) this.isTouchMoving = true;
                }
            },
            {
                key: "_handleDropdownClick",
                value: function _handleDropdownClick(e) {
                    // onItemClick callback
                    if (typeof this.options.onItemClick === "function") {
                        var itemEl = $1(e.target).closest("li")[0];
                        this.options.onItemClick.call(this, itemEl);
                    }
                }
            },
            {
                key: "_handleDropdownKeydown",
                value: function _handleDropdownKeydown(e) {
                    if (e.which === M.keys.TAB) {
                        e.preventDefault();
                        this.close();
                    // Navigate down dropdown list
                    } else if ((e.which === M.keys.ARROW_DOWN || e.which === M.keys.ARROW_UP) && this.isOpen) {
                        e.preventDefault();
                        var direction = e.which === M.keys.ARROW_DOWN ? 1 : -1;
                        var newFocusedIndex = this.focusedIndex;
                        var foundNewIndex = false;
                        do {
                            newFocusedIndex = newFocusedIndex + direction;
                            if (!!this.dropdownEl.children[newFocusedIndex] && this.dropdownEl.children[newFocusedIndex].tabIndex !== -1) {
                                foundNewIndex = true;
                                break;
                            }
                        }while (newFocusedIndex < this.dropdownEl.children.length && newFocusedIndex >= 0);
                        if (foundNewIndex) {
                            this.focusedIndex = newFocusedIndex;
                            this._focusFocusedItem();
                        }
                    // ENTER selects choice on focused item
                    } else if (e.which === M.keys.ENTER && this.isOpen) {
                        // Search for <a> and <button>
                        var focusedElement = this.dropdownEl.children[this.focusedIndex];
                        var $activatableElement = $1(focusedElement).find("a, button").first();
                        // Click a or button tag if exists, otherwise click li tag
                        if (!!$activatableElement.length) $activatableElement[0].click();
                        else if (!!focusedElement) focusedElement.click();
                    // Close dropdown on ESC
                    } else if (e.which === M.keys.ESC && this.isOpen) {
                        e.preventDefault();
                        this.close();
                    }
                    // CASE WHEN USER TYPE LETTERS
                    var letter = String.fromCharCode(e.which).toLowerCase(), nonLetters = [
                        9,
                        13,
                        27,
                        38,
                        40
                    ];
                    if (letter && nonLetters.indexOf(e.which) === -1) {
                        this.filterQuery.push(letter);
                        var string = this.filterQuery.join(""), newOptionEl = $1(this.dropdownEl).find("li").filter(function(el) {
                            return $1(el).text().toLowerCase().indexOf(string) === 0;
                        })[0];
                        if (newOptionEl) {
                            this.focusedIndex = $1(newOptionEl).index();
                            this._focusFocusedItem();
                        }
                    }
                    this.filterTimeout = setTimeout(this._resetFilterQueryBound, 1000);
                }
            },
            {
                key: "_resetFilterQuery",
                value: function _resetFilterQuery() {
                    this.filterQuery = [];
                }
            },
            {
                key: "_resetDropdownStyles",
                value: function _resetDropdownStyles() {
                    this.$dropdownEl.css({
                        display: "",
                        width: "",
                        height: "",
                        left: "",
                        top: "",
                        "transform-origin": "",
                        transform: "",
                        opacity: ""
                    });
                }
            },
            {
                key: "_makeDropdownFocusable",
                value: function _makeDropdownFocusable() {
                    // Needed for arrow key navigation
                    this.dropdownEl.tabIndex = 0;
                    // Only set tabindex if it hasn't been set by user
                    $1(this.dropdownEl).children().each(function(el) {
                        if (!el.getAttribute("tabindex")) el.setAttribute("tabindex", 0);
                    });
                }
            },
            {
                key: "_focusFocusedItem",
                value: function _focusFocusedItem() {
                    if (this.focusedIndex >= 0 && this.focusedIndex < this.dropdownEl.children.length && this.options.autoFocus) this.dropdownEl.children[this.focusedIndex].focus();
                }
            },
            {
                key: "_getDropdownPosition",
                value: function _getDropdownPosition() {
                    var offsetParentBRect = this.el.offsetParent.getBoundingClientRect();
                    var triggerBRect = this.el.getBoundingClientRect();
                    var dropdownBRect = this.dropdownEl.getBoundingClientRect();
                    var idealHeight = dropdownBRect.height;
                    var idealWidth = dropdownBRect.width;
                    var idealXPos = triggerBRect.left - dropdownBRect.left;
                    var idealYPos = triggerBRect.top - dropdownBRect.top;
                    var dropdownBounds = {
                        left: idealXPos,
                        top: idealYPos,
                        height: idealHeight,
                        width: idealWidth
                    };
                    // Countainer here will be closest ancestor with overflow: hidden
                    var closestOverflowParent = !!this.dropdownEl.offsetParent ? this.dropdownEl.offsetParent : this.dropdownEl.parentNode;
                    var alignments = M.checkPossibleAlignments(this.el, closestOverflowParent, dropdownBounds, this.options.coverTrigger ? 0 : triggerBRect.height);
                    var verticalAlignment = "top";
                    var horizontalAlignment = this.options.alignment;
                    idealYPos += this.options.coverTrigger ? 0 : triggerBRect.height;
                    // Reset isScrollable
                    this.isScrollable = false;
                    if (!alignments.top) {
                        if (alignments.bottom) verticalAlignment = "bottom";
                        else {
                            this.isScrollable = true;
                            // Determine which side has most space and cutoff at correct height
                            if (alignments.spaceOnTop > alignments.spaceOnBottom) {
                                verticalAlignment = "bottom";
                                idealHeight += alignments.spaceOnTop;
                                idealYPos -= alignments.spaceOnTop;
                            } else idealHeight += alignments.spaceOnBottom;
                        }
                    }
                    // If preferred horizontal alignment is possible
                    if (!alignments[horizontalAlignment]) {
                        var oppositeAlignment = horizontalAlignment === "left" ? "right" : "left";
                        if (alignments[oppositeAlignment]) horizontalAlignment = oppositeAlignment;
                        else // Determine which side has most space and cutoff at correct height
                        if (alignments.spaceOnLeft > alignments.spaceOnRight) {
                            horizontalAlignment = "right";
                            idealWidth += alignments.spaceOnLeft;
                            idealXPos -= alignments.spaceOnLeft;
                        } else {
                            horizontalAlignment = "left";
                            idealWidth += alignments.spaceOnRight;
                        }
                    }
                    if (verticalAlignment === "bottom") idealYPos = idealYPos - dropdownBRect.height + (this.options.coverTrigger ? triggerBRect.height : 0);
                    if (horizontalAlignment === "right") idealXPos = idealXPos - dropdownBRect.width + triggerBRect.width;
                    return {
                        x: idealXPos,
                        y: idealYPos,
                        verticalAlignment: verticalAlignment,
                        horizontalAlignment: horizontalAlignment,
                        height: idealHeight,
                        width: idealWidth
                    };
                }
            },
            {
                key: "_animateIn",
                value: function _animateIn() {
                    var _this11 = this;
                    anim.remove(this.dropdownEl);
                    anim({
                        targets: this.dropdownEl,
                        opacity: {
                            value: [
                                0,
                                1
                            ],
                            easing: "easeOutQuad"
                        },
                        scaleX: [
                            0.3,
                            1
                        ],
                        scaleY: [
                            0.3,
                            1
                        ],
                        duration: this.options.inDuration,
                        easing: "easeOutQuint",
                        complete: function(anim) {
                            if (_this11.options.autoFocus) _this11.dropdownEl.focus();
                            // onOpenEnd callback
                            if (typeof _this11.options.onOpenEnd === "function") _this11.options.onOpenEnd.call(_this11, _this11.el);
                        }
                    });
                }
            },
            {
                key: "_animateOut",
                value: function _animateOut() {
                    var _this12 = this;
                    anim.remove(this.dropdownEl);
                    anim({
                        targets: this.dropdownEl,
                        opacity: {
                            value: 0,
                            easing: "easeOutQuint"
                        },
                        scaleX: 0.3,
                        scaleY: 0.3,
                        duration: this.options.outDuration,
                        easing: "easeOutQuint",
                        complete: function(anim) {
                            _this12._resetDropdownStyles();
                            // onCloseEnd callback
                            if (typeof _this12.options.onCloseEnd === "function") _this12.options.onCloseEnd.call(_this12, _this12.el);
                        }
                    });
                }
            },
            {
                key: "_placeDropdown",
                value: function _placeDropdown() {
                    // Set width before calculating positionInfo
                    var idealWidth = this.options.constrainWidth ? this.el.getBoundingClientRect().width : this.dropdownEl.getBoundingClientRect().width;
                    this.dropdownEl.style.width = idealWidth + "px";
                    var positionInfo = this._getDropdownPosition();
                    this.dropdownEl.style.left = positionInfo.x + "px";
                    this.dropdownEl.style.top = positionInfo.y + "px";
                    this.dropdownEl.style.height = positionInfo.height + "px";
                    this.dropdownEl.style.width = positionInfo.width + "px";
                    this.dropdownEl.style.transformOrigin = (positionInfo.horizontalAlignment === "left" ? "0" : "100%") + " " + (positionInfo.verticalAlignment === "top" ? "0" : "100%");
                }
            },
            {
                key: "open",
                value: function open() {
                    if (this.isOpen) return;
                    this.isOpen = true;
                    // onOpenStart callback
                    if (typeof this.options.onOpenStart === "function") this.options.onOpenStart.call(this, this.el);
                    // Reset styles
                    this._resetDropdownStyles();
                    this.dropdownEl.style.display = "block";
                    this._placeDropdown();
                    this._animateIn();
                    this._setupTemporaryEventHandlers();
                }
            },
            {
                key: "close",
                value: function close() {
                    if (!this.isOpen) return;
                    this.isOpen = false;
                    this.focusedIndex = -1;
                    // onCloseStart callback
                    if (typeof this.options.onCloseStart === "function") this.options.onCloseStart.call(this, this.el);
                    this._animateOut();
                    this._removeTemporaryEventHandlers();
                    if (this.options.autoFocus) this.el.focus();
                }
            },
            {
                key: "recalculateDimensions",
                value: function recalculateDimensions() {
                    if (this.isOpen) {
                        this.$dropdownEl.css({
                            width: "",
                            height: "",
                            left: "",
                            top: "",
                            "transform-origin": ""
                        });
                        this._placeDropdown();
                    }
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Dropdown.__proto__ || Object.getPrototypeOf(Dropdown), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Dropdown;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Dropdown;
    }(Component);
    /**
   * @static
   * @memberof Dropdown
   */ Dropdown._dropdowns = [];
    M.Dropdown = Dropdown;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Dropdown, "dropdown", "M_Dropdown");
})(cash, M.anime);
(function($1, anim) {
    "use strict";
    var _defaults = {
        opacity: 0.5,
        inDuration: 250,
        outDuration: 250,
        onOpenStart: null,
        onOpenEnd: null,
        onCloseStart: null,
        onCloseEnd: null,
        preventScrolling: true,
        dismissible: true,
        startingTop: "4%",
        endingTop: "10%"
    };
    /**
   * @class
   *
   */ var Modal = function(_Component3) {
        _inherits(Modal, _Component3);
        /**
     * Construct Modal instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function Modal(el, options) {
            _classCallCheck(this, Modal);
            var _this13 = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, Modal, el, options));
            _this13.el.M_Modal = _this13;
            /**
       * Options for the modal
       * @member Modal#options
       * @prop {Number} [opacity=0.5] - Opacity of the modal overlay
       * @prop {Number} [inDuration=250] - Length in ms of enter transition
       * @prop {Number} [outDuration=250] - Length in ms of exit transition
       * @prop {Function} onOpenStart - Callback function called before modal is opened
       * @prop {Function} onOpenEnd - Callback function called after modal is opened
       * @prop {Function} onCloseStart - Callback function called before modal is closed
       * @prop {Function} onCloseEnd - Callback function called after modal is closed
       * @prop {Boolean} [dismissible=true] - Allow modal to be dismissed by keyboard or overlay click
       * @prop {String} [startingTop='4%'] - startingTop
       * @prop {String} [endingTop='10%'] - endingTop
       */ _this13.options = $1.extend({}, Modal.defaults, options);
            /**
       * Describes open/close state of modal
       * @type {Boolean}
       */ _this13.isOpen = false;
            _this13.id = _this13.$el.attr("id");
            _this13._openingTrigger = undefined;
            _this13.$overlay = $1('<div class="modal-overlay"></div>');
            _this13.el.tabIndex = 0;
            _this13._nthModalOpened = 0;
            Modal._count++;
            _this13._setupEventHandlers();
            return _this13;
        }
        _createClass(Modal, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    Modal._count--;
                    this._removeEventHandlers();
                    this.el.removeAttribute("style");
                    this.$overlay.remove();
                    this.el.M_Modal = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    this._handleOverlayClickBound = this._handleOverlayClick.bind(this);
                    this._handleModalCloseClickBound = this._handleModalCloseClick.bind(this);
                    if (Modal._count === 1) document.body.addEventListener("click", this._handleTriggerClick);
                    this.$overlay[0].addEventListener("click", this._handleOverlayClickBound);
                    this.el.addEventListener("click", this._handleModalCloseClickBound);
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    if (Modal._count === 0) document.body.removeEventListener("click", this._handleTriggerClick);
                    this.$overlay[0].removeEventListener("click", this._handleOverlayClickBound);
                    this.el.removeEventListener("click", this._handleModalCloseClickBound);
                }
            },
            {
                key: "_handleTriggerClick",
                value: function _handleTriggerClick(e) {
                    var $trigger = $1(e.target).closest(".modal-trigger");
                    if ($trigger.length) {
                        var modalId = M.getIdFromTrigger($trigger[0]);
                        var modalInstance = document.getElementById(modalId).M_Modal;
                        if (modalInstance) modalInstance.open($trigger);
                        e.preventDefault();
                    }
                }
            },
            {
                key: "_handleOverlayClick",
                value: function _handleOverlayClick() {
                    if (this.options.dismissible) this.close();
                }
            },
            {
                key: "_handleModalCloseClick",
                value: function _handleModalCloseClick(e) {
                    var $closeTrigger = $1(e.target).closest(".modal-close");
                    if ($closeTrigger.length) this.close();
                }
            },
            {
                key: "_handleKeydown",
                value: function _handleKeydown(e) {
                    // ESC key
                    if (e.keyCode === 27 && this.options.dismissible) this.close();
                }
            },
            {
                key: "_handleFocus",
                value: function _handleFocus(e) {
                    // Only trap focus if this modal is the last model opened (prevents loops in nested modals).
                    if (!this.el.contains(e.target) && this._nthModalOpened === Modal._modalsOpen) this.el.focus();
                }
            },
            {
                key: "_animateIn",
                value: function _animateIn() {
                    var _this14 = this;
                    // Set initial styles
                    $1.extend(this.el.style, {
                        display: "block",
                        opacity: 0
                    });
                    $1.extend(this.$overlay[0].style, {
                        display: "block",
                        opacity: 0
                    });
                    // Animate overlay
                    anim({
                        targets: this.$overlay[0],
                        opacity: this.options.opacity,
                        duration: this.options.inDuration,
                        easing: "easeOutQuad"
                    });
                    // Define modal animation options
                    var enterAnimOptions = {
                        targets: this.el,
                        duration: this.options.inDuration,
                        easing: "easeOutCubic",
                        // Handle modal onOpenEnd callback
                        complete: function() {
                            if (typeof _this14.options.onOpenEnd === "function") _this14.options.onOpenEnd.call(_this14, _this14.el, _this14._openingTrigger);
                        }
                    };
                    // Bottom sheet animation
                    if (this.el.classList.contains("bottom-sheet")) {
                        $1.extend(enterAnimOptions, {
                            bottom: 0,
                            opacity: 1
                        });
                        anim(enterAnimOptions);
                    // Normal modal animation
                    } else {
                        $1.extend(enterAnimOptions, {
                            top: [
                                this.options.startingTop,
                                this.options.endingTop
                            ],
                            opacity: 1,
                            scaleX: [
                                0.8,
                                1
                            ],
                            scaleY: [
                                0.8,
                                1
                            ]
                        });
                        anim(enterAnimOptions);
                    }
                }
            },
            {
                key: "_animateOut",
                value: function _animateOut() {
                    var _this15 = this;
                    // Animate overlay
                    anim({
                        targets: this.$overlay[0],
                        opacity: 0,
                        duration: this.options.outDuration,
                        easing: "easeOutQuart"
                    });
                    // Define modal animation options
                    var exitAnimOptions = {
                        targets: this.el,
                        duration: this.options.outDuration,
                        easing: "easeOutCubic",
                        // Handle modal ready callback
                        complete: function() {
                            _this15.el.style.display = "none";
                            _this15.$overlay.remove();
                            // Call onCloseEnd callback
                            if (typeof _this15.options.onCloseEnd === "function") _this15.options.onCloseEnd.call(_this15, _this15.el);
                        }
                    };
                    // Bottom sheet animation
                    if (this.el.classList.contains("bottom-sheet")) {
                        $1.extend(exitAnimOptions, {
                            bottom: "-100%",
                            opacity: 0
                        });
                        anim(exitAnimOptions);
                    // Normal modal animation
                    } else {
                        $1.extend(exitAnimOptions, {
                            top: [
                                this.options.endingTop,
                                this.options.startingTop
                            ],
                            opacity: 0,
                            scaleX: 0.8,
                            scaleY: 0.8
                        });
                        anim(exitAnimOptions);
                    }
                }
            },
            {
                key: "open",
                value: function open($trigger) {
                    if (this.isOpen) return;
                    this.isOpen = true;
                    Modal._modalsOpen++;
                    this._nthModalOpened = Modal._modalsOpen;
                    // Set Z-Index based on number of currently open modals
                    this.$overlay[0].style.zIndex = 1000 + Modal._modalsOpen * 2;
                    this.el.style.zIndex = 1000 + Modal._modalsOpen * 2 + 1;
                    // Set opening trigger, undefined indicates modal was opened by javascript
                    this._openingTrigger = !!$trigger ? $trigger[0] : undefined;
                    // onOpenStart callback
                    if (typeof this.options.onOpenStart === "function") this.options.onOpenStart.call(this, this.el, this._openingTrigger);
                    if (this.options.preventScrolling) document.body.style.overflow = "hidden";
                    this.el.classList.add("open");
                    this.el.insertAdjacentElement("afterend", this.$overlay[0]);
                    if (this.options.dismissible) {
                        this._handleKeydownBound = this._handleKeydown.bind(this);
                        this._handleFocusBound = this._handleFocus.bind(this);
                        document.addEventListener("keydown", this._handleKeydownBound);
                        document.addEventListener("focus", this._handleFocusBound, true);
                    }
                    anim.remove(this.el);
                    anim.remove(this.$overlay[0]);
                    this._animateIn();
                    // Focus modal
                    this.el.focus();
                    return this;
                }
            },
            {
                key: "close",
                value: function close() {
                    if (!this.isOpen) return;
                    this.isOpen = false;
                    Modal._modalsOpen--;
                    this._nthModalOpened = 0;
                    // Call onCloseStart callback
                    if (typeof this.options.onCloseStart === "function") this.options.onCloseStart.call(this, this.el);
                    this.el.classList.remove("open");
                    // Enable body scrolling only if there are no more modals open.
                    if (Modal._modalsOpen === 0) document.body.style.overflow = "";
                    if (this.options.dismissible) {
                        document.removeEventListener("keydown", this._handleKeydownBound);
                        document.removeEventListener("focus", this._handleFocusBound, true);
                    }
                    anim.remove(this.el);
                    anim.remove(this.$overlay[0]);
                    this._animateOut();
                    return this;
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Modal.__proto__ || Object.getPrototypeOf(Modal), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Modal;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Modal;
    }(Component);
    /**
   * @static
   * @memberof Modal
   */ Modal._modalsOpen = 0;
    /**
   * @static
   * @memberof Modal
   */ Modal._count = 0;
    M.Modal = Modal;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Modal, "modal", "M_Modal");
})(cash, M.anime);
(function($1, anim) {
    "use strict";
    var _defaults = {
        inDuration: 275,
        outDuration: 200,
        onOpenStart: null,
        onOpenEnd: null,
        onCloseStart: null,
        onCloseEnd: null
    };
    /**
   * @class
   *
   */ var Materialbox = function(_Component4) {
        _inherits(Materialbox, _Component4);
        /**
     * Construct Materialbox instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function Materialbox(el, options) {
            _classCallCheck(this, Materialbox);
            var _this16 = _possibleConstructorReturn(this, (Materialbox.__proto__ || Object.getPrototypeOf(Materialbox)).call(this, Materialbox, el, options));
            _this16.el.M_Materialbox = _this16;
            /**
       * Options for the modal
       * @member Materialbox#options
       * @prop {Number} [inDuration=275] - Length in ms of enter transition
       * @prop {Number} [outDuration=200] - Length in ms of exit transition
       * @prop {Function} onOpenStart - Callback function called before materialbox is opened
       * @prop {Function} onOpenEnd - Callback function called after materialbox is opened
       * @prop {Function} onCloseStart - Callback function called before materialbox is closed
       * @prop {Function} onCloseEnd - Callback function called after materialbox is closed
       */ _this16.options = $1.extend({}, Materialbox.defaults, options);
            _this16.overlayActive = false;
            _this16.doneAnimating = true;
            _this16.placeholder = $1("<div></div>").addClass("material-placeholder");
            _this16.originalWidth = 0;
            _this16.originalHeight = 0;
            _this16.originInlineStyles = _this16.$el.attr("style");
            _this16.caption = _this16.el.getAttribute("data-caption") || "";
            // Wrap
            _this16.$el.before(_this16.placeholder);
            _this16.placeholder.append(_this16.$el);
            _this16._setupEventHandlers();
            return _this16;
        }
        _createClass(Materialbox, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this._removeEventHandlers();
                    this.el.M_Materialbox = undefined;
                    // Unwrap image
                    $1(this.placeholder).after(this.el).remove();
                    this.$el.removeAttr("style");
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    this._handleMaterialboxClickBound = this._handleMaterialboxClick.bind(this);
                    this.el.addEventListener("click", this._handleMaterialboxClickBound);
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    this.el.removeEventListener("click", this._handleMaterialboxClickBound);
                }
            },
            {
                key: "_handleMaterialboxClick",
                value: function _handleMaterialboxClick(e) {
                    // If already modal, return to original
                    if (this.doneAnimating === false || this.overlayActive && this.doneAnimating) this.close();
                    else this.open();
                }
            },
            {
                key: "_handleWindowScroll",
                value: function _handleWindowScroll() {
                    if (this.overlayActive) this.close();
                }
            },
            {
                key: "_handleWindowResize",
                value: function _handleWindowResize() {
                    if (this.overlayActive) this.close();
                }
            },
            {
                key: "_handleWindowEscape",
                value: function _handleWindowEscape(e) {
                    // ESC key
                    if (e.keyCode === 27 && this.doneAnimating && this.overlayActive) this.close();
                }
            },
            {
                key: "_makeAncestorsOverflowVisible",
                value: function _makeAncestorsOverflowVisible() {
                    this.ancestorsChanged = $1();
                    var ancestor = this.placeholder[0].parentNode;
                    while(ancestor !== null && !$1(ancestor).is(document)){
                        var curr = $1(ancestor);
                        if (curr.css("overflow") !== "visible") {
                            curr.css("overflow", "visible");
                            if (this.ancestorsChanged === undefined) this.ancestorsChanged = curr;
                            else this.ancestorsChanged = this.ancestorsChanged.add(curr);
                        }
                        ancestor = ancestor.parentNode;
                    }
                }
            },
            {
                key: "_animateImageIn",
                value: function _animateImageIn() {
                    var _this17 = this;
                    var animOptions = {
                        targets: this.el,
                        height: [
                            this.originalHeight,
                            this.newHeight
                        ],
                        width: [
                            this.originalWidth,
                            this.newWidth
                        ],
                        left: M.getDocumentScrollLeft() + this.windowWidth / 2 - this.placeholder.offset().left - this.newWidth / 2,
                        top: M.getDocumentScrollTop() + this.windowHeight / 2 - this.placeholder.offset().top - this.newHeight / 2,
                        duration: this.options.inDuration,
                        easing: "easeOutQuad",
                        complete: function() {
                            _this17.doneAnimating = true;
                            // onOpenEnd callback
                            if (typeof _this17.options.onOpenEnd === "function") _this17.options.onOpenEnd.call(_this17, _this17.el);
                        }
                    };
                    // Override max-width or max-height if needed
                    this.maxWidth = this.$el.css("max-width");
                    this.maxHeight = this.$el.css("max-height");
                    if (this.maxWidth !== "none") animOptions.maxWidth = this.newWidth;
                    if (this.maxHeight !== "none") animOptions.maxHeight = this.newHeight;
                    anim(animOptions);
                }
            },
            {
                key: "_animateImageOut",
                value: function _animateImageOut() {
                    var _this18 = this;
                    var animOptions = {
                        targets: this.el,
                        width: this.originalWidth,
                        height: this.originalHeight,
                        left: 0,
                        top: 0,
                        duration: this.options.outDuration,
                        easing: "easeOutQuad",
                        complete: function() {
                            _this18.placeholder.css({
                                height: "",
                                width: "",
                                position: "",
                                top: "",
                                left: ""
                            });
                            // Revert to width or height attribute
                            if (_this18.attrWidth) _this18.$el.attr("width", _this18.attrWidth);
                            if (_this18.attrHeight) _this18.$el.attr("height", _this18.attrHeight);
                            _this18.$el.removeAttr("style");
                            _this18.originInlineStyles && _this18.$el.attr("style", _this18.originInlineStyles);
                            // Remove class
                            _this18.$el.removeClass("active");
                            _this18.doneAnimating = true;
                            // Remove overflow overrides on ancestors
                            if (_this18.ancestorsChanged.length) _this18.ancestorsChanged.css("overflow", "");
                            // onCloseEnd callback
                            if (typeof _this18.options.onCloseEnd === "function") _this18.options.onCloseEnd.call(_this18, _this18.el);
                        }
                    };
                    anim(animOptions);
                }
            },
            {
                key: "_updateVars",
                value: function _updateVars() {
                    this.windowWidth = window.innerWidth;
                    this.windowHeight = window.innerHeight;
                    this.caption = this.el.getAttribute("data-caption") || "";
                }
            },
            {
                key: "open",
                value: function open() {
                    var _this19 = this;
                    this._updateVars();
                    this.originalWidth = this.el.getBoundingClientRect().width;
                    this.originalHeight = this.el.getBoundingClientRect().height;
                    // Set states
                    this.doneAnimating = false;
                    this.$el.addClass("active");
                    this.overlayActive = true;
                    // onOpenStart callback
                    if (typeof this.options.onOpenStart === "function") this.options.onOpenStart.call(this, this.el);
                    // Set positioning for placeholder
                    this.placeholder.css({
                        width: this.placeholder[0].getBoundingClientRect().width + "px",
                        height: this.placeholder[0].getBoundingClientRect().height + "px",
                        position: "relative",
                        top: 0,
                        left: 0
                    });
                    this._makeAncestorsOverflowVisible();
                    // Set css on origin
                    this.$el.css({
                        position: "absolute",
                        "z-index": 1000,
                        "will-change": "left, top, width, height"
                    });
                    // Change from width or height attribute to css
                    this.attrWidth = this.$el.attr("width");
                    this.attrHeight = this.$el.attr("height");
                    if (this.attrWidth) {
                        this.$el.css("width", this.attrWidth + "px");
                        this.$el.removeAttr("width");
                    }
                    if (this.attrHeight) {
                        this.$el.css("width", this.attrHeight + "px");
                        this.$el.removeAttr("height");
                    }
                    // Add overlay
                    this.$overlay = $1('<div id="materialbox-overlay"></div>').css({
                        opacity: 0
                    }).one("click", function() {
                        if (_this19.doneAnimating) _this19.close();
                    });
                    // Put before in origin image to preserve z-index layering.
                    this.$el.before(this.$overlay);
                    // Set dimensions if needed
                    var overlayOffset = this.$overlay[0].getBoundingClientRect();
                    this.$overlay.css({
                        width: this.windowWidth + "px",
                        height: this.windowHeight + "px",
                        left: -1 * overlayOffset.left + "px",
                        top: -1 * overlayOffset.top + "px"
                    });
                    anim.remove(this.el);
                    anim.remove(this.$overlay[0]);
                    // Animate Overlay
                    anim({
                        targets: this.$overlay[0],
                        opacity: 1,
                        duration: this.options.inDuration,
                        easing: "easeOutQuad"
                    });
                    // Add and animate caption if it exists
                    if (this.caption !== "") {
                        if (this.$photocaption) anim.remove(this.$photoCaption[0]);
                        this.$photoCaption = $1('<div class="materialbox-caption"></div>');
                        this.$photoCaption.text(this.caption);
                        $1("body").append(this.$photoCaption);
                        this.$photoCaption.css({
                            display: "inline"
                        });
                        anim({
                            targets: this.$photoCaption[0],
                            opacity: 1,
                            duration: this.options.inDuration,
                            easing: "easeOutQuad"
                        });
                    }
                    // Resize Image
                    var ratio = 0;
                    var widthPercent = this.originalWidth / this.windowWidth;
                    var heightPercent = this.originalHeight / this.windowHeight;
                    this.newWidth = 0;
                    this.newHeight = 0;
                    if (widthPercent > heightPercent) {
                        ratio = this.originalHeight / this.originalWidth;
                        this.newWidth = this.windowWidth * 0.9;
                        this.newHeight = this.windowWidth * 0.9 * ratio;
                    } else {
                        ratio = this.originalWidth / this.originalHeight;
                        this.newWidth = this.windowHeight * 0.9 * ratio;
                        this.newHeight = this.windowHeight * 0.9;
                    }
                    this._animateImageIn();
                    // Handle Exit triggers
                    this._handleWindowScrollBound = this._handleWindowScroll.bind(this);
                    this._handleWindowResizeBound = this._handleWindowResize.bind(this);
                    this._handleWindowEscapeBound = this._handleWindowEscape.bind(this);
                    window.addEventListener("scroll", this._handleWindowScrollBound);
                    window.addEventListener("resize", this._handleWindowResizeBound);
                    window.addEventListener("keyup", this._handleWindowEscapeBound);
                }
            },
            {
                key: "close",
                value: function close() {
                    var _this20 = this;
                    this._updateVars();
                    this.doneAnimating = false;
                    // onCloseStart callback
                    if (typeof this.options.onCloseStart === "function") this.options.onCloseStart.call(this, this.el);
                    anim.remove(this.el);
                    anim.remove(this.$overlay[0]);
                    if (this.caption !== "") anim.remove(this.$photoCaption[0]);
                    // disable exit handlers
                    window.removeEventListener("scroll", this._handleWindowScrollBound);
                    window.removeEventListener("resize", this._handleWindowResizeBound);
                    window.removeEventListener("keyup", this._handleWindowEscapeBound);
                    anim({
                        targets: this.$overlay[0],
                        opacity: 0,
                        duration: this.options.outDuration,
                        easing: "easeOutQuad",
                        complete: function() {
                            _this20.overlayActive = false;
                            _this20.$overlay.remove();
                        }
                    });
                    this._animateImageOut();
                    // Remove Caption + reset css settings on image
                    if (this.caption !== "") anim({
                        targets: this.$photoCaption[0],
                        opacity: 0,
                        duration: this.options.outDuration,
                        easing: "easeOutQuad",
                        complete: function() {
                            _this20.$photoCaption.remove();
                        }
                    });
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Materialbox.__proto__ || Object.getPrototypeOf(Materialbox), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Materialbox;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Materialbox;
    }(Component);
    M.Materialbox = Materialbox;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Materialbox, "materialbox", "M_Materialbox");
})(cash, M.anime);
(function($1) {
    "use strict";
    var _defaults = {
        responsiveThreshold: 0 // breakpoint for swipeable
    };
    var Parallax = function(_Component5) {
        _inherits(Parallax, _Component5);
        function Parallax(el, options) {
            _classCallCheck(this, Parallax);
            var _this21 = _possibleConstructorReturn(this, (Parallax.__proto__ || Object.getPrototypeOf(Parallax)).call(this, Parallax, el, options));
            _this21.el.M_Parallax = _this21;
            /**
       * Options for the Parallax
       * @member Parallax#options
       * @prop {Number} responsiveThreshold
       */ _this21.options = $1.extend({}, Parallax.defaults, options);
            _this21._enabled = window.innerWidth > _this21.options.responsiveThreshold;
            _this21.$img = _this21.$el.find("img").first();
            _this21.$img.each(function() {
                var el = this;
                if (el.complete) $1(el).trigger("load");
            });
            _this21._updateParallax();
            _this21._setupEventHandlers();
            _this21._setupStyles();
            Parallax._parallaxes.push(_this21);
            return _this21;
        }
        _createClass(Parallax, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    Parallax._parallaxes.splice(Parallax._parallaxes.indexOf(this), 1);
                    this.$img[0].style.transform = "";
                    this._removeEventHandlers();
                    this.$el[0].M_Parallax = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    this._handleImageLoadBound = this._handleImageLoad.bind(this);
                    this.$img[0].addEventListener("load", this._handleImageLoadBound);
                    if (Parallax._parallaxes.length === 0) {
                        Parallax._handleScrollThrottled = M.throttle(Parallax._handleScroll, 5);
                        window.addEventListener("scroll", Parallax._handleScrollThrottled);
                        Parallax._handleWindowResizeThrottled = M.throttle(Parallax._handleWindowResize, 5);
                        window.addEventListener("resize", Parallax._handleWindowResizeThrottled);
                    }
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    this.$img[0].removeEventListener("load", this._handleImageLoadBound);
                    if (Parallax._parallaxes.length === 0) {
                        window.removeEventListener("scroll", Parallax._handleScrollThrottled);
                        window.removeEventListener("resize", Parallax._handleWindowResizeThrottled);
                    }
                }
            },
            {
                key: "_setupStyles",
                value: function _setupStyles() {
                    this.$img[0].style.opacity = 1;
                }
            },
            {
                key: "_handleImageLoad",
                value: function _handleImageLoad() {
                    this._updateParallax();
                }
            },
            {
                key: "_updateParallax",
                value: function _updateParallax() {
                    var containerHeight = this.$el.height() > 0 ? this.el.parentNode.offsetHeight : 500;
                    var imgHeight = this.$img[0].offsetHeight;
                    var parallaxDist = imgHeight - containerHeight;
                    var bottom = this.$el.offset().top + containerHeight;
                    var top = this.$el.offset().top;
                    var scrollTop = M.getDocumentScrollTop();
                    var windowHeight = window.innerHeight;
                    var windowBottom = scrollTop + windowHeight;
                    var percentScrolled = (windowBottom - top) / (containerHeight + windowHeight);
                    var parallax = parallaxDist * percentScrolled;
                    if (!this._enabled) this.$img[0].style.transform = "";
                    else if (bottom > scrollTop && top < scrollTop + windowHeight) this.$img[0].style.transform = "translate3D(-50%, " + parallax + "px, 0)";
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Parallax.__proto__ || Object.getPrototypeOf(Parallax), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Parallax;
                }
            },
            {
                key: "_handleScroll",
                value: function _handleScroll() {
                    for(var i = 0; i < Parallax._parallaxes.length; i++){
                        var parallaxInstance = Parallax._parallaxes[i];
                        parallaxInstance._updateParallax.call(parallaxInstance);
                    }
                }
            },
            {
                key: "_handleWindowResize",
                value: function _handleWindowResize() {
                    for(var i = 0; i < Parallax._parallaxes.length; i++){
                        var parallaxInstance = Parallax._parallaxes[i];
                        parallaxInstance._enabled = window.innerWidth > parallaxInstance.options.responsiveThreshold;
                    }
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Parallax;
    }(Component);
    /**
   * @static
   * @memberof Parallax
   */ Parallax._parallaxes = [];
    M.Parallax = Parallax;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Parallax, "parallax", "M_Parallax");
})(cash);
(function($1, anim) {
    "use strict";
    var _defaults = {
        duration: 300,
        onShow: null,
        swipeable: false,
        responsiveThreshold: Infinity // breakpoint for swipeable
    };
    /**
   * @class
   *
   */ var Tabs = function(_Component6) {
        _inherits(Tabs, _Component6);
        /**
     * Construct Tabs instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function Tabs(el, options) {
            _classCallCheck(this, Tabs);
            var _this22 = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, Tabs, el, options));
            _this22.el.M_Tabs = _this22;
            /**
       * Options for the Tabs
       * @member Tabs#options
       * @prop {Number} duration
       * @prop {Function} onShow
       * @prop {Boolean} swipeable
       * @prop {Number} responsiveThreshold
       */ _this22.options = $1.extend({}, Tabs.defaults, options);
            // Setup
            _this22.$tabLinks = _this22.$el.children("li.tab").children("a");
            _this22.index = 0;
            _this22._setupActiveTabLink();
            // Setup tabs content
            if (_this22.options.swipeable) _this22._setupSwipeableTabs();
            else _this22._setupNormalTabs();
            // Setup tabs indicator after content to ensure accurate widths
            _this22._setTabsAndTabWidth();
            _this22._createIndicator();
            _this22._setupEventHandlers();
            return _this22;
        }
        _createClass(Tabs, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this._removeEventHandlers();
                    this._indicator.parentNode.removeChild(this._indicator);
                    if (this.options.swipeable) this._teardownSwipeableTabs();
                    else this._teardownNormalTabs();
                    this.$el[0].M_Tabs = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    this._handleWindowResizeBound = this._handleWindowResize.bind(this);
                    window.addEventListener("resize", this._handleWindowResizeBound);
                    this._handleTabClickBound = this._handleTabClick.bind(this);
                    this.el.addEventListener("click", this._handleTabClickBound);
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    window.removeEventListener("resize", this._handleWindowResizeBound);
                    this.el.removeEventListener("click", this._handleTabClickBound);
                }
            },
            {
                key: "_handleWindowResize",
                value: function _handleWindowResize() {
                    this._setTabsAndTabWidth();
                    if (this.tabWidth !== 0 && this.tabsWidth !== 0) {
                        this._indicator.style.left = this._calcLeftPos(this.$activeTabLink) + "px";
                        this._indicator.style.right = this._calcRightPos(this.$activeTabLink) + "px";
                    }
                }
            },
            {
                key: "_handleTabClick",
                value: function _handleTabClick(e) {
                    var _this23 = this;
                    var tab = $1(e.target).closest("li.tab");
                    var tabLink = $1(e.target).closest("a");
                    // Handle click on tab link only
                    if (!tabLink.length || !tabLink.parent().hasClass("tab")) return;
                    if (tab.hasClass("disabled")) {
                        e.preventDefault();
                        return;
                    }
                    // Act as regular link if target attribute is specified.
                    if (!!tabLink.attr("target")) return;
                    // Make the old tab inactive.
                    this.$activeTabLink.removeClass("active");
                    var $oldContent = this.$content;
                    // Update the variables with the new link and content
                    this.$activeTabLink = tabLink;
                    this.$content = $1(M.escapeHash(tabLink[0].hash));
                    this.$tabLinks = this.$el.children("li.tab").children("a");
                    // Make the tab active.
                    this.$activeTabLink.addClass("active");
                    var prevIndex = this.index;
                    this.index = Math.max(this.$tabLinks.index(tabLink), 0);
                    // Swap content
                    if (this.options.swipeable) {
                        if (this._tabsCarousel) this._tabsCarousel.set(this.index, function() {
                            if (typeof _this23.options.onShow === "function") _this23.options.onShow.call(_this23, _this23.$content[0]);
                        });
                    } else if (this.$content.length) {
                        this.$content[0].style.display = "block";
                        this.$content.addClass("active");
                        if (typeof this.options.onShow === "function") this.options.onShow.call(this, this.$content[0]);
                        if ($oldContent.length && !$oldContent.is(this.$content)) {
                            $oldContent[0].style.display = "none";
                            $oldContent.removeClass("active");
                        }
                    }
                    // Update widths after content is swapped (scrollbar bugfix)
                    this._setTabsAndTabWidth();
                    // Update indicator
                    this._animateIndicator(prevIndex);
                    // Prevent the anchor's default click action
                    e.preventDefault();
                }
            },
            {
                key: "_createIndicator",
                value: function _createIndicator() {
                    var _this24 = this;
                    var indicator = document.createElement("li");
                    indicator.classList.add("indicator");
                    this.el.appendChild(indicator);
                    this._indicator = indicator;
                    setTimeout(function() {
                        _this24._indicator.style.left = _this24._calcLeftPos(_this24.$activeTabLink) + "px";
                        _this24._indicator.style.right = _this24._calcRightPos(_this24.$activeTabLink) + "px";
                    }, 0);
                }
            },
            {
                key: "_setupActiveTabLink",
                value: function _setupActiveTabLink() {
                    // If the location.hash matches one of the links, use that as the active tab.
                    this.$activeTabLink = $1(this.$tabLinks.filter('[href="' + location.hash + '"]'));
                    // If no match is found, use the first link or any with class 'active' as the initial active tab.
                    if (this.$activeTabLink.length === 0) this.$activeTabLink = this.$el.children("li.tab").children("a.active").first();
                    if (this.$activeTabLink.length === 0) this.$activeTabLink = this.$el.children("li.tab").children("a").first();
                    this.$tabLinks.removeClass("active");
                    this.$activeTabLink[0].classList.add("active");
                    this.index = Math.max(this.$tabLinks.index(this.$activeTabLink), 0);
                    if (this.$activeTabLink.length) {
                        this.$content = $1(M.escapeHash(this.$activeTabLink[0].hash));
                        this.$content.addClass("active");
                    }
                }
            },
            {
                key: "_setupSwipeableTabs",
                value: function _setupSwipeableTabs() {
                    var _this25 = this;
                    // Change swipeable according to responsive threshold
                    if (window.innerWidth > this.options.responsiveThreshold) this.options.swipeable = false;
                    var $tabsContent = $1();
                    this.$tabLinks.each(function(link) {
                        var $currContent = $1(M.escapeHash(link.hash));
                        $currContent.addClass("carousel-item");
                        $tabsContent = $tabsContent.add($currContent);
                    });
                    var $tabsWrapper = $1('<div class="tabs-content carousel carousel-slider"></div>');
                    $tabsContent.first().before($tabsWrapper);
                    $tabsWrapper.append($tabsContent);
                    $tabsContent[0].style.display = "";
                    // Keep active tab index to set initial carousel slide
                    var activeTabIndex = this.$activeTabLink.closest(".tab").index();
                    this._tabsCarousel = M.Carousel.init($tabsWrapper[0], {
                        fullWidth: true,
                        noWrap: true,
                        onCycleTo: function(item) {
                            var prevIndex = _this25.index;
                            _this25.index = $1(item).index();
                            _this25.$activeTabLink.removeClass("active");
                            _this25.$activeTabLink = _this25.$tabLinks.eq(_this25.index);
                            _this25.$activeTabLink.addClass("active");
                            _this25._animateIndicator(prevIndex);
                            if (typeof _this25.options.onShow === "function") _this25.options.onShow.call(_this25, _this25.$content[0]);
                        }
                    });
                    // Set initial carousel slide to active tab
                    this._tabsCarousel.set(activeTabIndex);
                }
            },
            {
                key: "_teardownSwipeableTabs",
                value: function _teardownSwipeableTabs() {
                    var $tabsWrapper = this._tabsCarousel.$el;
                    this._tabsCarousel.destroy();
                    // Unwrap
                    $tabsWrapper.after($tabsWrapper.children());
                    $tabsWrapper.remove();
                }
            },
            {
                key: "_setupNormalTabs",
                value: function _setupNormalTabs() {
                    // Hide Tabs Content
                    this.$tabLinks.not(this.$activeTabLink).each(function(link) {
                        if (!!link.hash) {
                            var $currContent = $1(M.escapeHash(link.hash));
                            if ($currContent.length) $currContent[0].style.display = "none";
                        }
                    });
                }
            },
            {
                key: "_teardownNormalTabs",
                value: function _teardownNormalTabs() {
                    // show Tabs Content
                    this.$tabLinks.each(function(link) {
                        if (!!link.hash) {
                            var $currContent = $1(M.escapeHash(link.hash));
                            if ($currContent.length) $currContent[0].style.display = "";
                        }
                    });
                }
            },
            {
                key: "_setTabsAndTabWidth",
                value: function _setTabsAndTabWidth() {
                    this.tabsWidth = this.$el.width();
                    this.tabWidth = Math.max(this.tabsWidth, this.el.scrollWidth) / this.$tabLinks.length;
                }
            },
            {
                key: "_calcRightPos",
                value: function _calcRightPos(el) {
                    return Math.ceil(this.tabsWidth - el.position().left - el[0].getBoundingClientRect().width);
                }
            },
            {
                key: "_calcLeftPos",
                value: function _calcLeftPos(el) {
                    return Math.floor(el.position().left);
                }
            },
            {
                key: "updateTabIndicator",
                value: function updateTabIndicator() {
                    this._setTabsAndTabWidth();
                    this._animateIndicator(this.index);
                }
            },
            {
                key: "_animateIndicator",
                value: function _animateIndicator(prevIndex) {
                    var leftDelay = 0, rightDelay = 0;
                    if (this.index - prevIndex >= 0) leftDelay = 90;
                    else rightDelay = 90;
                    // Animate
                    var animOptions = {
                        targets: this._indicator,
                        left: {
                            value: this._calcLeftPos(this.$activeTabLink),
                            delay: leftDelay
                        },
                        right: {
                            value: this._calcRightPos(this.$activeTabLink),
                            delay: rightDelay
                        },
                        duration: this.options.duration,
                        easing: "easeOutQuad"
                    };
                    anim.remove(this._indicator);
                    anim(animOptions);
                }
            },
            {
                key: "select",
                value: function select(tabId) {
                    var tab = this.$tabLinks.filter('[href="#' + tabId + '"]');
                    if (tab.length) tab.trigger("click");
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Tabs.__proto__ || Object.getPrototypeOf(Tabs), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Tabs;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Tabs;
    }(Component);
    M.Tabs = Tabs;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Tabs, "tabs", "M_Tabs");
})(cash, M.anime);
(function($1, anim) {
    "use strict";
    var _defaults = {
        exitDelay: 200,
        enterDelay: 0,
        html: null,
        margin: 5,
        inDuration: 250,
        outDuration: 200,
        position: "bottom",
        transitionMovement: 10
    };
    /**
   * @class
   *
   */ var Tooltip = function(_Component7) {
        _inherits(Tooltip, _Component7);
        /**
     * Construct Tooltip instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function Tooltip(el, options) {
            _classCallCheck(this, Tooltip);
            var _this26 = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, Tooltip, el, options));
            _this26.el.M_Tooltip = _this26;
            _this26.options = $1.extend({}, Tooltip.defaults, options);
            _this26.isOpen = false;
            _this26.isHovered = false;
            _this26.isFocused = false;
            _this26._appendTooltipEl();
            _this26._setupEventHandlers();
            return _this26;
        }
        _createClass(Tooltip, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    $1(this.tooltipEl).remove();
                    this._removeEventHandlers();
                    this.el.M_Tooltip = undefined;
                }
            },
            {
                key: "_appendTooltipEl",
                value: function _appendTooltipEl() {
                    var tooltipEl = document.createElement("div");
                    tooltipEl.classList.add("material-tooltip");
                    this.tooltipEl = tooltipEl;
                    var tooltipContentEl = document.createElement("div");
                    tooltipContentEl.classList.add("tooltip-content");
                    tooltipContentEl.innerHTML = this.options.html;
                    tooltipEl.appendChild(tooltipContentEl);
                    document.body.appendChild(tooltipEl);
                }
            },
            {
                key: "_updateTooltipContent",
                value: function _updateTooltipContent() {
                    this.tooltipEl.querySelector(".tooltip-content").innerHTML = this.options.html;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    this._handleMouseEnterBound = this._handleMouseEnter.bind(this);
                    this._handleMouseLeaveBound = this._handleMouseLeave.bind(this);
                    this._handleFocusBound = this._handleFocus.bind(this);
                    this._handleBlurBound = this._handleBlur.bind(this);
                    this.el.addEventListener("mouseenter", this._handleMouseEnterBound);
                    this.el.addEventListener("mouseleave", this._handleMouseLeaveBound);
                    this.el.addEventListener("focus", this._handleFocusBound, true);
                    this.el.addEventListener("blur", this._handleBlurBound, true);
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    this.el.removeEventListener("mouseenter", this._handleMouseEnterBound);
                    this.el.removeEventListener("mouseleave", this._handleMouseLeaveBound);
                    this.el.removeEventListener("focus", this._handleFocusBound, true);
                    this.el.removeEventListener("blur", this._handleBlurBound, true);
                }
            },
            {
                key: "open",
                value: function open(isManual) {
                    if (this.isOpen) return;
                    isManual = isManual === undefined ? true : undefined; // Default value true
                    this.isOpen = true;
                    // Update tooltip content with HTML attribute options
                    this.options = $1.extend({}, this.options, this._getAttributeOptions());
                    this._updateTooltipContent();
                    this._setEnterDelayTimeout(isManual);
                }
            },
            {
                key: "close",
                value: function close() {
                    if (!this.isOpen) return;
                    this.isHovered = false;
                    this.isFocused = false;
                    this.isOpen = false;
                    this._setExitDelayTimeout();
                }
            },
            {
                key: "_setExitDelayTimeout",
                value: function _setExitDelayTimeout() {
                    var _this27 = this;
                    clearTimeout(this._exitDelayTimeout);
                    this._exitDelayTimeout = setTimeout(function() {
                        if (_this27.isHovered || _this27.isFocused) return;
                        _this27._animateOut();
                    }, this.options.exitDelay);
                }
            },
            {
                key: "_setEnterDelayTimeout",
                value: function _setEnterDelayTimeout(isManual) {
                    var _this28 = this;
                    clearTimeout(this._enterDelayTimeout);
                    this._enterDelayTimeout = setTimeout(function() {
                        if (!_this28.isHovered && !_this28.isFocused && !isManual) return;
                        _this28._animateIn();
                    }, this.options.enterDelay);
                }
            },
            {
                key: "_positionTooltip",
                value: function _positionTooltip() {
                    var origin = this.el, tooltip = this.tooltipEl, originHeight = origin.offsetHeight, originWidth = origin.offsetWidth, tooltipHeight = tooltip.offsetHeight, tooltipWidth = tooltip.offsetWidth, newCoordinates = void 0, margin = this.options.margin, targetTop = void 0, targetLeft = void 0;
                    this.xMovement = 0, this.yMovement = 0;
                    targetTop = origin.getBoundingClientRect().top + M.getDocumentScrollTop();
                    targetLeft = origin.getBoundingClientRect().left + M.getDocumentScrollLeft();
                    if (this.options.position === "top") {
                        targetTop += -tooltipHeight - margin;
                        targetLeft += originWidth / 2 - tooltipWidth / 2;
                        this.yMovement = -this.options.transitionMovement;
                    } else if (this.options.position === "right") {
                        targetTop += originHeight / 2 - tooltipHeight / 2;
                        targetLeft += originWidth + margin;
                        this.xMovement = this.options.transitionMovement;
                    } else if (this.options.position === "left") {
                        targetTop += originHeight / 2 - tooltipHeight / 2;
                        targetLeft += -tooltipWidth - margin;
                        this.xMovement = -this.options.transitionMovement;
                    } else {
                        targetTop += originHeight + margin;
                        targetLeft += originWidth / 2 - tooltipWidth / 2;
                        this.yMovement = this.options.transitionMovement;
                    }
                    newCoordinates = this._repositionWithinScreen(targetLeft, targetTop, tooltipWidth, tooltipHeight);
                    $1(tooltip).css({
                        top: newCoordinates.y + "px",
                        left: newCoordinates.x + "px"
                    });
                }
            },
            {
                key: "_repositionWithinScreen",
                value: function _repositionWithinScreen(x, y, width, height) {
                    var scrollLeft = M.getDocumentScrollLeft();
                    var scrollTop = M.getDocumentScrollTop();
                    var newX = x - scrollLeft;
                    var newY = y - scrollTop;
                    var bounding = {
                        left: newX,
                        top: newY,
                        width: width,
                        height: height
                    };
                    var offset = this.options.margin + this.options.transitionMovement;
                    var edges = M.checkWithinContainer(document.body, bounding, offset);
                    if (edges.left) newX = offset;
                    else if (edges.right) newX -= newX + width - window.innerWidth;
                    if (edges.top) newY = offset;
                    else if (edges.bottom) newY -= newY + height - window.innerHeight;
                    return {
                        x: newX + scrollLeft,
                        y: newY + scrollTop
                    };
                }
            },
            {
                key: "_animateIn",
                value: function _animateIn() {
                    this._positionTooltip();
                    this.tooltipEl.style.visibility = "visible";
                    anim.remove(this.tooltipEl);
                    anim({
                        targets: this.tooltipEl,
                        opacity: 1,
                        translateX: this.xMovement,
                        translateY: this.yMovement,
                        duration: this.options.inDuration,
                        easing: "easeOutCubic"
                    });
                }
            },
            {
                key: "_animateOut",
                value: function _animateOut() {
                    anim.remove(this.tooltipEl);
                    anim({
                        targets: this.tooltipEl,
                        opacity: 0,
                        translateX: 0,
                        translateY: 0,
                        duration: this.options.outDuration,
                        easing: "easeOutCubic"
                    });
                }
            },
            {
                key: "_handleMouseEnter",
                value: function _handleMouseEnter() {
                    this.isHovered = true;
                    this.isFocused = false; // Allows close of tooltip when opened by focus.
                    this.open(false);
                }
            },
            {
                key: "_handleMouseLeave",
                value: function _handleMouseLeave() {
                    this.isHovered = false;
                    this.isFocused = false; // Allows close of tooltip when opened by focus.
                    this.close();
                }
            },
            {
                key: "_handleFocus",
                value: function _handleFocus() {
                    if (M.tabPressed) {
                        this.isFocused = true;
                        this.open(false);
                    }
                }
            },
            {
                key: "_handleBlur",
                value: function _handleBlur() {
                    this.isFocused = false;
                    this.close();
                }
            },
            {
                key: "_getAttributeOptions",
                value: function _getAttributeOptions() {
                    var attributeOptions = {};
                    var tooltipTextOption = this.el.getAttribute("data-tooltip");
                    var positionOption = this.el.getAttribute("data-position");
                    if (tooltipTextOption) attributeOptions.html = tooltipTextOption;
                    if (positionOption) attributeOptions.position = positionOption;
                    return attributeOptions;
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Tooltip.__proto__ || Object.getPrototypeOf(Tooltip), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Tooltip;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Tooltip;
    }(Component);
    M.Tooltip = Tooltip;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Tooltip, "tooltip", "M_Tooltip");
})(cash, M.anime);
(function(window1) {
    "use strict";
    var Waves = Waves || {};
    var $$ = document.querySelectorAll.bind(document);
    // Find exact position of element
    function isWindow(obj) {
        return obj !== null && obj === obj.window;
    }
    function getWindow(elem) {
        return isWindow(elem) ? elem : elem.nodeType === 9 && elem.defaultView;
    }
    function offset(elem) {
        var docElem, win, box = {
            top: 0,
            left: 0
        }, doc = elem && elem.ownerDocument;
        docElem = doc.documentElement;
        if (typeof elem.getBoundingClientRect !== "undefined") box = elem.getBoundingClientRect();
        win = getWindow(doc);
        return {
            top: box.top + win.pageYOffset - docElem.clientTop,
            left: box.left + win.pageXOffset - docElem.clientLeft
        };
    }
    function convertStyle(obj) {
        var style = "";
        for(var a in obj)if (obj.hasOwnProperty(a)) style += a + ":" + obj[a] + ";";
        return style;
    }
    var Effect = {
        // Effect delay
        duration: 750,
        show: function(e, element) {
            // Disable right click
            if (e.button === 2) return false;
            var el = element || this;
            // Create ripple
            var ripple = document.createElement("div");
            ripple.className = "waves-ripple";
            el.appendChild(ripple);
            // Get click coordinate and element witdh
            var pos = offset(el);
            var relativeY = e.pageY - pos.top;
            var relativeX = e.pageX - pos.left;
            var scale = "scale(" + el.clientWidth / 100 * 10 + ")";
            // Support for touch devices
            if ("touches" in e) {
                relativeY = e.touches[0].pageY - pos.top;
                relativeX = e.touches[0].pageX - pos.left;
            }
            // Attach data to element
            ripple.setAttribute("data-hold", Date.now());
            ripple.setAttribute("data-scale", scale);
            ripple.setAttribute("data-x", relativeX);
            ripple.setAttribute("data-y", relativeY);
            // Set ripple position
            var rippleStyle = {
                "top": relativeY + "px",
                "left": relativeX + "px"
            };
            ripple.className = ripple.className + " waves-notransition";
            ripple.setAttribute("style", convertStyle(rippleStyle));
            ripple.className = ripple.className.replace("waves-notransition", "");
            // Scale the ripple
            rippleStyle["-webkit-transform"] = scale;
            rippleStyle["-moz-transform"] = scale;
            rippleStyle["-ms-transform"] = scale;
            rippleStyle["-o-transform"] = scale;
            rippleStyle.transform = scale;
            rippleStyle.opacity = "1";
            rippleStyle["-webkit-transition-duration"] = Effect.duration + "ms";
            rippleStyle["-moz-transition-duration"] = Effect.duration + "ms";
            rippleStyle["-o-transition-duration"] = Effect.duration + "ms";
            rippleStyle["transition-duration"] = Effect.duration + "ms";
            rippleStyle["-webkit-transition-timing-function"] = "cubic-bezier(0.250, 0.460, 0.450, 0.940)";
            rippleStyle["-moz-transition-timing-function"] = "cubic-bezier(0.250, 0.460, 0.450, 0.940)";
            rippleStyle["-o-transition-timing-function"] = "cubic-bezier(0.250, 0.460, 0.450, 0.940)";
            rippleStyle["transition-timing-function"] = "cubic-bezier(0.250, 0.460, 0.450, 0.940)";
            ripple.setAttribute("style", convertStyle(rippleStyle));
        },
        hide: function(e) {
            TouchHandler.touchup(e);
            var el = this;
            var width = el.clientWidth * 1.4;
            // Get first ripple
            var ripple = null;
            var ripples = el.getElementsByClassName("waves-ripple");
            if (ripples.length > 0) ripple = ripples[ripples.length - 1];
            else return false;
            var relativeX = ripple.getAttribute("data-x");
            var relativeY = ripple.getAttribute("data-y");
            var scale = ripple.getAttribute("data-scale");
            // Get delay beetween mousedown and mouse leave
            var diff = Date.now() - Number(ripple.getAttribute("data-hold"));
            var delay = 350 - diff;
            if (delay < 0) delay = 0;
            // Fade out ripple after delay
            setTimeout(function() {
                var style = {
                    "top": relativeY + "px",
                    "left": relativeX + "px",
                    "opacity": "0",
                    // Duration
                    "-webkit-transition-duration": Effect.duration + "ms",
                    "-moz-transition-duration": Effect.duration + "ms",
                    "-o-transition-duration": Effect.duration + "ms",
                    "transition-duration": Effect.duration + "ms",
                    "-webkit-transform": scale,
                    "-moz-transform": scale,
                    "-ms-transform": scale,
                    "-o-transform": scale,
                    "transform": scale
                };
                ripple.setAttribute("style", convertStyle(style));
                setTimeout(function() {
                    try {
                        el.removeChild(ripple);
                    } catch (e) {
                        return false;
                    }
                }, Effect.duration);
            }, delay);
        },
        // Little hack to make <input> can perform waves effect
        wrapInput: function(elements) {
            for(var a = 0; a < elements.length; a++){
                var el = elements[a];
                if (el.tagName.toLowerCase() === "input") {
                    var parent = el.parentNode;
                    // If input already have parent just pass through
                    if (parent.tagName.toLowerCase() === "i" && parent.className.indexOf("waves-effect") !== -1) continue;
                    // Put element class and style to the specified parent
                    var wrapper = document.createElement("i");
                    wrapper.className = el.className + " waves-input-wrapper";
                    var elementStyle = el.getAttribute("style");
                    if (!elementStyle) elementStyle = "";
                    wrapper.setAttribute("style", elementStyle);
                    el.className = "waves-button-input";
                    el.removeAttribute("style");
                    // Put element as child
                    parent.replaceChild(wrapper, el);
                    wrapper.appendChild(el);
                }
            }
        }
    };
    /**
   * Disable mousedown event for 500ms during and after touch
   */ var TouchHandler = {
        /* uses an integer rather than bool so there's no issues with
     * needing to clear timeouts if another touch event occurred
     * within the 500ms. Cannot mouseup between touchstart and
     * touchend, nor in the 500ms after touchend. */ touches: 0,
        allowEvent: function(e) {
            var allow = true;
            if (e.type === "touchstart") TouchHandler.touches += 1; //push
            else if (e.type === "touchend" || e.type === "touchcancel") setTimeout(function() {
                if (TouchHandler.touches > 0) TouchHandler.touches -= 1; //pop after 500ms
            }, 500);
            else if (e.type === "mousedown" && TouchHandler.touches > 0) allow = false;
            return allow;
        },
        touchup: function(e) {
            TouchHandler.allowEvent(e);
        }
    };
    /**
   * Delegated click handler for .waves-effect element.
   * returns null when .waves-effect element not in "click tree"
   */ function getWavesEffectElement(e) {
        if (TouchHandler.allowEvent(e) === false) return null;
        var element = null;
        var target = e.target || e.srcElement;
        while(target.parentNode !== null){
            if (!(target instanceof SVGElement) && target.className.indexOf("waves-effect") !== -1) {
                element = target;
                break;
            }
            target = target.parentNode;
        }
        return element;
    }
    /**
   * Bubble the click and show effect if .waves-effect elem was found
   */ function showEffect(e) {
        var element = getWavesEffectElement(e);
        if (element !== null) {
            Effect.show(e, element);
            if ("ontouchstart" in window1) {
                element.addEventListener("touchend", Effect.hide, false);
                element.addEventListener("touchcancel", Effect.hide, false);
            }
            element.addEventListener("mouseup", Effect.hide, false);
            element.addEventListener("mouseleave", Effect.hide, false);
            element.addEventListener("dragend", Effect.hide, false);
        }
    }
    Waves.displayEffect = function(options) {
        options = options || {};
        if ("duration" in options) Effect.duration = options.duration;
        //Wrap input inside <i> tag
        Effect.wrapInput($$(".waves-effect"));
        if ("ontouchstart" in window1) document.body.addEventListener("touchstart", showEffect, false);
        document.body.addEventListener("mousedown", showEffect, false);
    };
    /**
   * Attach Waves to an input element (or any element which doesn't
   * bubble mouseup/mousedown events).
   *   Intended to be used with dynamically loaded forms/inputs, or
   * where the user doesn't want a delegated click handler.
   */ Waves.attach = function(element) {
        //FUTURE: automatically add waves classes and allow users
        // to specify them with an options param? Eg. light/classic/button
        if (element.tagName.toLowerCase() === "input") {
            Effect.wrapInput([
                element
            ]);
            element = element.parentNode;
        }
        if ("ontouchstart" in window1) element.addEventListener("touchstart", showEffect, false);
        element.addEventListener("mousedown", showEffect, false);
    };
    window1.Waves = Waves;
    document.addEventListener("DOMContentLoaded", function() {
        Waves.displayEffect();
    }, false);
})(window);
(function($1, anim) {
    "use strict";
    var _defaults = {
        html: "",
        displayLength: 4000,
        inDuration: 300,
        outDuration: 375,
        classes: "",
        completeCallback: null,
        activationPercent: 0.8
    };
    var Toast = function() {
        function Toast(options) {
            _classCallCheck(this, Toast);
            /**
       * Options for the toast
       * @member Toast#options
       */ this.options = $1.extend({}, Toast.defaults, options);
            this.message = this.options.html;
            /**
       * Describes current pan state toast
       * @type {Boolean}
       */ this.panning = false;
            /**
       * Time remaining until toast is removed
       */ this.timeRemaining = this.options.displayLength;
            if (Toast._toasts.length === 0) Toast._createContainer();
            // Create new toast
            Toast._toasts.push(this);
            var toastElement = this._createToast();
            toastElement.M_Toast = this;
            this.el = toastElement;
            this.$el = $1(toastElement);
            this._animateIn();
            this._setTimer();
        }
        _createClass(Toast, [
            {
                key: "_createToast",
                /**
       * Create toast and append it to toast container
       */ value: function _createToast() {
                    var toast = document.createElement("div");
                    toast.classList.add("toast");
                    // Add custom classes onto toast
                    if (!!this.options.classes.length) $1(toast).addClass(this.options.classes);
                    // Set content
                    if (typeof HTMLElement === "object" ? this.message instanceof HTMLElement : this.message && typeof this.message === "object" && this.message !== null && this.message.nodeType === 1 && typeof this.message.nodeName === "string") toast.appendChild(this.message);
                    else if (!!this.message.jquery) $1(toast).append(this.message[0]);
                    else toast.innerHTML = this.message;
                    // Append toasft
                    Toast._container.appendChild(toast);
                    return toast;
                }
            },
            {
                key: "_animateIn",
                value: function _animateIn() {
                    // Animate toast in
                    anim({
                        targets: this.el,
                        top: 0,
                        opacity: 1,
                        duration: this.options.inDuration,
                        easing: "easeOutCubic"
                    });
                }
            },
            {
                key: "_setTimer",
                value: function _setTimer() {
                    var _this29 = this;
                    if (this.timeRemaining !== Infinity) this.counterInterval = setInterval(function() {
                        // If toast is not being dragged, decrease its time remaining
                        if (!_this29.panning) _this29.timeRemaining -= 20;
                        // Animate toast out
                        if (_this29.timeRemaining <= 0) _this29.dismiss();
                    }, 20);
                }
            },
            {
                key: "dismiss",
                value: function dismiss() {
                    var _this30 = this;
                    window.clearInterval(this.counterInterval);
                    var activationDistance = this.el.offsetWidth * this.options.activationPercent;
                    if (this.wasSwiped) {
                        this.el.style.transition = "transform .05s, opacity .05s";
                        this.el.style.transform = "translateX(" + activationDistance + "px)";
                        this.el.style.opacity = 0;
                    }
                    anim({
                        targets: this.el,
                        opacity: 0,
                        marginTop: -40,
                        duration: this.options.outDuration,
                        easing: "easeOutExpo",
                        complete: function() {
                            // Call the optional callback
                            if (typeof _this30.options.completeCallback === "function") _this30.options.completeCallback();
                            // Remove toast from DOM
                            _this30.$el.remove();
                            Toast._toasts.splice(Toast._toasts.indexOf(_this30), 1);
                            if (Toast._toasts.length === 0) Toast._removeContainer();
                        }
                    });
                }
            }
        ], [
            {
                key: "getInstance",
                /**
       * Get Instance
       */ value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Toast;
                }
            },
            {
                key: "_createContainer",
                value: function _createContainer() {
                    var container = document.createElement("div");
                    container.setAttribute("id", "toast-container");
                    // Add event handler
                    container.addEventListener("touchstart", Toast._onDragStart);
                    container.addEventListener("touchmove", Toast._onDragMove);
                    container.addEventListener("touchend", Toast._onDragEnd);
                    container.addEventListener("mousedown", Toast._onDragStart);
                    document.addEventListener("mousemove", Toast._onDragMove);
                    document.addEventListener("mouseup", Toast._onDragEnd);
                    document.body.appendChild(container);
                    Toast._container = container;
                }
            },
            {
                key: "_removeContainer",
                value: function _removeContainer() {
                    // Add event handler
                    document.removeEventListener("mousemove", Toast._onDragMove);
                    document.removeEventListener("mouseup", Toast._onDragEnd);
                    $1(Toast._container).remove();
                    Toast._container = null;
                }
            },
            {
                key: "_onDragStart",
                value: function _onDragStart(e) {
                    if (e.target && $1(e.target).closest(".toast").length) {
                        var $toast = $1(e.target).closest(".toast");
                        var toast = $toast[0].M_Toast;
                        toast.panning = true;
                        Toast._draggedToast = toast;
                        toast.el.classList.add("panning");
                        toast.el.style.transition = "";
                        toast.startingXPos = Toast._xPos(e);
                        toast.time = Date.now();
                        toast.xPos = Toast._xPos(e);
                    }
                }
            },
            {
                key: "_onDragMove",
                value: function _onDragMove(e) {
                    if (!!Toast._draggedToast) {
                        e.preventDefault();
                        var toast = Toast._draggedToast;
                        toast.deltaX = Math.abs(toast.xPos - Toast._xPos(e));
                        toast.xPos = Toast._xPos(e);
                        toast.velocityX = toast.deltaX / (Date.now() - toast.time);
                        toast.time = Date.now();
                        var totalDeltaX = toast.xPos - toast.startingXPos;
                        var activationDistance = toast.el.offsetWidth * toast.options.activationPercent;
                        toast.el.style.transform = "translateX(" + totalDeltaX + "px)";
                        toast.el.style.opacity = 1 - Math.abs(totalDeltaX / activationDistance);
                    }
                }
            },
            {
                key: "_onDragEnd",
                value: function _onDragEnd() {
                    if (!!Toast._draggedToast) {
                        var toast = Toast._draggedToast;
                        toast.panning = false;
                        toast.el.classList.remove("panning");
                        var totalDeltaX = toast.xPos - toast.startingXPos;
                        var activationDistance = toast.el.offsetWidth * toast.options.activationPercent;
                        var shouldBeDismissed = Math.abs(totalDeltaX) > activationDistance || toast.velocityX > 1;
                        // Remove toast
                        if (shouldBeDismissed) {
                            toast.wasSwiped = true;
                            toast.dismiss();
                        // Animate toast back to original position
                        } else {
                            toast.el.style.transition = "transform .2s, opacity .2s";
                            toast.el.style.transform = "";
                            toast.el.style.opacity = "";
                        }
                        Toast._draggedToast = null;
                    }
                }
            },
            {
                key: "_xPos",
                value: function _xPos(e) {
                    if (e.targetTouches && e.targetTouches.length >= 1) return e.targetTouches[0].clientX;
                    // mouse event
                    return e.clientX;
                }
            },
            {
                key: "dismissAll",
                value: function dismissAll() {
                    for(var toastIndex in Toast._toasts)Toast._toasts[toastIndex].dismiss();
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Toast;
    }();
    /**
   * @static
   * @memberof Toast
   * @type {Array.<Toast>}
   */ Toast._toasts = [];
    /**
   * @static
   * @memberof Toast
   */ Toast._container = null;
    /**
   * @static
   * @memberof Toast
   * @type {Toast}
   */ Toast._draggedToast = null;
    M.Toast = Toast;
    M.toast = function(options) {
        return new Toast(options);
    };
})(cash, M.anime);
(function($1, anim) {
    "use strict";
    var _defaults = {
        edge: "left",
        draggable: true,
        inDuration: 250,
        outDuration: 200,
        onOpenStart: null,
        onOpenEnd: null,
        onCloseStart: null,
        onCloseEnd: null,
        preventScrolling: true
    };
    /**
   * @class
   */ var Sidenav = function(_Component8) {
        _inherits(Sidenav, _Component8);
        /**
     * Construct Sidenav instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function Sidenav(el, options) {
            _classCallCheck(this, Sidenav);
            var _this31 = _possibleConstructorReturn(this, (Sidenav.__proto__ || Object.getPrototypeOf(Sidenav)).call(this, Sidenav, el, options));
            _this31.el.M_Sidenav = _this31;
            _this31.id = _this31.$el.attr("id");
            /**
       * Options for the Sidenav
       * @member Sidenav#options
       * @prop {String} [edge='left'] - Side of screen on which Sidenav appears
       * @prop {Boolean} [draggable=true] - Allow swipe gestures to open/close Sidenav
       * @prop {Number} [inDuration=250] - Length in ms of enter transition
       * @prop {Number} [outDuration=200] - Length in ms of exit transition
       * @prop {Function} onOpenStart - Function called when sidenav starts entering
       * @prop {Function} onOpenEnd - Function called when sidenav finishes entering
       * @prop {Function} onCloseStart - Function called when sidenav starts exiting
       * @prop {Function} onCloseEnd - Function called when sidenav finishes exiting
       */ _this31.options = $1.extend({}, Sidenav.defaults, options);
            /**
       * Describes open/close state of Sidenav
       * @type {Boolean}
       */ _this31.isOpen = false;
            /**
       * Describes if Sidenav is fixed
       * @type {Boolean}
       */ _this31.isFixed = _this31.el.classList.contains("sidenav-fixed");
            /**
       * Describes if Sidenav is being draggeed
       * @type {Boolean}
       */ _this31.isDragged = false;
            // Window size variables for window resize checks
            _this31.lastWindowWidth = window.innerWidth;
            _this31.lastWindowHeight = window.innerHeight;
            _this31._createOverlay();
            _this31._createDragTarget();
            _this31._setupEventHandlers();
            _this31._setupClasses();
            _this31._setupFixed();
            Sidenav._sidenavs.push(_this31);
            return _this31;
        }
        _createClass(Sidenav, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this._removeEventHandlers();
                    this._enableBodyScrolling();
                    this._overlay.parentNode.removeChild(this._overlay);
                    this.dragTarget.parentNode.removeChild(this.dragTarget);
                    this.el.M_Sidenav = undefined;
                    this.el.style.transform = "";
                    var index = Sidenav._sidenavs.indexOf(this);
                    if (index >= 0) Sidenav._sidenavs.splice(index, 1);
                }
            },
            {
                key: "_createOverlay",
                value: function _createOverlay() {
                    var overlay = document.createElement("div");
                    this._closeBound = this.close.bind(this);
                    overlay.classList.add("sidenav-overlay");
                    overlay.addEventListener("click", this._closeBound);
                    document.body.appendChild(overlay);
                    this._overlay = overlay;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    if (Sidenav._sidenavs.length === 0) document.body.addEventListener("click", this._handleTriggerClick);
                    this._handleDragTargetDragBound = this._handleDragTargetDrag.bind(this);
                    this._handleDragTargetReleaseBound = this._handleDragTargetRelease.bind(this);
                    this._handleCloseDragBound = this._handleCloseDrag.bind(this);
                    this._handleCloseReleaseBound = this._handleCloseRelease.bind(this);
                    this._handleCloseTriggerClickBound = this._handleCloseTriggerClick.bind(this);
                    this.dragTarget.addEventListener("touchmove", this._handleDragTargetDragBound);
                    this.dragTarget.addEventListener("touchend", this._handleDragTargetReleaseBound);
                    this._overlay.addEventListener("touchmove", this._handleCloseDragBound);
                    this._overlay.addEventListener("touchend", this._handleCloseReleaseBound);
                    this.el.addEventListener("touchmove", this._handleCloseDragBound);
                    this.el.addEventListener("touchend", this._handleCloseReleaseBound);
                    this.el.addEventListener("click", this._handleCloseTriggerClickBound);
                    // Add resize for side nav fixed
                    if (this.isFixed) {
                        this._handleWindowResizeBound = this._handleWindowResize.bind(this);
                        window.addEventListener("resize", this._handleWindowResizeBound);
                    }
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    if (Sidenav._sidenavs.length === 1) document.body.removeEventListener("click", this._handleTriggerClick);
                    this.dragTarget.removeEventListener("touchmove", this._handleDragTargetDragBound);
                    this.dragTarget.removeEventListener("touchend", this._handleDragTargetReleaseBound);
                    this._overlay.removeEventListener("touchmove", this._handleCloseDragBound);
                    this._overlay.removeEventListener("touchend", this._handleCloseReleaseBound);
                    this.el.removeEventListener("touchmove", this._handleCloseDragBound);
                    this.el.removeEventListener("touchend", this._handleCloseReleaseBound);
                    this.el.removeEventListener("click", this._handleCloseTriggerClickBound);
                    // Remove resize for side nav fixed
                    if (this.isFixed) window.removeEventListener("resize", this._handleWindowResizeBound);
                }
            },
            {
                key: "_handleTriggerClick",
                value: function _handleTriggerClick(e) {
                    var $trigger = $1(e.target).closest(".sidenav-trigger");
                    if (e.target && $trigger.length) {
                        var sidenavId = M.getIdFromTrigger($trigger[0]);
                        var sidenavInstance = document.getElementById(sidenavId).M_Sidenav;
                        if (sidenavInstance) sidenavInstance.open($trigger);
                        e.preventDefault();
                    }
                }
            },
            {
                key: "_startDrag",
                value: function _startDrag(e) {
                    var clientX = e.targetTouches[0].clientX;
                    this.isDragged = true;
                    this._startingXpos = clientX;
                    this._xPos = this._startingXpos;
                    this._time = Date.now();
                    this._width = this.el.getBoundingClientRect().width;
                    this._overlay.style.display = "block";
                    this._initialScrollTop = this.isOpen ? this.el.scrollTop : M.getDocumentScrollTop();
                    this._verticallyScrolling = false;
                    anim.remove(this.el);
                    anim.remove(this._overlay);
                }
            },
            {
                key: "_dragMoveUpdate",
                value: function _dragMoveUpdate(e) {
                    var clientX = e.targetTouches[0].clientX;
                    var currentScrollTop = this.isOpen ? this.el.scrollTop : M.getDocumentScrollTop();
                    this.deltaX = Math.abs(this._xPos - clientX);
                    this._xPos = clientX;
                    this.velocityX = this.deltaX / (Date.now() - this._time);
                    this._time = Date.now();
                    if (this._initialScrollTop !== currentScrollTop) this._verticallyScrolling = true;
                }
            },
            {
                key: "_handleDragTargetDrag",
                value: function _handleDragTargetDrag(e) {
                    // Check if draggable
                    if (!this.options.draggable || this._isCurrentlyFixed() || this._verticallyScrolling) return;
                    // If not being dragged, set initial drag start variables
                    if (!this.isDragged) this._startDrag(e);
                    // Run touchmove updates
                    this._dragMoveUpdate(e);
                    // Calculate raw deltaX
                    var totalDeltaX = this._xPos - this._startingXpos;
                    // dragDirection is the attempted user drag direction
                    var dragDirection = totalDeltaX > 0 ? "right" : "left";
                    // Don't allow totalDeltaX to exceed Sidenav width or be dragged in the opposite direction
                    totalDeltaX = Math.min(this._width, Math.abs(totalDeltaX));
                    if (this.options.edge === dragDirection) totalDeltaX = 0;
                    /**
         * transformX is the drag displacement
         * transformPrefix is the initial transform placement
         * Invert values if Sidenav is right edge
         */ var transformX = totalDeltaX;
                    var transformPrefix = "translateX(-100%)";
                    if (this.options.edge === "right") {
                        transformPrefix = "translateX(100%)";
                        transformX = -transformX;
                    }
                    // Calculate open/close percentage of sidenav, with open = 1 and close = 0
                    this.percentOpen = Math.min(1, totalDeltaX / this._width);
                    // Set transform and opacity styles
                    this.el.style.transform = transformPrefix + " translateX(" + transformX + "px)";
                    this._overlay.style.opacity = this.percentOpen;
                }
            },
            {
                key: "_handleDragTargetRelease",
                value: function _handleDragTargetRelease() {
                    if (this.isDragged) {
                        if (this.percentOpen > 0.2) this.open();
                        else this._animateOut();
                        this.isDragged = false;
                        this._verticallyScrolling = false;
                    }
                }
            },
            {
                key: "_handleCloseDrag",
                value: function _handleCloseDrag(e) {
                    if (this.isOpen) {
                        // Check if draggable
                        if (!this.options.draggable || this._isCurrentlyFixed() || this._verticallyScrolling) return;
                        // If not being dragged, set initial drag start variables
                        if (!this.isDragged) this._startDrag(e);
                        // Run touchmove updates
                        this._dragMoveUpdate(e);
                        // Calculate raw deltaX
                        var totalDeltaX = this._xPos - this._startingXpos;
                        // dragDirection is the attempted user drag direction
                        var dragDirection = totalDeltaX > 0 ? "right" : "left";
                        // Don't allow totalDeltaX to exceed Sidenav width or be dragged in the opposite direction
                        totalDeltaX = Math.min(this._width, Math.abs(totalDeltaX));
                        if (this.options.edge !== dragDirection) totalDeltaX = 0;
                        var transformX = -totalDeltaX;
                        if (this.options.edge === "right") transformX = -transformX;
                        // Calculate open/close percentage of sidenav, with open = 1 and close = 0
                        this.percentOpen = Math.min(1, 1 - totalDeltaX / this._width);
                        // Set transform and opacity styles
                        this.el.style.transform = "translateX(" + transformX + "px)";
                        this._overlay.style.opacity = this.percentOpen;
                    }
                }
            },
            {
                key: "_handleCloseRelease",
                value: function _handleCloseRelease() {
                    if (this.isOpen && this.isDragged) {
                        if (this.percentOpen > 0.8) this._animateIn();
                        else this.close();
                        this.isDragged = false;
                        this._verticallyScrolling = false;
                    }
                }
            },
            {
                key: "_handleCloseTriggerClick",
                value: function _handleCloseTriggerClick(e) {
                    var $closeTrigger = $1(e.target).closest(".sidenav-close");
                    if ($closeTrigger.length && !this._isCurrentlyFixed()) this.close();
                }
            },
            {
                key: "_handleWindowResize",
                value: function _handleWindowResize() {
                    // Only handle horizontal resizes
                    if (this.lastWindowWidth !== window.innerWidth) {
                        if (window.innerWidth > 992) this.open();
                        else this.close();
                    }
                    this.lastWindowWidth = window.innerWidth;
                    this.lastWindowHeight = window.innerHeight;
                }
            },
            {
                key: "_setupClasses",
                value: function _setupClasses() {
                    if (this.options.edge === "right") {
                        this.el.classList.add("right-aligned");
                        this.dragTarget.classList.add("right-aligned");
                    }
                }
            },
            {
                key: "_removeClasses",
                value: function _removeClasses() {
                    this.el.classList.remove("right-aligned");
                    this.dragTarget.classList.remove("right-aligned");
                }
            },
            {
                key: "_setupFixed",
                value: function _setupFixed() {
                    if (this._isCurrentlyFixed()) this.open();
                }
            },
            {
                key: "_isCurrentlyFixed",
                value: function _isCurrentlyFixed() {
                    return this.isFixed && window.innerWidth > 992;
                }
            },
            {
                key: "_createDragTarget",
                value: function _createDragTarget() {
                    var dragTarget = document.createElement("div");
                    dragTarget.classList.add("drag-target");
                    document.body.appendChild(dragTarget);
                    this.dragTarget = dragTarget;
                }
            },
            {
                key: "_preventBodyScrolling",
                value: function _preventBodyScrolling() {
                    var body = document.body;
                    body.style.overflow = "hidden";
                }
            },
            {
                key: "_enableBodyScrolling",
                value: function _enableBodyScrolling() {
                    var body = document.body;
                    body.style.overflow = "";
                }
            },
            {
                key: "open",
                value: function open() {
                    if (this.isOpen === true) return;
                    this.isOpen = true;
                    // Run onOpenStart callback
                    if (typeof this.options.onOpenStart === "function") this.options.onOpenStart.call(this, this.el);
                    // Handle fixed Sidenav
                    if (this._isCurrentlyFixed()) {
                        anim.remove(this.el);
                        anim({
                            targets: this.el,
                            translateX: 0,
                            duration: 0,
                            easing: "easeOutQuad"
                        });
                        this._enableBodyScrolling();
                        this._overlay.style.display = "none";
                    // Handle non-fixed Sidenav
                    } else {
                        if (this.options.preventScrolling) this._preventBodyScrolling();
                        if (!this.isDragged || this.percentOpen != 1) this._animateIn();
                    }
                }
            },
            {
                key: "close",
                value: function close() {
                    if (this.isOpen === false) return;
                    this.isOpen = false;
                    // Run onCloseStart callback
                    if (typeof this.options.onCloseStart === "function") this.options.onCloseStart.call(this, this.el);
                    // Handle fixed Sidenav
                    if (this._isCurrentlyFixed()) {
                        var transformX = this.options.edge === "left" ? "-105%" : "105%";
                        this.el.style.transform = "translateX(" + transformX + ")";
                    // Handle non-fixed Sidenav
                    } else {
                        this._enableBodyScrolling();
                        if (!this.isDragged || this.percentOpen != 0) this._animateOut();
                        else this._overlay.style.display = "none";
                    }
                }
            },
            {
                key: "_animateIn",
                value: function _animateIn() {
                    this._animateSidenavIn();
                    this._animateOverlayIn();
                }
            },
            {
                key: "_animateSidenavIn",
                value: function _animateSidenavIn() {
                    var _this32 = this;
                    var slideOutPercent = this.options.edge === "left" ? -1 : 1;
                    if (this.isDragged) slideOutPercent = this.options.edge === "left" ? slideOutPercent + this.percentOpen : slideOutPercent - this.percentOpen;
                    anim.remove(this.el);
                    anim({
                        targets: this.el,
                        translateX: [
                            slideOutPercent * 100 + "%",
                            0
                        ],
                        duration: this.options.inDuration,
                        easing: "easeOutQuad",
                        complete: function() {
                            // Run onOpenEnd callback
                            if (typeof _this32.options.onOpenEnd === "function") _this32.options.onOpenEnd.call(_this32, _this32.el);
                        }
                    });
                }
            },
            {
                key: "_animateOverlayIn",
                value: function _animateOverlayIn() {
                    var start = 0;
                    if (this.isDragged) start = this.percentOpen;
                    else $1(this._overlay).css({
                        display: "block"
                    });
                    anim.remove(this._overlay);
                    anim({
                        targets: this._overlay,
                        opacity: [
                            start,
                            1
                        ],
                        duration: this.options.inDuration,
                        easing: "easeOutQuad"
                    });
                }
            },
            {
                key: "_animateOut",
                value: function _animateOut() {
                    this._animateSidenavOut();
                    this._animateOverlayOut();
                }
            },
            {
                key: "_animateSidenavOut",
                value: function _animateSidenavOut() {
                    var _this33 = this;
                    var endPercent = this.options.edge === "left" ? -1 : 1;
                    var slideOutPercent = 0;
                    if (this.isDragged) slideOutPercent = this.options.edge === "left" ? endPercent + this.percentOpen : endPercent - this.percentOpen;
                    anim.remove(this.el);
                    anim({
                        targets: this.el,
                        translateX: [
                            slideOutPercent * 100 + "%",
                            endPercent * 105 + "%"
                        ],
                        duration: this.options.outDuration,
                        easing: "easeOutQuad",
                        complete: function() {
                            // Run onOpenEnd callback
                            if (typeof _this33.options.onCloseEnd === "function") _this33.options.onCloseEnd.call(_this33, _this33.el);
                        }
                    });
                }
            },
            {
                key: "_animateOverlayOut",
                value: function _animateOverlayOut() {
                    var _this34 = this;
                    anim.remove(this._overlay);
                    anim({
                        targets: this._overlay,
                        opacity: 0,
                        duration: this.options.outDuration,
                        easing: "easeOutQuad",
                        complete: function() {
                            $1(_this34._overlay).css("display", "none");
                        }
                    });
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Sidenav.__proto__ || Object.getPrototypeOf(Sidenav), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Sidenav;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Sidenav;
    }(Component);
    /**
   * @static
   * @memberof Sidenav
   * @type {Array.<Sidenav>}
   */ Sidenav._sidenavs = [];
    M.Sidenav = Sidenav;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Sidenav, "sidenav", "M_Sidenav");
})(cash, M.anime);
(function($1, anim) {
    "use strict";
    var _defaults = {
        throttle: 100,
        scrollOffset: 200,
        activeClass: "active",
        getActiveElement: function(id) {
            return 'a[href="#' + id + '"]';
        }
    };
    /**
   * @class
   *
   */ var ScrollSpy = function(_Component9) {
        _inherits(ScrollSpy, _Component9);
        /**
     * Construct ScrollSpy instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function ScrollSpy(el, options) {
            _classCallCheck(this, ScrollSpy);
            var _this35 = _possibleConstructorReturn(this, (ScrollSpy.__proto__ || Object.getPrototypeOf(ScrollSpy)).call(this, ScrollSpy, el, options));
            _this35.el.M_ScrollSpy = _this35;
            /**
       * Options for the modal
       * @member Modal#options
       * @prop {Number} [throttle=100] - Throttle of scroll handler
       * @prop {Number} [scrollOffset=200] - Offset for centering element when scrolled to
       * @prop {String} [activeClass='active'] - Class applied to active elements
       * @prop {Function} [getActiveElement] - Used to find active element
       */ _this35.options = $1.extend({}, ScrollSpy.defaults, options);
            // setup
            ScrollSpy._elements.push(_this35);
            ScrollSpy._count++;
            ScrollSpy._increment++;
            _this35.tickId = -1;
            _this35.id = ScrollSpy._increment;
            _this35._setupEventHandlers();
            _this35._handleWindowScroll();
            return _this35;
        }
        _createClass(ScrollSpy, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    ScrollSpy._elements.splice(ScrollSpy._elements.indexOf(this), 1);
                    ScrollSpy._elementsInView.splice(ScrollSpy._elementsInView.indexOf(this), 1);
                    ScrollSpy._visibleElements.splice(ScrollSpy._visibleElements.indexOf(this.$el), 1);
                    ScrollSpy._count--;
                    this._removeEventHandlers();
                    $1(this.options.getActiveElement(this.$el.attr("id"))).removeClass(this.options.activeClass);
                    this.el.M_ScrollSpy = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    var throttledResize = M.throttle(this._handleWindowScroll, 200);
                    this._handleThrottledResizeBound = throttledResize.bind(this);
                    this._handleWindowScrollBound = this._handleWindowScroll.bind(this);
                    if (ScrollSpy._count === 1) {
                        window.addEventListener("scroll", this._handleWindowScrollBound);
                        window.addEventListener("resize", this._handleThrottledResizeBound);
                        document.body.addEventListener("click", this._handleTriggerClick);
                    }
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    if (ScrollSpy._count === 0) {
                        window.removeEventListener("scroll", this._handleWindowScrollBound);
                        window.removeEventListener("resize", this._handleThrottledResizeBound);
                        document.body.removeEventListener("click", this._handleTriggerClick);
                    }
                }
            },
            {
                key: "_handleTriggerClick",
                value: function _handleTriggerClick(e) {
                    var $trigger = $1(e.target);
                    for(var i = ScrollSpy._elements.length - 1; i >= 0; i--){
                        var scrollspy = ScrollSpy._elements[i];
                        if ($trigger.is('a[href="#' + scrollspy.$el.attr("id") + '"]')) {
                            e.preventDefault();
                            var offset = scrollspy.$el.offset().top + 1;
                            anim({
                                targets: [
                                    document.documentElement,
                                    document.body
                                ],
                                scrollTop: offset - scrollspy.options.scrollOffset,
                                duration: 400,
                                easing: "easeOutCubic"
                            });
                            break;
                        }
                    }
                }
            },
            {
                key: "_handleWindowScroll",
                value: function _handleWindowScroll() {
                    // unique tick id
                    ScrollSpy._ticks++;
                    // viewport rectangle
                    var top = M.getDocumentScrollTop(), left = M.getDocumentScrollLeft(), right = left + window.innerWidth, bottom = top + window.innerHeight;
                    // determine which elements are in view
                    var intersections = ScrollSpy._findElements(top, right, bottom, left);
                    for(var i = 0; i < intersections.length; i++){
                        var scrollspy = intersections[i];
                        var lastTick = scrollspy.tickId;
                        if (lastTick < 0) // entered into view
                        scrollspy._enter();
                        // update tick id
                        scrollspy.tickId = ScrollSpy._ticks;
                    }
                    for(var _i = 0; _i < ScrollSpy._elementsInView.length; _i++){
                        var _scrollspy = ScrollSpy._elementsInView[_i];
                        var _lastTick = _scrollspy.tickId;
                        if (_lastTick >= 0 && _lastTick !== ScrollSpy._ticks) {
                            // exited from view
                            _scrollspy._exit();
                            _scrollspy.tickId = -1;
                        }
                    }
                    // remember elements in view for next tick
                    ScrollSpy._elementsInView = intersections;
                }
            },
            {
                key: "_enter",
                value: function _enter() {
                    ScrollSpy._visibleElements = ScrollSpy._visibleElements.filter(function(value) {
                        return value.height() != 0;
                    });
                    if (ScrollSpy._visibleElements[0]) {
                        $1(this.options.getActiveElement(ScrollSpy._visibleElements[0].attr("id"))).removeClass(this.options.activeClass);
                        if (ScrollSpy._visibleElements[0][0].M_ScrollSpy && this.id < ScrollSpy._visibleElements[0][0].M_ScrollSpy.id) ScrollSpy._visibleElements.unshift(this.$el);
                        else ScrollSpy._visibleElements.push(this.$el);
                    } else ScrollSpy._visibleElements.push(this.$el);
                    $1(this.options.getActiveElement(ScrollSpy._visibleElements[0].attr("id"))).addClass(this.options.activeClass);
                }
            },
            {
                key: "_exit",
                value: function _exit() {
                    var _this36 = this;
                    ScrollSpy._visibleElements = ScrollSpy._visibleElements.filter(function(value) {
                        return value.height() != 0;
                    });
                    if (ScrollSpy._visibleElements[0]) {
                        $1(this.options.getActiveElement(ScrollSpy._visibleElements[0].attr("id"))).removeClass(this.options.activeClass);
                        ScrollSpy._visibleElements = ScrollSpy._visibleElements.filter(function(el) {
                            return el.attr("id") != _this36.$el.attr("id");
                        });
                        if (ScrollSpy._visibleElements[0]) // Check if empty
                        $1(this.options.getActiveElement(ScrollSpy._visibleElements[0].attr("id"))).addClass(this.options.activeClass);
                    }
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(ScrollSpy.__proto__ || Object.getPrototypeOf(ScrollSpy), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_ScrollSpy;
                }
            },
            {
                key: "_findElements",
                value: function _findElements(top, right, bottom, left) {
                    var hits = [];
                    for(var i = 0; i < ScrollSpy._elements.length; i++){
                        var scrollspy = ScrollSpy._elements[i];
                        var currTop = top + scrollspy.options.scrollOffset || 200;
                        if (scrollspy.$el.height() > 0) {
                            var elTop = scrollspy.$el.offset().top, elLeft = scrollspy.$el.offset().left, elRight = elLeft + scrollspy.$el.width(), elBottom = elTop + scrollspy.$el.height();
                            var isIntersect = !(elLeft > right || elRight < left || elTop > bottom || elBottom < currTop);
                            if (isIntersect) hits.push(scrollspy);
                        }
                    }
                    return hits;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return ScrollSpy;
    }(Component);
    /**
   * @static
   * @memberof ScrollSpy
   * @type {Array.<ScrollSpy>}
   */ ScrollSpy._elements = [];
    /**
   * @static
   * @memberof ScrollSpy
   * @type {Array.<ScrollSpy>}
   */ ScrollSpy._elementsInView = [];
    /**
   * @static
   * @memberof ScrollSpy
   * @type {Array.<cash>}
   */ ScrollSpy._visibleElements = [];
    /**
   * @static
   * @memberof ScrollSpy
   */ ScrollSpy._count = 0;
    /**
   * @static
   * @memberof ScrollSpy
   */ ScrollSpy._increment = 0;
    /**
   * @static
   * @memberof ScrollSpy
   */ ScrollSpy._ticks = 0;
    M.ScrollSpy = ScrollSpy;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(ScrollSpy, "scrollSpy", "M_ScrollSpy");
})(cash, M.anime);
(function($1) {
    "use strict";
    var _defaults = {
        data: {},
        limit: Infinity,
        onAutocomplete: null,
        minLength: 1,
        sortFunction: function(a, b, inputString) {
            // Sort function for sorting autocomplete results
            return a.indexOf(inputString) - b.indexOf(inputString);
        }
    };
    /**
   * @class
   *
   */ var Autocomplete = function(_Component10) {
        _inherits(Autocomplete, _Component10);
        /**
     * Construct Autocomplete instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function Autocomplete(el, options) {
            _classCallCheck(this, Autocomplete);
            var _this37 = _possibleConstructorReturn(this, (Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete)).call(this, Autocomplete, el, options));
            _this37.el.M_Autocomplete = _this37;
            /**
       * Options for the autocomplete
       * @member Autocomplete#options
       * @prop {Number} duration
       * @prop {Number} dist
       * @prop {number} shift
       * @prop {number} padding
       * @prop {Boolean} fullWidth
       * @prop {Boolean} indicators
       * @prop {Boolean} noWrap
       * @prop {Function} onCycleTo
       */ _this37.options = $1.extend({}, Autocomplete.defaults, options);
            // Setup
            _this37.isOpen = false;
            _this37.count = 0;
            _this37.activeIndex = -1;
            _this37.oldVal;
            _this37.$inputField = _this37.$el.closest(".input-field");
            _this37.$active = $1();
            _this37._mousedown = false;
            _this37._setupDropdown();
            _this37._setupEventHandlers();
            return _this37;
        }
        _createClass(Autocomplete, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this._removeEventHandlers();
                    this._removeDropdown();
                    this.el.M_Autocomplete = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    this._handleInputBlurBound = this._handleInputBlur.bind(this);
                    this._handleInputKeyupAndFocusBound = this._handleInputKeyupAndFocus.bind(this);
                    this._handleInputKeydownBound = this._handleInputKeydown.bind(this);
                    this._handleInputClickBound = this._handleInputClick.bind(this);
                    this._handleContainerMousedownAndTouchstartBound = this._handleContainerMousedownAndTouchstart.bind(this);
                    this._handleContainerMouseupAndTouchendBound = this._handleContainerMouseupAndTouchend.bind(this);
                    this.el.addEventListener("blur", this._handleInputBlurBound);
                    this.el.addEventListener("keyup", this._handleInputKeyupAndFocusBound);
                    this.el.addEventListener("focus", this._handleInputKeyupAndFocusBound);
                    this.el.addEventListener("keydown", this._handleInputKeydownBound);
                    this.el.addEventListener("click", this._handleInputClickBound);
                    this.container.addEventListener("mousedown", this._handleContainerMousedownAndTouchstartBound);
                    this.container.addEventListener("mouseup", this._handleContainerMouseupAndTouchendBound);
                    if (typeof window.ontouchstart !== "undefined") {
                        this.container.addEventListener("touchstart", this._handleContainerMousedownAndTouchstartBound);
                        this.container.addEventListener("touchend", this._handleContainerMouseupAndTouchendBound);
                    }
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    this.el.removeEventListener("blur", this._handleInputBlurBound);
                    this.el.removeEventListener("keyup", this._handleInputKeyupAndFocusBound);
                    this.el.removeEventListener("focus", this._handleInputKeyupAndFocusBound);
                    this.el.removeEventListener("keydown", this._handleInputKeydownBound);
                    this.el.removeEventListener("click", this._handleInputClickBound);
                    this.container.removeEventListener("mousedown", this._handleContainerMousedownAndTouchstartBound);
                    this.container.removeEventListener("mouseup", this._handleContainerMouseupAndTouchendBound);
                    if (typeof window.ontouchstart !== "undefined") {
                        this.container.removeEventListener("touchstart", this._handleContainerMousedownAndTouchstartBound);
                        this.container.removeEventListener("touchend", this._handleContainerMouseupAndTouchendBound);
                    }
                }
            },
            {
                key: "_setupDropdown",
                value: function _setupDropdown() {
                    var _this38 = this;
                    this.container = document.createElement("ul");
                    this.container.id = "autocomplete-options-" + M.guid();
                    $1(this.container).addClass("autocomplete-content dropdown-content");
                    this.$inputField.append(this.container);
                    this.el.setAttribute("data-target", this.container.id);
                    this.dropdown = M.Dropdown.init(this.el, {
                        autoFocus: false,
                        closeOnClick: false,
                        coverTrigger: false,
                        onItemClick: function(itemEl) {
                            _this38.selectOption($1(itemEl));
                        }
                    });
                    // Sketchy removal of dropdown click handler
                    this.el.removeEventListener("click", this.dropdown._handleClickBound);
                }
            },
            {
                key: "_removeDropdown",
                value: function _removeDropdown() {
                    this.container.parentNode.removeChild(this.container);
                }
            },
            {
                key: "_handleInputBlur",
                value: function _handleInputBlur() {
                    if (!this._mousedown) {
                        this.close();
                        this._resetAutocomplete();
                    }
                }
            },
            {
                key: "_handleInputKeyupAndFocus",
                value: function _handleInputKeyupAndFocus(e) {
                    if (e.type === "keyup") Autocomplete._keydown = false;
                    this.count = 0;
                    var val = this.el.value.toLowerCase();
                    // Don't capture enter or arrow key usage.
                    if (e.keyCode === 13 || e.keyCode === 38 || e.keyCode === 40) return;
                    // Check if the input isn't empty
                    // Check if focus triggered by tab
                    if (this.oldVal !== val && (M.tabPressed || e.type !== "focus")) this.open();
                    // Update oldVal
                    this.oldVal = val;
                }
            },
            {
                key: "_handleInputKeydown",
                value: function _handleInputKeydown(e) {
                    Autocomplete._keydown = true;
                    // Arrow keys and enter key usage
                    var keyCode = e.keyCode, liElement = void 0, numItems = $1(this.container).children("li").length;
                    // select element on Enter
                    if (keyCode === M.keys.ENTER && this.activeIndex >= 0) {
                        liElement = $1(this.container).children("li").eq(this.activeIndex);
                        if (liElement.length) {
                            this.selectOption(liElement);
                            e.preventDefault();
                        }
                        return;
                    }
                    // Capture up and down key
                    if (keyCode === M.keys.ARROW_UP || keyCode === M.keys.ARROW_DOWN) {
                        e.preventDefault();
                        if (keyCode === M.keys.ARROW_UP && this.activeIndex > 0) this.activeIndex--;
                        if (keyCode === M.keys.ARROW_DOWN && this.activeIndex < numItems - 1) this.activeIndex++;
                        this.$active.removeClass("active");
                        if (this.activeIndex >= 0) {
                            this.$active = $1(this.container).children("li").eq(this.activeIndex);
                            this.$active.addClass("active");
                        }
                    }
                }
            },
            {
                key: "_handleInputClick",
                value: function _handleInputClick(e) {
                    this.open();
                }
            },
            {
                key: "_handleContainerMousedownAndTouchstart",
                value: function _handleContainerMousedownAndTouchstart(e) {
                    this._mousedown = true;
                }
            },
            {
                key: "_handleContainerMouseupAndTouchend",
                value: function _handleContainerMouseupAndTouchend(e) {
                    this._mousedown = false;
                }
            },
            {
                key: "_highlight",
                value: function _highlight(string, $el) {
                    var img = $el.find("img");
                    var matchStart = $el.text().toLowerCase().indexOf("" + string.toLowerCase() + ""), matchEnd = matchStart + string.length - 1, beforeMatch = $el.text().slice(0, matchStart), matchText = $el.text().slice(matchStart, matchEnd + 1), afterMatch = $el.text().slice(matchEnd + 1);
                    $el.html("<span>" + beforeMatch + "<span class='highlight'>" + matchText + "</span>" + afterMatch + "</span>");
                    if (img.length) $el.prepend(img);
                }
            },
            {
                key: "_resetCurrentElement",
                value: function _resetCurrentElement() {
                    this.activeIndex = -1;
                    this.$active.removeClass("active");
                }
            },
            {
                key: "_resetAutocomplete",
                value: function _resetAutocomplete() {
                    $1(this.container).empty();
                    this._resetCurrentElement();
                    this.oldVal = null;
                    this.isOpen = false;
                    this._mousedown = false;
                }
            },
            {
                key: "selectOption",
                value: function selectOption(el) {
                    var text = el.text().trim();
                    this.el.value = text;
                    this.$el.trigger("change");
                    this._resetAutocomplete();
                    this.close();
                    // Handle onAutocomplete callback.
                    if (typeof this.options.onAutocomplete === "function") this.options.onAutocomplete.call(this, text);
                }
            },
            {
                key: "_renderDropdown",
                value: function _renderDropdown(data, val) {
                    var _this39 = this;
                    this._resetAutocomplete();
                    var matchingData = [];
                    // Gather all matching data
                    for(var key in data)if (data.hasOwnProperty(key) && key.toLowerCase().indexOf(val) !== -1) {
                        // Break if past limit
                        if (this.count >= this.options.limit) break;
                        var entry = {
                            data: data[key],
                            key: key
                        };
                        matchingData.push(entry);
                        this.count++;
                    }
                    // Sort
                    if (this.options.sortFunction) {
                        var sortFunctionBound = function(a, b) {
                            return _this39.options.sortFunction(a.key.toLowerCase(), b.key.toLowerCase(), val.toLowerCase());
                        };
                        matchingData.sort(sortFunctionBound);
                    }
                    // Render
                    for(var i = 0; i < matchingData.length; i++){
                        var _entry = matchingData[i];
                        var $autocompleteOption = $1("<li></li>");
                        if (!!_entry.data) $autocompleteOption.append('<img src="' + _entry.data + '" class="right circle"><span>' + _entry.key + "</span>");
                        else $autocompleteOption.append("<span>" + _entry.key + "</span>");
                        $1(this.container).append($autocompleteOption);
                        this._highlight(val, $autocompleteOption);
                    }
                }
            },
            {
                key: "open",
                value: function open() {
                    var val = this.el.value.toLowerCase();
                    this._resetAutocomplete();
                    if (val.length >= this.options.minLength) {
                        this.isOpen = true;
                        this._renderDropdown(this.options.data, val);
                    }
                    // Open dropdown
                    if (!this.dropdown.isOpen) this.dropdown.open();
                    else // Recalculate dropdown when its already open
                    this.dropdown.recalculateDimensions();
                }
            },
            {
                key: "close",
                value: function close() {
                    this.dropdown.close();
                }
            },
            {
                key: "updateData",
                value: function updateData(data) {
                    var val = this.el.value.toLowerCase();
                    this.options.data = data;
                    if (this.isOpen) this._renderDropdown(data, val);
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Autocomplete.__proto__ || Object.getPrototypeOf(Autocomplete), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Autocomplete;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Autocomplete;
    }(Component);
    /**
   * @static
   * @memberof Autocomplete
   */ Autocomplete._keydown = false;
    M.Autocomplete = Autocomplete;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Autocomplete, "autocomplete", "M_Autocomplete");
})(cash);
(function($1) {
    // Function to update labels of text fields
    M.updateTextFields = function() {
        var input_selector = "input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], input[type=date], input[type=time], textarea";
        $1(input_selector).each(function(element, index) {
            var $this = $1(this);
            if (element.value.length > 0 || $1(element).is(":focus") || element.autofocus || $this.attr("placeholder") !== null) $this.siblings("label").addClass("active");
            else if (element.validity) $this.siblings("label").toggleClass("active", element.validity.badInput === true);
            else $this.siblings("label").removeClass("active");
        });
    };
    M.validate_field = function(object) {
        var hasLength = object.attr("data-length") !== null;
        var lenAttr = parseInt(object.attr("data-length"));
        var len = object[0].value.length;
        if (len === 0 && object[0].validity.badInput === false && !object.is(":required")) {
            if (object.hasClass("validate")) {
                object.removeClass("valid");
                object.removeClass("invalid");
            }
        } else if (object.hasClass("validate")) {
            // Check for character counter attributes
            if (object.is(":valid") && hasLength && len <= lenAttr || object.is(":valid") && !hasLength) {
                object.removeClass("invalid");
                object.addClass("valid");
            } else {
                object.removeClass("valid");
                object.addClass("invalid");
            }
        }
    };
    M.textareaAutoResize = function($textarea) {
        // Wrap if native element
        if ($textarea instanceof Element) $textarea = $1($textarea);
        if (!$textarea.length) {
            console.error("No textarea element found");
            return;
        }
        // Textarea Auto Resize
        var hiddenDiv = $1(".hiddendiv").first();
        if (!hiddenDiv.length) {
            hiddenDiv = $1('<div class="hiddendiv common"></div>');
            $1("body").append(hiddenDiv);
        }
        // Set font properties of hiddenDiv
        var fontFamily = $textarea.css("font-family");
        var fontSize = $textarea.css("font-size");
        var lineHeight = $textarea.css("line-height");
        // Firefox can't handle padding shorthand.
        var paddingTop = $textarea.css("padding-top");
        var paddingRight = $textarea.css("padding-right");
        var paddingBottom = $textarea.css("padding-bottom");
        var paddingLeft = $textarea.css("padding-left");
        if (fontSize) hiddenDiv.css("font-size", fontSize);
        if (fontFamily) hiddenDiv.css("font-family", fontFamily);
        if (lineHeight) hiddenDiv.css("line-height", lineHeight);
        if (paddingTop) hiddenDiv.css("padding-top", paddingTop);
        if (paddingRight) hiddenDiv.css("padding-right", paddingRight);
        if (paddingBottom) hiddenDiv.css("padding-bottom", paddingBottom);
        if (paddingLeft) hiddenDiv.css("padding-left", paddingLeft);
        // Set original-height, if none
        if (!$textarea.data("original-height")) $textarea.data("original-height", $textarea.height());
        if ($textarea.attr("wrap") === "off") hiddenDiv.css("overflow-wrap", "normal").css("white-space", "pre");
        hiddenDiv.text($textarea[0].value + "\n");
        var content = hiddenDiv.html().replace(/\n/g, "<br>");
        hiddenDiv.html(content);
        // When textarea is hidden, width goes crazy.
        // Approximate with half of window size
        if ($textarea[0].offsetWidth > 0 && $textarea[0].offsetHeight > 0) hiddenDiv.css("width", $textarea.width() + "px");
        else hiddenDiv.css("width", window.innerWidth / 2 + "px");
        /**
     * Resize if the new height is greater than the
     * original height of the textarea
     */ if ($textarea.data("original-height") <= hiddenDiv.innerHeight()) $textarea.css("height", hiddenDiv.innerHeight() + "px");
        else if ($textarea[0].value.length < $textarea.data("previous-length")) /**
       * In case the new height is less than original height, it
       * means the textarea has less text than before
       * So we set the height to the original one
       */ $textarea.css("height", $textarea.data("original-height") + "px");
        $textarea.data("previous-length", $textarea[0].value.length);
    };
    $1(document).ready(function() {
        // Text based inputs
        var input_selector = "input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], input[type=date], input[type=time], textarea";
        // Add active if form auto complete
        $1(document).on("change", input_selector, function() {
            if (this.value.length !== 0 || $1(this).attr("placeholder") !== null) $1(this).siblings("label").addClass("active");
            M.validate_field($1(this));
        });
        // Add active if input element has been pre-populated on document ready
        $1(document).ready(function() {
            M.updateTextFields();
        });
        // HTML DOM FORM RESET handling
        $1(document).on("reset", function(e) {
            var formReset = $1(e.target);
            if (formReset.is("form")) {
                formReset.find(input_selector).removeClass("valid").removeClass("invalid");
                formReset.find(input_selector).each(function(e) {
                    if (this.value.length) $1(this).siblings("label").removeClass("active");
                });
                // Reset select (after native reset)
                setTimeout(function() {
                    formReset.find("select").each(function() {
                        // check if initialized
                        if (this.M_FormSelect) $1(this).trigger("change");
                    });
                }, 0);
            }
        });
        /**
     * Add active when element has focus
     * @param {Event} e
     */ document.addEventListener("focus", function(e) {
            if ($1(e.target).is(input_selector)) $1(e.target).siblings("label, .prefix").addClass("active");
        }, true);
        /**
     * Remove active when element is blurred
     * @param {Event} e
     */ document.addEventListener("blur", function(e) {
            var $inputElement = $1(e.target);
            if ($inputElement.is(input_selector)) {
                var selector = ".prefix";
                if ($inputElement[0].value.length === 0 && $inputElement[0].validity.badInput !== true && $inputElement.attr("placeholder") === null) selector += ", label";
                $inputElement.siblings(selector).removeClass("active");
                M.validate_field($inputElement);
            }
        }, true);
        // Radio and Checkbox focus class
        var radio_checkbox = "input[type=radio], input[type=checkbox]";
        $1(document).on("keyup", radio_checkbox, function(e) {
            // TAB, check if tabbing to radio or checkbox.
            if (e.which === M.keys.TAB) {
                $1(this).addClass("tabbed");
                var $this = $1(this);
                $this.one("blur", function(e) {
                    $1(this).removeClass("tabbed");
                });
                return;
            }
        });
        var text_area_selector = ".materialize-textarea";
        $1(text_area_selector).each(function() {
            var $textarea = $1(this);
            /**
       * Resize textarea on document load after storing
       * the original height and the original length
       */ $textarea.data("original-height", $textarea.height());
            $textarea.data("previous-length", this.value.length);
            M.textareaAutoResize($textarea);
        });
        $1(document).on("keyup", text_area_selector, function() {
            M.textareaAutoResize($1(this));
        });
        $1(document).on("keydown", text_area_selector, function() {
            M.textareaAutoResize($1(this));
        });
        // File Input Path
        $1(document).on("change", '.file-field input[type="file"]', function() {
            var file_field = $1(this).closest(".file-field");
            var path_input = file_field.find("input.file-path");
            var files = $1(this)[0].files;
            var file_names = [];
            for(var i = 0; i < files.length; i++)file_names.push(files[i].name);
            path_input[0].value = file_names.join(", ");
            path_input.trigger("change");
        });
    }); // End of $(document).ready
})(cash);
(function($1, anim) {
    "use strict";
    var _defaults = {
        indicators: true,
        height: 400,
        duration: 500,
        interval: 6000
    };
    /**
   * @class
   *
   */ var Slider = function(_Component11) {
        _inherits(Slider, _Component11);
        /**
     * Construct Slider instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function Slider(el, options) {
            _classCallCheck(this, Slider);
            var _this40 = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, Slider, el, options));
            _this40.el.M_Slider = _this40;
            /**
       * Options for the modal
       * @member Slider#options
       * @prop {Boolean} [indicators=true] - Show indicators
       * @prop {Number} [height=400] - height of slider
       * @prop {Number} [duration=500] - Length in ms of slide transition
       * @prop {Number} [interval=6000] - Length in ms of slide interval
       */ _this40.options = $1.extend({}, Slider.defaults, options);
            // setup
            _this40.$slider = _this40.$el.find(".slides");
            _this40.$slides = _this40.$slider.children("li");
            _this40.activeIndex = _this40.$slides.filter(function(item) {
                return $1(item).hasClass("active");
            }).first().index();
            if (_this40.activeIndex != -1) _this40.$active = _this40.$slides.eq(_this40.activeIndex);
            _this40._setSliderHeight();
            // Set initial positions of captions
            _this40.$slides.find(".caption").each(function(el) {
                _this40._animateCaptionIn(el, 0);
            });
            // Move img src into background-image
            _this40.$slides.find("img").each(function(el) {
                var placeholderBase64 = "data:image/gif;base64,R0lGODlhAQABAIABAP///wAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
                if ($1(el).attr("src") !== placeholderBase64) {
                    $1(el).css("background-image", 'url("' + $1(el).attr("src") + '")');
                    $1(el).attr("src", placeholderBase64);
                }
            });
            _this40._setupIndicators();
            // Show active slide
            if (_this40.$active) _this40.$active.css("display", "block");
            else {
                _this40.$slides.first().addClass("active");
                anim({
                    targets: _this40.$slides.first()[0],
                    opacity: 1,
                    duration: _this40.options.duration,
                    easing: "easeOutQuad"
                });
                _this40.activeIndex = 0;
                _this40.$active = _this40.$slides.eq(_this40.activeIndex);
                // Update indicators
                if (_this40.options.indicators) _this40.$indicators.eq(_this40.activeIndex).addClass("active");
            }
            // Adjust height to current slide
            _this40.$active.find("img").each(function(el) {
                anim({
                    targets: _this40.$active.find(".caption")[0],
                    opacity: 1,
                    translateX: 0,
                    translateY: 0,
                    duration: _this40.options.duration,
                    easing: "easeOutQuad"
                });
            });
            _this40._setupEventHandlers();
            // auto scroll
            _this40.start();
            return _this40;
        }
        _createClass(Slider, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this.pause();
                    this._removeIndicators();
                    this._removeEventHandlers();
                    this.el.M_Slider = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    var _this41 = this;
                    this._handleIntervalBound = this._handleInterval.bind(this);
                    this._handleIndicatorClickBound = this._handleIndicatorClick.bind(this);
                    if (this.options.indicators) this.$indicators.each(function(el) {
                        el.addEventListener("click", _this41._handleIndicatorClickBound);
                    });
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    var _this42 = this;
                    if (this.options.indicators) this.$indicators.each(function(el) {
                        el.removeEventListener("click", _this42._handleIndicatorClickBound);
                    });
                }
            },
            {
                key: "_handleIndicatorClick",
                value: function _handleIndicatorClick(e) {
                    var currIndex = $1(e.target).index();
                    this.set(currIndex);
                }
            },
            {
                key: "_handleInterval",
                value: function _handleInterval() {
                    var newActiveIndex = this.$slider.find(".active").index();
                    if (this.$slides.length === newActiveIndex + 1) newActiveIndex = 0;
                    else newActiveIndex += 1;
                    this.set(newActiveIndex);
                }
            },
            {
                key: "_animateCaptionIn",
                value: function _animateCaptionIn(caption, duration) {
                    var animOptions = {
                        targets: caption,
                        opacity: 0,
                        duration: duration,
                        easing: "easeOutQuad"
                    };
                    if ($1(caption).hasClass("center-align")) animOptions.translateY = -100;
                    else if ($1(caption).hasClass("right-align")) animOptions.translateX = 100;
                    else if ($1(caption).hasClass("left-align")) animOptions.translateX = -100;
                    anim(animOptions);
                }
            },
            {
                key: "_setSliderHeight",
                value: function _setSliderHeight() {
                    // If fullscreen, do nothing
                    if (!this.$el.hasClass("fullscreen")) {
                        if (this.options.indicators) // Add height if indicators are present
                        this.$el.css("height", this.options.height + 40 + "px");
                        else this.$el.css("height", this.options.height + "px");
                        this.$slider.css("height", this.options.height + "px");
                    }
                }
            },
            {
                key: "_setupIndicators",
                value: function _setupIndicators() {
                    var _this43 = this;
                    if (this.options.indicators) {
                        this.$indicators = $1('<ul class="indicators"></ul>');
                        this.$slides.each(function(el, index) {
                            var $indicator = $1('<li class="indicator-item"></li>');
                            _this43.$indicators.append($indicator[0]);
                        });
                        this.$el.append(this.$indicators[0]);
                        this.$indicators = this.$indicators.children("li.indicator-item");
                    }
                }
            },
            {
                key: "_removeIndicators",
                value: function _removeIndicators() {
                    this.$el.find("ul.indicators").remove();
                }
            },
            {
                key: "set",
                value: function set(index) {
                    var _this44 = this;
                    // Wrap around indices.
                    if (index >= this.$slides.length) index = 0;
                    else if (index < 0) index = this.$slides.length - 1;
                    // Only do if index changes
                    if (this.activeIndex != index) {
                        this.$active = this.$slides.eq(this.activeIndex);
                        var $caption = this.$active.find(".caption");
                        this.$active.removeClass("active");
                        anim({
                            targets: this.$active[0],
                            opacity: 0,
                            duration: this.options.duration,
                            easing: "easeOutQuad",
                            complete: function() {
                                _this44.$slides.not(".active").each(function(el) {
                                    anim({
                                        targets: el,
                                        opacity: 0,
                                        translateX: 0,
                                        translateY: 0,
                                        duration: 0,
                                        easing: "easeOutQuad"
                                    });
                                });
                            }
                        });
                        this._animateCaptionIn($caption[0], this.options.duration);
                        // Update indicators
                        if (this.options.indicators) {
                            this.$indicators.eq(this.activeIndex).removeClass("active");
                            this.$indicators.eq(index).addClass("active");
                        }
                        anim({
                            targets: this.$slides.eq(index)[0],
                            opacity: 1,
                            duration: this.options.duration,
                            easing: "easeOutQuad"
                        });
                        anim({
                            targets: this.$slides.eq(index).find(".caption")[0],
                            opacity: 1,
                            translateX: 0,
                            translateY: 0,
                            duration: this.options.duration,
                            delay: this.options.duration,
                            easing: "easeOutQuad"
                        });
                        this.$slides.eq(index).addClass("active");
                        this.activeIndex = index;
                        // Reset interval
                        this.start();
                    }
                }
            },
            {
                key: "pause",
                value: function pause() {
                    clearInterval(this.interval);
                }
            },
            {
                key: "start",
                value: function start() {
                    clearInterval(this.interval);
                    this.interval = setInterval(this._handleIntervalBound, this.options.duration + this.options.interval);
                }
            },
            {
                key: "next",
                value: function next() {
                    var newIndex = this.activeIndex + 1;
                    // Wrap around indices.
                    if (newIndex >= this.$slides.length) newIndex = 0;
                    else if (newIndex < 0) newIndex = this.$slides.length - 1;
                    this.set(newIndex);
                }
            },
            {
                key: "prev",
                value: function prev() {
                    var newIndex = this.activeIndex - 1;
                    // Wrap around indices.
                    if (newIndex >= this.$slides.length) newIndex = 0;
                    else if (newIndex < 0) newIndex = this.$slides.length - 1;
                    this.set(newIndex);
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Slider.__proto__ || Object.getPrototypeOf(Slider), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Slider;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Slider;
    }(Component);
    M.Slider = Slider;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Slider, "slider", "M_Slider");
})(cash, M.anime);
(function($1, anim) {
    $1(document).on("click", ".card", function(e) {
        if ($1(this).children(".card-reveal").length) {
            var $card = $1(e.target).closest(".card");
            if ($card.data("initialOverflow") === undefined) $card.data("initialOverflow", $card.css("overflow") === undefined ? "" : $card.css("overflow"));
            var $cardReveal = $1(this).find(".card-reveal");
            if ($1(e.target).is($1(".card-reveal .card-title")) || $1(e.target).is($1(".card-reveal .card-title i"))) // Make Reveal animate down and display none
            anim({
                targets: $cardReveal[0],
                translateY: 0,
                duration: 225,
                easing: "easeInOutQuad",
                complete: function(anim) {
                    var el = anim.animatables[0].target;
                    $1(el).css({
                        display: "none"
                    });
                    $card.css("overflow", $card.data("initialOverflow"));
                }
            });
            else if ($1(e.target).is($1(".card .activator")) || $1(e.target).is($1(".card .activator i"))) {
                $card.css("overflow", "hidden");
                $cardReveal.css({
                    display: "block"
                });
                anim({
                    targets: $cardReveal[0],
                    translateY: "-100%",
                    duration: 300,
                    easing: "easeInOutQuad"
                });
            }
        }
    });
})(cash, M.anime);
(function($1) {
    "use strict";
    var _defaults = {
        data: [],
        placeholder: "",
        secondaryPlaceholder: "",
        autocompleteOptions: {},
        limit: Infinity,
        onChipAdd: null,
        onChipSelect: null,
        onChipDelete: null
    };
    /**
   * @typedef {Object} chip
   * @property {String} tag  chip tag string
   * @property {String} [image]  chip avatar image string
   */ /**
   * @class
   *
   */ var Chips = function(_Component12) {
        _inherits(Chips, _Component12);
        /**
     * Construct Chips instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function Chips(el, options) {
            _classCallCheck(this, Chips);
            var _this45 = _possibleConstructorReturn(this, (Chips.__proto__ || Object.getPrototypeOf(Chips)).call(this, Chips, el, options));
            _this45.el.M_Chips = _this45;
            /**
       * Options for the modal
       * @member Chips#options
       * @prop {Array} data
       * @prop {String} placeholder
       * @prop {String} secondaryPlaceholder
       * @prop {Object} autocompleteOptions
       */ _this45.options = $1.extend({}, Chips.defaults, options);
            _this45.$el.addClass("chips input-field");
            _this45.chipsData = [];
            _this45.$chips = $1();
            _this45._setupInput();
            _this45.hasAutocomplete = Object.keys(_this45.options.autocompleteOptions).length > 0;
            // Set input id
            if (!_this45.$input.attr("id")) _this45.$input.attr("id", M.guid());
            // Render initial chips
            if (_this45.options.data.length) {
                _this45.chipsData = _this45.options.data;
                _this45._renderChips(_this45.chipsData);
            }
            // Setup autocomplete if needed
            if (_this45.hasAutocomplete) _this45._setupAutocomplete();
            _this45._setPlaceholder();
            _this45._setupLabel();
            _this45._setupEventHandlers();
            return _this45;
        }
        _createClass(Chips, [
            {
                key: "getData",
                /**
       * Get Chips Data
       */ value: function getData() {
                    return this.chipsData;
                }
            },
            {
                key: "destroy",
                value: function destroy() {
                    this._removeEventHandlers();
                    this.$chips.remove();
                    this.el.M_Chips = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    this._handleChipClickBound = this._handleChipClick.bind(this);
                    this._handleInputKeydownBound = this._handleInputKeydown.bind(this);
                    this._handleInputFocusBound = this._handleInputFocus.bind(this);
                    this._handleInputBlurBound = this._handleInputBlur.bind(this);
                    this.el.addEventListener("click", this._handleChipClickBound);
                    document.addEventListener("keydown", Chips._handleChipsKeydown);
                    document.addEventListener("keyup", Chips._handleChipsKeyup);
                    this.el.addEventListener("blur", Chips._handleChipsBlur, true);
                    this.$input[0].addEventListener("focus", this._handleInputFocusBound);
                    this.$input[0].addEventListener("blur", this._handleInputBlurBound);
                    this.$input[0].addEventListener("keydown", this._handleInputKeydownBound);
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    this.el.removeEventListener("click", this._handleChipClickBound);
                    document.removeEventListener("keydown", Chips._handleChipsKeydown);
                    document.removeEventListener("keyup", Chips._handleChipsKeyup);
                    this.el.removeEventListener("blur", Chips._handleChipsBlur, true);
                    this.$input[0].removeEventListener("focus", this._handleInputFocusBound);
                    this.$input[0].removeEventListener("blur", this._handleInputBlurBound);
                    this.$input[0].removeEventListener("keydown", this._handleInputKeydownBound);
                }
            },
            {
                key: "_handleChipClick",
                value: function _handleChipClick(e) {
                    var $chip = $1(e.target).closest(".chip");
                    var clickedClose = $1(e.target).is(".close");
                    if ($chip.length) {
                        var index = $chip.index();
                        if (clickedClose) {
                            // delete chip
                            this.deleteChip(index);
                            this.$input[0].focus();
                        } else // select chip
                        this.selectChip(index);
                    // Default handle click to focus on input
                    } else this.$input[0].focus();
                }
            },
            {
                key: "_handleInputFocus",
                /**
       * Handle Input Focus
       */ value: function _handleInputFocus() {
                    this.$el.addClass("focus");
                }
            },
            {
                key: "_handleInputBlur",
                value: function _handleInputBlur() {
                    this.$el.removeClass("focus");
                }
            },
            {
                key: "_handleInputKeydown",
                value: function _handleInputKeydown(e) {
                    Chips._keydown = true;
                    // enter
                    if (e.keyCode === 13) {
                        // Override enter if autocompleting.
                        if (this.hasAutocomplete && this.autocomplete && this.autocomplete.isOpen) return;
                        e.preventDefault();
                        this.addChip({
                            tag: this.$input[0].value
                        });
                        this.$input[0].value = "";
                    // delete or left
                    } else if ((e.keyCode === 8 || e.keyCode === 37) && this.$input[0].value === "" && this.chipsData.length) {
                        e.preventDefault();
                        this.selectChip(this.chipsData.length - 1);
                    }
                }
            },
            {
                key: "_renderChip",
                value: function _renderChip(chip) {
                    if (!chip.tag) return;
                    var renderedChip = document.createElement("div");
                    var closeIcon = document.createElement("i");
                    renderedChip.classList.add("chip");
                    renderedChip.textContent = chip.tag;
                    renderedChip.setAttribute("tabindex", 0);
                    $1(closeIcon).addClass("material-icons close");
                    closeIcon.textContent = "close";
                    // attach image if needed
                    if (chip.image) {
                        var img = document.createElement("img");
                        img.setAttribute("src", chip.image);
                        renderedChip.insertBefore(img, renderedChip.firstChild);
                    }
                    renderedChip.appendChild(closeIcon);
                    return renderedChip;
                }
            },
            {
                key: "_renderChips",
                value: function _renderChips() {
                    this.$chips.remove();
                    for(var i = 0; i < this.chipsData.length; i++){
                        var chipEl = this._renderChip(this.chipsData[i]);
                        this.$el.append(chipEl);
                        this.$chips.add(chipEl);
                    }
                    // move input to end
                    this.$el.append(this.$input[0]);
                }
            },
            {
                key: "_setupAutocomplete",
                value: function _setupAutocomplete() {
                    var _this46 = this;
                    this.options.autocompleteOptions.onAutocomplete = function(val) {
                        _this46.addChip({
                            tag: val
                        });
                        _this46.$input[0].value = "";
                        _this46.$input[0].focus();
                    };
                    this.autocomplete = M.Autocomplete.init(this.$input[0], this.options.autocompleteOptions);
                }
            },
            {
                key: "_setupInput",
                value: function _setupInput() {
                    this.$input = this.$el.find("input");
                    if (!this.$input.length) {
                        this.$input = $1("<input></input>");
                        this.$el.append(this.$input);
                    }
                    this.$input.addClass("input");
                }
            },
            {
                key: "_setupLabel",
                value: function _setupLabel() {
                    this.$label = this.$el.find("label");
                    if (this.$label.length) this.$label.setAttribute("for", this.$input.attr("id"));
                }
            },
            {
                key: "_setPlaceholder",
                value: function _setPlaceholder() {
                    if (this.chipsData !== undefined && !this.chipsData.length && this.options.placeholder) $1(this.$input).prop("placeholder", this.options.placeholder);
                    else if ((this.chipsData === undefined || !!this.chipsData.length) && this.options.secondaryPlaceholder) $1(this.$input).prop("placeholder", this.options.secondaryPlaceholder);
                }
            },
            {
                key: "_isValid",
                value: function _isValid(chip) {
                    if (chip.hasOwnProperty("tag") && chip.tag !== "") {
                        var exists = false;
                        for(var i = 0; i < this.chipsData.length; i++)if (this.chipsData[i].tag === chip.tag) {
                            exists = true;
                            break;
                        }
                        return !exists;
                    }
                    return false;
                }
            },
            {
                key: "addChip",
                value: function addChip(chip) {
                    if (!this._isValid(chip) || this.chipsData.length >= this.options.limit) return;
                    var renderedChip = this._renderChip(chip);
                    this.$chips.add(renderedChip);
                    this.chipsData.push(chip);
                    $1(this.$input).before(renderedChip);
                    this._setPlaceholder();
                    // fire chipAdd callback
                    if (typeof this.options.onChipAdd === "function") this.options.onChipAdd.call(this, this.$el, renderedChip);
                }
            },
            {
                key: "deleteChip",
                value: function deleteChip(chipIndex) {
                    var $chip = this.$chips.eq(chipIndex);
                    this.$chips.eq(chipIndex).remove();
                    this.$chips = this.$chips.filter(function(el) {
                        return $1(el).index() >= 0;
                    });
                    this.chipsData.splice(chipIndex, 1);
                    this._setPlaceholder();
                    // fire chipDelete callback
                    if (typeof this.options.onChipDelete === "function") this.options.onChipDelete.call(this, this.$el, $chip[0]);
                }
            },
            {
                key: "selectChip",
                value: function selectChip(chipIndex) {
                    var $chip = this.$chips.eq(chipIndex);
                    this._selectedChip = $chip;
                    $chip[0].focus();
                    // fire chipSelect callback
                    if (typeof this.options.onChipSelect === "function") this.options.onChipSelect.call(this, this.$el, $chip[0]);
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Chips.__proto__ || Object.getPrototypeOf(Chips), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Chips;
                }
            },
            {
                key: "_handleChipsKeydown",
                value: function _handleChipsKeydown(e) {
                    Chips._keydown = true;
                    var $chips = $1(e.target).closest(".chips");
                    var chipsKeydown = e.target && $chips.length;
                    // Don't handle keydown inputs on input and textarea
                    if ($1(e.target).is("input, textarea") || !chipsKeydown) return;
                    var currChips = $chips[0].M_Chips;
                    // backspace and delete
                    if (e.keyCode === 8 || e.keyCode === 46) {
                        e.preventDefault();
                        var selectIndex = currChips.chipsData.length;
                        if (currChips._selectedChip) {
                            var index = currChips._selectedChip.index();
                            currChips.deleteChip(index);
                            currChips._selectedChip = null;
                            // Make sure selectIndex doesn't go negative
                            selectIndex = Math.max(index - 1, 0);
                        }
                        if (currChips.chipsData.length) currChips.selectChip(selectIndex);
                    // left arrow key
                    } else if (e.keyCode === 37) {
                        if (currChips._selectedChip) {
                            var _selectIndex = currChips._selectedChip.index() - 1;
                            if (_selectIndex < 0) return;
                            currChips.selectChip(_selectIndex);
                        }
                    } else if (e.keyCode === 39) {
                        if (currChips._selectedChip) {
                            var _selectIndex2 = currChips._selectedChip.index() + 1;
                            if (_selectIndex2 >= currChips.chipsData.length) currChips.$input[0].focus();
                            else currChips.selectChip(_selectIndex2);
                        }
                    }
                }
            },
            {
                key: "_handleChipsKeyup",
                value: function _handleChipsKeyup(e) {
                    Chips._keydown = false;
                }
            },
            {
                key: "_handleChipsBlur",
                value: function _handleChipsBlur(e) {
                    if (!Chips._keydown) {
                        var $chips = $1(e.target).closest(".chips");
                        var currChips = $chips[0].M_Chips;
                        currChips._selectedChip = null;
                    }
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Chips;
    }(Component);
    /**
   * @static
   * @memberof Chips
   */ Chips._keydown = false;
    M.Chips = Chips;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Chips, "chips", "M_Chips");
    $1(document).ready(function() {
        // Handle removal of static chips.
        $1(document.body).on("click", ".chip .close", function() {
            var $chips = $1(this).closest(".chips");
            if ($chips.length && $chips[0].M_Chips) return;
            $1(this).closest(".chip").remove();
        });
    });
})(cash);
(function($1) {
    "use strict";
    var _defaults = {
        top: 0,
        bottom: Infinity,
        offset: 0,
        onPositionChange: null
    };
    /**
   * @class
   *
   */ var Pushpin = function(_Component13) {
        _inherits(Pushpin, _Component13);
        /**
     * Construct Pushpin instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function Pushpin(el, options) {
            _classCallCheck(this, Pushpin);
            var _this47 = _possibleConstructorReturn(this, (Pushpin.__proto__ || Object.getPrototypeOf(Pushpin)).call(this, Pushpin, el, options));
            _this47.el.M_Pushpin = _this47;
            /**
       * Options for the modal
       * @member Pushpin#options
       */ _this47.options = $1.extend({}, Pushpin.defaults, options);
            _this47.originalOffset = _this47.el.offsetTop;
            Pushpin._pushpins.push(_this47);
            _this47._setupEventHandlers();
            _this47._updatePosition();
            return _this47;
        }
        _createClass(Pushpin, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this.el.style.top = null;
                    this._removePinClasses();
                    this._removeEventHandlers();
                    // Remove pushpin Inst
                    var index = Pushpin._pushpins.indexOf(this);
                    Pushpin._pushpins.splice(index, 1);
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    document.addEventListener("scroll", Pushpin._updateElements);
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    document.removeEventListener("scroll", Pushpin._updateElements);
                }
            },
            {
                key: "_updatePosition",
                value: function _updatePosition() {
                    var scrolled = M.getDocumentScrollTop() + this.options.offset;
                    if (this.options.top <= scrolled && this.options.bottom >= scrolled && !this.el.classList.contains("pinned")) {
                        this._removePinClasses();
                        this.el.style.top = this.options.offset + "px";
                        this.el.classList.add("pinned");
                        // onPositionChange callback
                        if (typeof this.options.onPositionChange === "function") this.options.onPositionChange.call(this, "pinned");
                    }
                    // Add pin-top (when scrolled position is above top)
                    if (scrolled < this.options.top && !this.el.classList.contains("pin-top")) {
                        this._removePinClasses();
                        this.el.style.top = 0;
                        this.el.classList.add("pin-top");
                        // onPositionChange callback
                        if (typeof this.options.onPositionChange === "function") this.options.onPositionChange.call(this, "pin-top");
                    }
                    // Add pin-bottom (when scrolled position is below bottom)
                    if (scrolled > this.options.bottom && !this.el.classList.contains("pin-bottom")) {
                        this._removePinClasses();
                        this.el.classList.add("pin-bottom");
                        this.el.style.top = this.options.bottom - this.originalOffset + "px";
                        // onPositionChange callback
                        if (typeof this.options.onPositionChange === "function") this.options.onPositionChange.call(this, "pin-bottom");
                    }
                }
            },
            {
                key: "_removePinClasses",
                value: function _removePinClasses() {
                    // IE 11 bug (can't remove multiple classes in one line)
                    this.el.classList.remove("pin-top");
                    this.el.classList.remove("pinned");
                    this.el.classList.remove("pin-bottom");
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Pushpin.__proto__ || Object.getPrototypeOf(Pushpin), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Pushpin;
                }
            },
            {
                key: "_updateElements",
                value: function _updateElements() {
                    for(var elIndex in Pushpin._pushpins){
                        var pInstance = Pushpin._pushpins[elIndex];
                        pInstance._updatePosition();
                    }
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Pushpin;
    }(Component);
    /**
   * @static
   * @memberof Pushpin
   */ Pushpin._pushpins = [];
    M.Pushpin = Pushpin;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Pushpin, "pushpin", "M_Pushpin");
})(cash);
(function($1, anim) {
    "use strict";
    var _defaults = {
        direction: "top",
        hoverEnabled: true,
        toolbarEnabled: false
    };
    $1.fn.reverse = [].reverse;
    /**
   * @class
   *
   */ var FloatingActionButton = function(_Component14) {
        _inherits(FloatingActionButton, _Component14);
        /**
     * Construct FloatingActionButton instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function FloatingActionButton(el, options) {
            _classCallCheck(this, FloatingActionButton);
            var _this48 = _possibleConstructorReturn(this, (FloatingActionButton.__proto__ || Object.getPrototypeOf(FloatingActionButton)).call(this, FloatingActionButton, el, options));
            _this48.el.M_FloatingActionButton = _this48;
            /**
       * Options for the fab
       * @member FloatingActionButton#options
       * @prop {Boolean} [direction] - Direction fab menu opens
       * @prop {Boolean} [hoverEnabled=true] - Enable hover vs click
       * @prop {Boolean} [toolbarEnabled=false] - Enable toolbar transition
       */ _this48.options = $1.extend({}, FloatingActionButton.defaults, options);
            _this48.isOpen = false;
            _this48.$anchor = _this48.$el.children("a").first();
            _this48.$menu = _this48.$el.children("ul").first();
            _this48.$floatingBtns = _this48.$el.find("ul .btn-floating");
            _this48.$floatingBtnsReverse = _this48.$el.find("ul .btn-floating").reverse();
            _this48.offsetY = 0;
            _this48.offsetX = 0;
            _this48.$el.addClass("direction-" + _this48.options.direction);
            if (_this48.options.direction === "top") _this48.offsetY = 40;
            else if (_this48.options.direction === "right") _this48.offsetX = -40;
            else if (_this48.options.direction === "bottom") _this48.offsetY = -40;
            else _this48.offsetX = 40;
            _this48._setupEventHandlers();
            return _this48;
        }
        _createClass(FloatingActionButton, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this._removeEventHandlers();
                    this.el.M_FloatingActionButton = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    this._handleFABClickBound = this._handleFABClick.bind(this);
                    this._handleOpenBound = this.open.bind(this);
                    this._handleCloseBound = this.close.bind(this);
                    if (this.options.hoverEnabled && !this.options.toolbarEnabled) {
                        this.el.addEventListener("mouseenter", this._handleOpenBound);
                        this.el.addEventListener("mouseleave", this._handleCloseBound);
                    } else this.el.addEventListener("click", this._handleFABClickBound);
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    if (this.options.hoverEnabled && !this.options.toolbarEnabled) {
                        this.el.removeEventListener("mouseenter", this._handleOpenBound);
                        this.el.removeEventListener("mouseleave", this._handleCloseBound);
                    } else this.el.removeEventListener("click", this._handleFABClickBound);
                }
            },
            {
                key: "_handleFABClick",
                value: function _handleFABClick() {
                    if (this.isOpen) this.close();
                    else this.open();
                }
            },
            {
                key: "_handleDocumentClick",
                value: function _handleDocumentClick(e) {
                    if (!$1(e.target).closest(this.$menu).length) this.close();
                }
            },
            {
                key: "open",
                value: function open() {
                    if (this.isOpen) return;
                    if (this.options.toolbarEnabled) this._animateInToolbar();
                    else this._animateInFAB();
                    this.isOpen = true;
                }
            },
            {
                key: "close",
                value: function close() {
                    if (!this.isOpen) return;
                    if (this.options.toolbarEnabled) {
                        window.removeEventListener("scroll", this._handleCloseBound, true);
                        document.body.removeEventListener("click", this._handleDocumentClickBound, true);
                        this._animateOutToolbar();
                    } else this._animateOutFAB();
                    this.isOpen = false;
                }
            },
            {
                key: "_animateInFAB",
                value: function _animateInFAB() {
                    var _this49 = this;
                    this.$el.addClass("active");
                    var time = 0;
                    this.$floatingBtnsReverse.each(function(el) {
                        anim({
                            targets: el,
                            opacity: 1,
                            scale: [
                                0.4,
                                1
                            ],
                            translateY: [
                                _this49.offsetY,
                                0
                            ],
                            translateX: [
                                _this49.offsetX,
                                0
                            ],
                            duration: 275,
                            delay: time,
                            easing: "easeInOutQuad"
                        });
                        time += 40;
                    });
                }
            },
            {
                key: "_animateOutFAB",
                value: function _animateOutFAB() {
                    var _this50 = this;
                    this.$floatingBtnsReverse.each(function(el) {
                        anim.remove(el);
                        anim({
                            targets: el,
                            opacity: 0,
                            scale: 0.4,
                            translateY: _this50.offsetY,
                            translateX: _this50.offsetX,
                            duration: 175,
                            easing: "easeOutQuad",
                            complete: function() {
                                _this50.$el.removeClass("active");
                            }
                        });
                    });
                }
            },
            {
                key: "_animateInToolbar",
                value: function _animateInToolbar() {
                    var _this51 = this;
                    var scaleFactor = void 0;
                    var windowWidth = window.innerWidth;
                    var windowHeight = window.innerHeight;
                    var btnRect = this.el.getBoundingClientRect();
                    var backdrop = $1('<div class="fab-backdrop"></div>');
                    var fabColor = this.$anchor.css("background-color");
                    this.$anchor.append(backdrop);
                    this.offsetX = btnRect.left - windowWidth / 2 + btnRect.width / 2;
                    this.offsetY = windowHeight - btnRect.bottom;
                    scaleFactor = windowWidth / backdrop[0].clientWidth;
                    this.btnBottom = btnRect.bottom;
                    this.btnLeft = btnRect.left;
                    this.btnWidth = btnRect.width;
                    // Set initial state
                    this.$el.addClass("active");
                    this.$el.css({
                        "text-align": "center",
                        width: "100%",
                        bottom: 0,
                        left: 0,
                        transform: "translateX(" + this.offsetX + "px)",
                        transition: "none"
                    });
                    this.$anchor.css({
                        transform: "translateY(" + -this.offsetY + "px)",
                        transition: "none"
                    });
                    backdrop.css({
                        "background-color": fabColor
                    });
                    setTimeout(function() {
                        _this51.$el.css({
                            transform: "",
                            transition: "transform .2s cubic-bezier(0.550, 0.085, 0.680, 0.530), background-color 0s linear .2s"
                        });
                        _this51.$anchor.css({
                            overflow: "visible",
                            transform: "",
                            transition: "transform .2s"
                        });
                        setTimeout(function() {
                            _this51.$el.css({
                                overflow: "hidden",
                                "background-color": fabColor
                            });
                            backdrop.css({
                                transform: "scale(" + scaleFactor + ")",
                                transition: "transform .2s cubic-bezier(0.550, 0.055, 0.675, 0.190)"
                            });
                            _this51.$menu.children("li").children("a").css({
                                opacity: 1
                            });
                            // Scroll to close.
                            _this51._handleDocumentClickBound = _this51._handleDocumentClick.bind(_this51);
                            window.addEventListener("scroll", _this51._handleCloseBound, true);
                            document.body.addEventListener("click", _this51._handleDocumentClickBound, true);
                        }, 100);
                    }, 0);
                }
            },
            {
                key: "_animateOutToolbar",
                value: function _animateOutToolbar() {
                    var _this52 = this;
                    var windowWidth = window.innerWidth;
                    var windowHeight = window.innerHeight;
                    var backdrop = this.$el.find(".fab-backdrop");
                    var fabColor = this.$anchor.css("background-color");
                    this.offsetX = this.btnLeft - windowWidth / 2 + this.btnWidth / 2;
                    this.offsetY = windowHeight - this.btnBottom;
                    // Hide backdrop
                    this.$el.removeClass("active");
                    this.$el.css({
                        "background-color": "transparent",
                        transition: "none"
                    });
                    this.$anchor.css({
                        transition: "none"
                    });
                    backdrop.css({
                        transform: "scale(0)",
                        "background-color": fabColor
                    });
                    this.$menu.children("li").children("a").css({
                        opacity: ""
                    });
                    setTimeout(function() {
                        backdrop.remove();
                        // Set initial state.
                        _this52.$el.css({
                            "text-align": "",
                            width: "",
                            bottom: "",
                            left: "",
                            overflow: "",
                            "background-color": "",
                            transform: "translate3d(" + -_this52.offsetX + "px,0,0)"
                        });
                        _this52.$anchor.css({
                            overflow: "",
                            transform: "translate3d(0," + _this52.offsetY + "px,0)"
                        });
                        setTimeout(function() {
                            _this52.$el.css({
                                transform: "translate3d(0,0,0)",
                                transition: "transform .2s"
                            });
                            _this52.$anchor.css({
                                transform: "translate3d(0,0,0)",
                                transition: "transform .2s cubic-bezier(0.550, 0.055, 0.675, 0.190)"
                            });
                        }, 20);
                    }, 200);
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(FloatingActionButton.__proto__ || Object.getPrototypeOf(FloatingActionButton), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_FloatingActionButton;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return FloatingActionButton;
    }(Component);
    M.FloatingActionButton = FloatingActionButton;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(FloatingActionButton, "floatingActionButton", "M_FloatingActionButton");
})(cash, M.anime);
(function($1) {
    "use strict";
    var _defaults = {
        // Close when date is selected
        autoClose: false,
        // the default output format for the input field value
        format: "mmm dd, yyyy",
        // Used to create date object from current input string
        parse: null,
        // The initial date to view when first opened
        defaultDate: null,
        // Make the `defaultDate` the initial selected value
        setDefaultDate: false,
        disableWeekends: false,
        disableDayFn: null,
        // First day of week (0: Sunday, 1: Monday etc)
        firstDay: 0,
        // The earliest date that can be selected
        minDate: null,
        // Thelatest date that can be selected
        maxDate: null,
        // Number of years either side, or array of upper/lower range
        yearRange: 10,
        // used internally (don't config outside)
        minYear: 0,
        maxYear: 9999,
        minMonth: undefined,
        maxMonth: undefined,
        startRange: null,
        endRange: null,
        isRTL: false,
        // Render the month after year in the calendar title
        showMonthAfterYear: false,
        // Render days of the calendar grid that fall in the next or previous month
        showDaysInNextAndPreviousMonths: false,
        // Specify a DOM element to render the calendar in
        container: null,
        // Show clear button
        showClearBtn: false,
        // internationalization
        i18n: {
            cancel: "Cancel",
            clear: "Clear",
            done: "Ok",
            previousMonth: "\u2039",
            nextMonth: "\u203A",
            months: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ],
            monthsShort: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ],
            weekdays: [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ],
            weekdaysShort: [
                "Sun",
                "Mon",
                "Tue",
                "Wed",
                "Thu",
                "Fri",
                "Sat"
            ],
            weekdaysAbbrev: [
                "S",
                "M",
                "T",
                "W",
                "T",
                "F",
                "S"
            ]
        },
        // events array
        events: [],
        // callback function
        onSelect: null,
        onOpen: null,
        onClose: null,
        onDraw: null
    };
    /**
   * @class
   *
   */ var Datepicker = function(_Component15) {
        _inherits(Datepicker, _Component15);
        /**
     * Construct Datepicker instance and set up overlay
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function Datepicker(el, options) {
            _classCallCheck(this, Datepicker);
            var _this53 = _possibleConstructorReturn(this, (Datepicker.__proto__ || Object.getPrototypeOf(Datepicker)).call(this, Datepicker, el, options));
            _this53.el.M_Datepicker = _this53;
            _this53.options = $1.extend({}, Datepicker.defaults, options);
            // make sure i18n defaults are not lost when only few i18n option properties are passed
            if (!!options && options.hasOwnProperty("i18n") && typeof options.i18n === "object") _this53.options.i18n = $1.extend({}, Datepicker.defaults.i18n, options.i18n);
            // Remove time component from minDate and maxDate options
            if (_this53.options.minDate) _this53.options.minDate.setHours(0, 0, 0, 0);
            if (_this53.options.maxDate) _this53.options.maxDate.setHours(0, 0, 0, 0);
            _this53.id = M.guid();
            _this53._setupVariables();
            _this53._insertHTMLIntoDOM();
            _this53._setupModal();
            _this53._setupEventHandlers();
            if (!_this53.options.defaultDate) _this53.options.defaultDate = new Date(Date.parse(_this53.el.value));
            var defDate = _this53.options.defaultDate;
            if (Datepicker._isDate(defDate)) {
                if (_this53.options.setDefaultDate) {
                    _this53.setDate(defDate, true);
                    _this53.setInputValue();
                } else _this53.gotoDate(defDate);
            } else _this53.gotoDate(new Date());
            /**
       * Describes open/close state of datepicker
       * @type {Boolean}
       */ _this53.isOpen = false;
            return _this53;
        }
        _createClass(Datepicker, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this._removeEventHandlers();
                    this.modal.destroy();
                    $1(this.modalEl).remove();
                    this.destroySelects();
                    this.el.M_Datepicker = undefined;
                }
            },
            {
                key: "destroySelects",
                value: function destroySelects() {
                    var oldYearSelect = this.calendarEl.querySelector(".orig-select-year");
                    if (oldYearSelect) M.FormSelect.getInstance(oldYearSelect).destroy();
                    var oldMonthSelect = this.calendarEl.querySelector(".orig-select-month");
                    if (oldMonthSelect) M.FormSelect.getInstance(oldMonthSelect).destroy();
                }
            },
            {
                key: "_insertHTMLIntoDOM",
                value: function _insertHTMLIntoDOM() {
                    if (this.options.showClearBtn) {
                        $1(this.clearBtn).css({
                            visibility: ""
                        });
                        this.clearBtn.innerHTML = this.options.i18n.clear;
                    }
                    this.doneBtn.innerHTML = this.options.i18n.done;
                    this.cancelBtn.innerHTML = this.options.i18n.cancel;
                    if (this.options.container) this.$modalEl.appendTo(this.options.container);
                    else this.$modalEl.insertBefore(this.el);
                }
            },
            {
                key: "_setupModal",
                value: function _setupModal() {
                    var _this54 = this;
                    this.modalEl.id = "modal-" + this.id;
                    this.modal = M.Modal.init(this.modalEl, {
                        onCloseEnd: function() {
                            _this54.isOpen = false;
                        }
                    });
                }
            },
            {
                key: "toString",
                value: function toString(format) {
                    var _this55 = this;
                    format = format || this.options.format;
                    if (!Datepicker._isDate(this.date)) return "";
                    var formatArray = format.split(/(d{1,4}|m{1,4}|y{4}|yy|!.)/g);
                    var formattedDate = formatArray.map(function(label) {
                        if (_this55.formats[label]) return _this55.formats[label]();
                        return label;
                    }).join("");
                    return formattedDate;
                }
            },
            {
                key: "setDate",
                value: function setDate(date, preventOnSelect) {
                    if (!date) {
                        this.date = null;
                        this._renderDateDisplay();
                        return this.draw();
                    }
                    if (typeof date === "string") date = new Date(Date.parse(date));
                    if (!Datepicker._isDate(date)) return;
                    var min = this.options.minDate, max = this.options.maxDate;
                    if (Datepicker._isDate(min) && date < min) date = min;
                    else if (Datepicker._isDate(max) && date > max) date = max;
                    this.date = new Date(date.getTime());
                    this._renderDateDisplay();
                    Datepicker._setToStartOfDay(this.date);
                    this.gotoDate(this.date);
                    if (!preventOnSelect && typeof this.options.onSelect === "function") this.options.onSelect.call(this, this.date);
                }
            },
            {
                key: "setInputValue",
                value: function setInputValue() {
                    this.el.value = this.toString();
                    this.$el.trigger("change", {
                        firedBy: this
                    });
                }
            },
            {
                key: "_renderDateDisplay",
                value: function _renderDateDisplay() {
                    var displayDate = Datepicker._isDate(this.date) ? this.date : new Date();
                    var i18n = this.options.i18n;
                    var day = i18n.weekdaysShort[displayDate.getDay()];
                    var month = i18n.monthsShort[displayDate.getMonth()];
                    var date = displayDate.getDate();
                    this.yearTextEl.innerHTML = displayDate.getFullYear();
                    this.dateTextEl.innerHTML = day + ", " + month + " " + date;
                }
            },
            {
                key: "gotoDate",
                value: function gotoDate(date) {
                    var newCalendar = true;
                    if (!Datepicker._isDate(date)) return;
                    if (this.calendars) {
                        var firstVisibleDate = new Date(this.calendars[0].year, this.calendars[0].month, 1), lastVisibleDate = new Date(this.calendars[this.calendars.length - 1].year, this.calendars[this.calendars.length - 1].month, 1), visibleDate = date.getTime();
                        // get the end of the month
                        lastVisibleDate.setMonth(lastVisibleDate.getMonth() + 1);
                        lastVisibleDate.setDate(lastVisibleDate.getDate() - 1);
                        newCalendar = visibleDate < firstVisibleDate.getTime() || lastVisibleDate.getTime() < visibleDate;
                    }
                    if (newCalendar) this.calendars = [
                        {
                            month: date.getMonth(),
                            year: date.getFullYear()
                        }
                    ];
                    this.adjustCalendars();
                }
            },
            {
                key: "adjustCalendars",
                value: function adjustCalendars() {
                    this.calendars[0] = this.adjustCalendar(this.calendars[0]);
                    this.draw();
                }
            },
            {
                key: "adjustCalendar",
                value: function adjustCalendar(calendar) {
                    if (calendar.month < 0) {
                        calendar.year -= Math.ceil(Math.abs(calendar.month) / 12);
                        calendar.month += 12;
                    }
                    if (calendar.month > 11) {
                        calendar.year += Math.floor(Math.abs(calendar.month) / 12);
                        calendar.month -= 12;
                    }
                    return calendar;
                }
            },
            {
                key: "nextMonth",
                value: function nextMonth() {
                    this.calendars[0].month++;
                    this.adjustCalendars();
                }
            },
            {
                key: "prevMonth",
                value: function prevMonth() {
                    this.calendars[0].month--;
                    this.adjustCalendars();
                }
            },
            {
                key: "render",
                value: function render(year, month, randId) {
                    var opts = this.options, now = new Date(), days = Datepicker._getDaysInMonth(year, month), before = new Date(year, month, 1).getDay(), data = [], row = [];
                    Datepicker._setToStartOfDay(now);
                    if (opts.firstDay > 0) {
                        before -= opts.firstDay;
                        if (before < 0) before += 7;
                    }
                    var previousMonth = month === 0 ? 11 : month - 1, nextMonth = month === 11 ? 0 : month + 1, yearOfPreviousMonth = month === 0 ? year - 1 : year, yearOfNextMonth = month === 11 ? year + 1 : year, daysInPreviousMonth = Datepicker._getDaysInMonth(yearOfPreviousMonth, previousMonth);
                    var cells = days + before, after = cells;
                    while(after > 7)after -= 7;
                    cells += 7 - after;
                    var isWeekSelected = false;
                    for(var i = 0, r = 0; i < cells; i++){
                        var day = new Date(year, month, 1 + (i - before)), isSelected = Datepicker._isDate(this.date) ? Datepicker._compareDates(day, this.date) : false, isToday = Datepicker._compareDates(day, now), hasEvent = opts.events.indexOf(day.toDateString()) !== -1 ? true : false, isEmpty = i < before || i >= days + before, dayNumber = 1 + (i - before), monthNumber = month, yearNumber = year, isStartRange = opts.startRange && Datepicker._compareDates(opts.startRange, day), isEndRange = opts.endRange && Datepicker._compareDates(opts.endRange, day), isInRange = opts.startRange && opts.endRange && opts.startRange < day && day < opts.endRange, isDisabled = opts.minDate && day < opts.minDate || opts.maxDate && day > opts.maxDate || opts.disableWeekends && Datepicker._isWeekend(day) || opts.disableDayFn && opts.disableDayFn(day);
                        if (isEmpty) {
                            if (i < before) {
                                dayNumber = daysInPreviousMonth + dayNumber;
                                monthNumber = previousMonth;
                                yearNumber = yearOfPreviousMonth;
                            } else {
                                dayNumber = dayNumber - days;
                                monthNumber = nextMonth;
                                yearNumber = yearOfNextMonth;
                            }
                        }
                        var dayConfig = {
                            day: dayNumber,
                            month: monthNumber,
                            year: yearNumber,
                            hasEvent: hasEvent,
                            isSelected: isSelected,
                            isToday: isToday,
                            isDisabled: isDisabled,
                            isEmpty: isEmpty,
                            isStartRange: isStartRange,
                            isEndRange: isEndRange,
                            isInRange: isInRange,
                            showDaysInNextAndPreviousMonths: opts.showDaysInNextAndPreviousMonths
                        };
                        row.push(this.renderDay(dayConfig));
                        if (++r === 7) {
                            data.push(this.renderRow(row, opts.isRTL, isWeekSelected));
                            row = [];
                            r = 0;
                            isWeekSelected = false;
                        }
                    }
                    return this.renderTable(opts, data, randId);
                }
            },
            {
                key: "renderDay",
                value: function renderDay(opts) {
                    var arr = [];
                    var ariaSelected = "false";
                    if (opts.isEmpty) {
                        if (opts.showDaysInNextAndPreviousMonths) {
                            arr.push("is-outside-current-month");
                            arr.push("is-selection-disabled");
                        } else return '<td class="is-empty"></td>';
                    }
                    if (opts.isDisabled) arr.push("is-disabled");
                    if (opts.isToday) arr.push("is-today");
                    if (opts.isSelected) {
                        arr.push("is-selected");
                        ariaSelected = "true";
                    }
                    if (opts.hasEvent) arr.push("has-event");
                    if (opts.isInRange) arr.push("is-inrange");
                    if (opts.isStartRange) arr.push("is-startrange");
                    if (opts.isEndRange) arr.push("is-endrange");
                    return '<td data-day="' + opts.day + '" class="' + arr.join(" ") + '" aria-selected="' + ariaSelected + '">' + ('<button class="datepicker-day-button" type="button" data-year="' + opts.year + '" data-month="' + opts.month + '" data-day="' + opts.day + '">' + opts.day + "</button>") + "</td>";
                }
            },
            {
                key: "renderRow",
                value: function renderRow(days, isRTL, isRowSelected) {
                    return '<tr class="datepicker-row' + (isRowSelected ? " is-selected" : "") + '">' + (isRTL ? days.reverse() : days).join("") + "</tr>";
                }
            },
            {
                key: "renderTable",
                value: function renderTable(opts, data, randId) {
                    return '<div class="datepicker-table-wrapper"><table cellpadding="0" cellspacing="0" class="datepicker-table" role="grid" aria-labelledby="' + randId + '">' + this.renderHead(opts) + this.renderBody(data) + "</table></div>";
                }
            },
            {
                key: "renderHead",
                value: function renderHead(opts) {
                    var i = void 0, arr = [];
                    for(i = 0; i < 7; i++)arr.push('<th scope="col"><abbr title="' + this.renderDayName(opts, i) + '">' + this.renderDayName(opts, i, true) + "</abbr></th>");
                    return "<thead><tr>" + (opts.isRTL ? arr.reverse() : arr).join("") + "</tr></thead>";
                }
            },
            {
                key: "renderBody",
                value: function renderBody(rows) {
                    return "<tbody>" + rows.join("") + "</tbody>";
                }
            },
            {
                key: "renderTitle",
                value: function renderTitle(instance, c, year, month, refYear, randId) {
                    var i = void 0, j = void 0, arr = void 0, opts = this.options, isMinYear = year === opts.minYear, isMaxYear = year === opts.maxYear, html = '<div id="' + randId + '" class="datepicker-controls" role="heading" aria-live="assertive">', monthHtml = void 0, yearHtml = void 0, prev = true, next = true;
                    for(arr = [], i = 0; i < 12; i++)arr.push('<option value="' + (year === refYear ? i - c : 12 + i - c) + '"' + (i === month ? ' selected="selected"' : "") + (isMinYear && i < opts.minMonth || isMaxYear && i > opts.maxMonth ? 'disabled="disabled"' : "") + ">" + opts.i18n.months[i] + "</option>");
                    monthHtml = '<select class="datepicker-select orig-select-month" tabindex="-1">' + arr.join("") + "</select>";
                    if ($1.isArray(opts.yearRange)) {
                        i = opts.yearRange[0];
                        j = opts.yearRange[1] + 1;
                    } else {
                        i = year - opts.yearRange;
                        j = 1 + year + opts.yearRange;
                    }
                    for(arr = []; i < j && i <= opts.maxYear; i++)if (i >= opts.minYear) arr.push('<option value="' + i + '" ' + (i === year ? 'selected="selected"' : "") + ">" + i + "</option>");
                    yearHtml = '<select class="datepicker-select orig-select-year" tabindex="-1">' + arr.join("") + "</select>";
                    var leftArrow = '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"/><path d="M0-.5h24v24H0z" fill="none"/></svg>';
                    html += '<button class="month-prev' + (prev ? "" : " is-disabled") + '" type="button">' + leftArrow + "</button>";
                    html += '<div class="selects-container">';
                    if (opts.showMonthAfterYear) html += yearHtml + monthHtml;
                    else html += monthHtml + yearHtml;
                    html += "</div>";
                    if (isMinYear && (month === 0 || opts.minMonth >= month)) prev = false;
                    if (isMaxYear && (month === 11 || opts.maxMonth <= month)) next = false;
                    var rightArrow = '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"/><path d="M0-.25h24v24H0z" fill="none"/></svg>';
                    html += '<button class="month-next' + (next ? "" : " is-disabled") + '" type="button">' + rightArrow + "</button>";
                    return html += "</div>";
                }
            },
            {
                key: "draw",
                value: function draw(force) {
                    if (!this.isOpen && !force) return;
                    var opts = this.options, minYear = opts.minYear, maxYear = opts.maxYear, minMonth = opts.minMonth, maxMonth = opts.maxMonth, html = "", randId = void 0;
                    if (this._y <= minYear) {
                        this._y = minYear;
                        if (!isNaN(minMonth) && this._m < minMonth) this._m = minMonth;
                    }
                    if (this._y >= maxYear) {
                        this._y = maxYear;
                        if (!isNaN(maxMonth) && this._m > maxMonth) this._m = maxMonth;
                    }
                    randId = "datepicker-title-" + Math.random().toString(36).replace(/[^a-z]+/g, "").substr(0, 2);
                    for(var c = 0; c < 1; c++){
                        this._renderDateDisplay();
                        html += this.renderTitle(this, c, this.calendars[c].year, this.calendars[c].month, this.calendars[0].year, randId) + this.render(this.calendars[c].year, this.calendars[c].month, randId);
                    }
                    this.destroySelects();
                    this.calendarEl.innerHTML = html;
                    // Init Materialize Select
                    var yearSelect = this.calendarEl.querySelector(".orig-select-year");
                    var monthSelect = this.calendarEl.querySelector(".orig-select-month");
                    M.FormSelect.init(yearSelect, {
                        classes: "select-year",
                        dropdownOptions: {
                            container: document.body,
                            constrainWidth: false
                        }
                    });
                    M.FormSelect.init(monthSelect, {
                        classes: "select-month",
                        dropdownOptions: {
                            container: document.body,
                            constrainWidth: false
                        }
                    });
                    // Add change handlers for select
                    yearSelect.addEventListener("change", this._handleYearChange.bind(this));
                    monthSelect.addEventListener("change", this._handleMonthChange.bind(this));
                    if (typeof this.options.onDraw === "function") this.options.onDraw(this);
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    this._handleInputKeydownBound = this._handleInputKeydown.bind(this);
                    this._handleInputClickBound = this._handleInputClick.bind(this);
                    this._handleInputChangeBound = this._handleInputChange.bind(this);
                    this._handleCalendarClickBound = this._handleCalendarClick.bind(this);
                    this._finishSelectionBound = this._finishSelection.bind(this);
                    this._handleMonthChange = this._handleMonthChange.bind(this);
                    this._closeBound = this.close.bind(this);
                    this.el.addEventListener("click", this._handleInputClickBound);
                    this.el.addEventListener("keydown", this._handleInputKeydownBound);
                    this.el.addEventListener("change", this._handleInputChangeBound);
                    this.calendarEl.addEventListener("click", this._handleCalendarClickBound);
                    this.doneBtn.addEventListener("click", this._finishSelectionBound);
                    this.cancelBtn.addEventListener("click", this._closeBound);
                    if (this.options.showClearBtn) {
                        this._handleClearClickBound = this._handleClearClick.bind(this);
                        this.clearBtn.addEventListener("click", this._handleClearClickBound);
                    }
                }
            },
            {
                key: "_setupVariables",
                value: function _setupVariables() {
                    var _this56 = this;
                    this.$modalEl = $1(Datepicker._template);
                    this.modalEl = this.$modalEl[0];
                    this.calendarEl = this.modalEl.querySelector(".datepicker-calendar");
                    this.yearTextEl = this.modalEl.querySelector(".year-text");
                    this.dateTextEl = this.modalEl.querySelector(".date-text");
                    if (this.options.showClearBtn) this.clearBtn = this.modalEl.querySelector(".datepicker-clear");
                    this.doneBtn = this.modalEl.querySelector(".datepicker-done");
                    this.cancelBtn = this.modalEl.querySelector(".datepicker-cancel");
                    this.formats = {
                        d: function() {
                            return _this56.date.getDate();
                        },
                        dd: function() {
                            var d = _this56.date.getDate();
                            return (d < 10 ? "0" : "") + d;
                        },
                        ddd: function() {
                            return _this56.options.i18n.weekdaysShort[_this56.date.getDay()];
                        },
                        dddd: function() {
                            return _this56.options.i18n.weekdays[_this56.date.getDay()];
                        },
                        m: function() {
                            return _this56.date.getMonth() + 1;
                        },
                        mm: function() {
                            var m = _this56.date.getMonth() + 1;
                            return (m < 10 ? "0" : "") + m;
                        },
                        mmm: function() {
                            return _this56.options.i18n.monthsShort[_this56.date.getMonth()];
                        },
                        mmmm: function() {
                            return _this56.options.i18n.months[_this56.date.getMonth()];
                        },
                        yy: function() {
                            return ("" + _this56.date.getFullYear()).slice(2);
                        },
                        yyyy: function() {
                            return _this56.date.getFullYear();
                        }
                    };
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    this.el.removeEventListener("click", this._handleInputClickBound);
                    this.el.removeEventListener("keydown", this._handleInputKeydownBound);
                    this.el.removeEventListener("change", this._handleInputChangeBound);
                    this.calendarEl.removeEventListener("click", this._handleCalendarClickBound);
                }
            },
            {
                key: "_handleInputClick",
                value: function _handleInputClick() {
                    this.open();
                }
            },
            {
                key: "_handleInputKeydown",
                value: function _handleInputKeydown(e) {
                    if (e.which === M.keys.ENTER) {
                        e.preventDefault();
                        this.open();
                    }
                }
            },
            {
                key: "_handleCalendarClick",
                value: function _handleCalendarClick(e) {
                    if (!this.isOpen) return;
                    var $target = $1(e.target);
                    if (!$target.hasClass("is-disabled")) {
                        if ($target.hasClass("datepicker-day-button") && !$target.hasClass("is-empty") && !$target.parent().hasClass("is-disabled")) {
                            this.setDate(new Date(e.target.getAttribute("data-year"), e.target.getAttribute("data-month"), e.target.getAttribute("data-day")));
                            if (this.options.autoClose) this._finishSelection();
                        } else if ($target.closest(".month-prev").length) this.prevMonth();
                        else if ($target.closest(".month-next").length) this.nextMonth();
                    }
                }
            },
            {
                key: "_handleClearClick",
                value: function _handleClearClick() {
                    this.date = null;
                    this.setInputValue();
                    this.close();
                }
            },
            {
                key: "_handleMonthChange",
                value: function _handleMonthChange(e) {
                    this.gotoMonth(e.target.value);
                }
            },
            {
                key: "_handleYearChange",
                value: function _handleYearChange(e) {
                    this.gotoYear(e.target.value);
                }
            },
            {
                key: "gotoMonth",
                value: function gotoMonth(month) {
                    if (!isNaN(month)) {
                        this.calendars[0].month = parseInt(month, 10);
                        this.adjustCalendars();
                    }
                }
            },
            {
                key: "gotoYear",
                value: function gotoYear(year) {
                    if (!isNaN(year)) {
                        this.calendars[0].year = parseInt(year, 10);
                        this.adjustCalendars();
                    }
                }
            },
            {
                key: "_handleInputChange",
                value: function _handleInputChange(e) {
                    var date = void 0;
                    // Prevent change event from being fired when triggered by the plugin
                    if (e.firedBy === this) return;
                    if (this.options.parse) date = this.options.parse(this.el.value, this.options.format);
                    else date = new Date(Date.parse(this.el.value));
                    if (Datepicker._isDate(date)) this.setDate(date);
                }
            },
            {
                key: "renderDayName",
                value: function renderDayName(opts, day, abbr) {
                    day += opts.firstDay;
                    while(day >= 7)day -= 7;
                    return abbr ? opts.i18n.weekdaysAbbrev[day] : opts.i18n.weekdays[day];
                }
            },
            {
                key: "_finishSelection",
                value: function _finishSelection() {
                    this.setInputValue();
                    this.close();
                }
            },
            {
                key: "open",
                value: function open() {
                    if (this.isOpen) return;
                    this.isOpen = true;
                    if (typeof this.options.onOpen === "function") this.options.onOpen.call(this);
                    this.draw();
                    this.modal.open();
                    return this;
                }
            },
            {
                key: "close",
                value: function close() {
                    if (!this.isOpen) return;
                    this.isOpen = false;
                    if (typeof this.options.onClose === "function") this.options.onClose.call(this);
                    this.modal.close();
                    return this;
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Datepicker.__proto__ || Object.getPrototypeOf(Datepicker), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "_isDate",
                value: function _isDate(obj) {
                    return /Date/.test(Object.prototype.toString.call(obj)) && !isNaN(obj.getTime());
                }
            },
            {
                key: "_isWeekend",
                value: function _isWeekend(date) {
                    var day = date.getDay();
                    return day === 0 || day === 6;
                }
            },
            {
                key: "_setToStartOfDay",
                value: function _setToStartOfDay(date) {
                    if (Datepicker._isDate(date)) date.setHours(0, 0, 0, 0);
                }
            },
            {
                key: "_getDaysInMonth",
                value: function _getDaysInMonth(year, month) {
                    return [
                        31,
                        Datepicker._isLeapYear(year) ? 29 : 28,
                        31,
                        30,
                        31,
                        30,
                        31,
                        31,
                        30,
                        31,
                        30,
                        31
                    ][month];
                }
            },
            {
                key: "_isLeapYear",
                value: function _isLeapYear(year) {
                    // solution by Matti Virkkunen: http://stackoverflow.com/a/4881951
                    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
                }
            },
            {
                key: "_compareDates",
                value: function _compareDates(a, b) {
                    // weak date comparison (use setToStartOfDay(date) to ensure correct result)
                    return a.getTime() === b.getTime();
                }
            },
            {
                key: "_setToStartOfDay",
                value: function _setToStartOfDay(date) {
                    if (Datepicker._isDate(date)) date.setHours(0, 0, 0, 0);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Datepicker;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Datepicker;
    }(Component);
    Datepicker._template = [
        '<div class= "modal datepicker-modal">',
        '<div class="modal-content datepicker-container">',
        '<div class="datepicker-date-display">',
        '<span class="year-text"></span>',
        '<span class="date-text"></span>',
        "</div>",
        '<div class="datepicker-calendar-container">',
        '<div class="datepicker-calendar"></div>',
        '<div class="datepicker-footer">',
        '<button class="btn-flat datepicker-clear waves-effect" style="visibility: hidden;" type="button"></button>',
        '<div class="confirmation-btns">',
        '<button class="btn-flat datepicker-cancel waves-effect" type="button"></button>',
        '<button class="btn-flat datepicker-done waves-effect" type="button"></button>',
        "</div>",
        "</div>",
        "</div>",
        "</div>",
        "</div>"
    ].join("");
    M.Datepicker = Datepicker;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Datepicker, "datepicker", "M_Datepicker");
})(cash);
(function($1) {
    "use strict";
    var _defaults = {
        dialRadius: 135,
        outerRadius: 105,
        innerRadius: 70,
        tickRadius: 20,
        duration: 350,
        container: null,
        defaultTime: "now",
        fromNow: 0,
        showClearBtn: false,
        // internationalization
        i18n: {
            cancel: "Cancel",
            clear: "Clear",
            done: "Ok"
        },
        autoClose: false,
        twelveHour: true,
        vibrate: true,
        // Callbacks
        onOpenStart: null,
        onOpenEnd: null,
        onCloseStart: null,
        onCloseEnd: null,
        onSelect: null
    };
    /**
   * @class
   *
   */ var Timepicker = function(_Component16) {
        _inherits(Timepicker, _Component16);
        function Timepicker(el, options) {
            _classCallCheck(this, Timepicker);
            var _this57 = _possibleConstructorReturn(this, (Timepicker.__proto__ || Object.getPrototypeOf(Timepicker)).call(this, Timepicker, el, options));
            _this57.el.M_Timepicker = _this57;
            _this57.options = $1.extend({}, Timepicker.defaults, options);
            _this57.id = M.guid();
            _this57._insertHTMLIntoDOM();
            _this57._setupModal();
            _this57._setupVariables();
            _this57._setupEventHandlers();
            _this57._clockSetup();
            _this57._pickerSetup();
            return _this57;
        }
        _createClass(Timepicker, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this._removeEventHandlers();
                    this.modal.destroy();
                    $1(this.modalEl).remove();
                    this.el.M_Timepicker = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    this._handleInputKeydownBound = this._handleInputKeydown.bind(this);
                    this._handleInputClickBound = this._handleInputClick.bind(this);
                    this._handleClockClickStartBound = this._handleClockClickStart.bind(this);
                    this._handleDocumentClickMoveBound = this._handleDocumentClickMove.bind(this);
                    this._handleDocumentClickEndBound = this._handleDocumentClickEnd.bind(this);
                    this.el.addEventListener("click", this._handleInputClickBound);
                    this.el.addEventListener("keydown", this._handleInputKeydownBound);
                    this.plate.addEventListener("mousedown", this._handleClockClickStartBound);
                    this.plate.addEventListener("touchstart", this._handleClockClickStartBound);
                    $1(this.spanHours).on("click", this.showView.bind(this, "hours"));
                    $1(this.spanMinutes).on("click", this.showView.bind(this, "minutes"));
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    this.el.removeEventListener("click", this._handleInputClickBound);
                    this.el.removeEventListener("keydown", this._handleInputKeydownBound);
                }
            },
            {
                key: "_handleInputClick",
                value: function _handleInputClick() {
                    this.open();
                }
            },
            {
                key: "_handleInputKeydown",
                value: function _handleInputKeydown(e) {
                    if (e.which === M.keys.ENTER) {
                        e.preventDefault();
                        this.open();
                    }
                }
            },
            {
                key: "_handleClockClickStart",
                value: function _handleClockClickStart(e) {
                    e.preventDefault();
                    var clockPlateBR = this.plate.getBoundingClientRect();
                    var offset = {
                        x: clockPlateBR.left,
                        y: clockPlateBR.top
                    };
                    this.x0 = offset.x + this.options.dialRadius;
                    this.y0 = offset.y + this.options.dialRadius;
                    this.moved = false;
                    var clickPos = Timepicker._Pos(e);
                    this.dx = clickPos.x - this.x0;
                    this.dy = clickPos.y - this.y0;
                    // Set clock hands
                    this.setHand(this.dx, this.dy, false);
                    // Mousemove on document
                    document.addEventListener("mousemove", this._handleDocumentClickMoveBound);
                    document.addEventListener("touchmove", this._handleDocumentClickMoveBound);
                    // Mouseup on document
                    document.addEventListener("mouseup", this._handleDocumentClickEndBound);
                    document.addEventListener("touchend", this._handleDocumentClickEndBound);
                }
            },
            {
                key: "_handleDocumentClickMove",
                value: function _handleDocumentClickMove(e) {
                    e.preventDefault();
                    var clickPos = Timepicker._Pos(e);
                    var x = clickPos.x - this.x0;
                    var y = clickPos.y - this.y0;
                    this.moved = true;
                    this.setHand(x, y, false, true);
                }
            },
            {
                key: "_handleDocumentClickEnd",
                value: function _handleDocumentClickEnd(e) {
                    var _this58 = this;
                    e.preventDefault();
                    document.removeEventListener("mouseup", this._handleDocumentClickEndBound);
                    document.removeEventListener("touchend", this._handleDocumentClickEndBound);
                    var clickPos = Timepicker._Pos(e);
                    var x = clickPos.x - this.x0;
                    var y = clickPos.y - this.y0;
                    if (this.moved && x === this.dx && y === this.dy) this.setHand(x, y);
                    if (this.currentView === "hours") this.showView("minutes", this.options.duration / 2);
                    else if (this.options.autoClose) {
                        $1(this.minutesView).addClass("timepicker-dial-out");
                        setTimeout(function() {
                            _this58.done();
                        }, this.options.duration / 2);
                    }
                    if (typeof this.options.onSelect === "function") this.options.onSelect.call(this, this.hours, this.minutes);
                    // Unbind mousemove event
                    document.removeEventListener("mousemove", this._handleDocumentClickMoveBound);
                    document.removeEventListener("touchmove", this._handleDocumentClickMoveBound);
                }
            },
            {
                key: "_insertHTMLIntoDOM",
                value: function _insertHTMLIntoDOM() {
                    this.$modalEl = $1(Timepicker._template);
                    this.modalEl = this.$modalEl[0];
                    this.modalEl.id = "modal-" + this.id;
                    // Append popover to input by default
                    var containerEl = document.querySelector(this.options.container);
                    if (this.options.container && !!containerEl) this.$modalEl.appendTo(containerEl);
                    else this.$modalEl.insertBefore(this.el);
                }
            },
            {
                key: "_setupModal",
                value: function _setupModal() {
                    var _this59 = this;
                    this.modal = M.Modal.init(this.modalEl, {
                        onOpenStart: this.options.onOpenStart,
                        onOpenEnd: this.options.onOpenEnd,
                        onCloseStart: this.options.onCloseStart,
                        onCloseEnd: function() {
                            if (typeof _this59.options.onCloseEnd === "function") _this59.options.onCloseEnd.call(_this59);
                            _this59.isOpen = false;
                        }
                    });
                }
            },
            {
                key: "_setupVariables",
                value: function _setupVariables() {
                    this.currentView = "hours";
                    this.vibrate = navigator.vibrate ? "vibrate" : navigator.webkitVibrate ? "webkitVibrate" : null;
                    this._canvas = this.modalEl.querySelector(".timepicker-canvas");
                    this.plate = this.modalEl.querySelector(".timepicker-plate");
                    this.hoursView = this.modalEl.querySelector(".timepicker-hours");
                    this.minutesView = this.modalEl.querySelector(".timepicker-minutes");
                    this.spanHours = this.modalEl.querySelector(".timepicker-span-hours");
                    this.spanMinutes = this.modalEl.querySelector(".timepicker-span-minutes");
                    this.spanAmPm = this.modalEl.querySelector(".timepicker-span-am-pm");
                    this.footer = this.modalEl.querySelector(".timepicker-footer");
                    this.amOrPm = "PM";
                }
            },
            {
                key: "_pickerSetup",
                value: function _pickerSetup() {
                    var $clearBtn = $1('<button class="btn-flat timepicker-clear waves-effect" style="visibility: hidden;" type="button" tabindex="' + (this.options.twelveHour ? "3" : "1") + '">' + this.options.i18n.clear + "</button>").appendTo(this.footer).on("click", this.clear.bind(this));
                    if (this.options.showClearBtn) $clearBtn.css({
                        visibility: ""
                    });
                    var confirmationBtnsContainer = $1('<div class="confirmation-btns"></div>');
                    $1('<button class="btn-flat timepicker-close waves-effect" type="button" tabindex="' + (this.options.twelveHour ? "3" : "1") + '">' + this.options.i18n.cancel + "</button>").appendTo(confirmationBtnsContainer).on("click", this.close.bind(this));
                    $1('<button class="btn-flat timepicker-close waves-effect" type="button" tabindex="' + (this.options.twelveHour ? "3" : "1") + '">' + this.options.i18n.done + "</button>").appendTo(confirmationBtnsContainer).on("click", this.done.bind(this));
                    confirmationBtnsContainer.appendTo(this.footer);
                }
            },
            {
                key: "_clockSetup",
                value: function _clockSetup() {
                    if (this.options.twelveHour) {
                        this.$amBtn = $1('<div class="am-btn">AM</div>');
                        this.$pmBtn = $1('<div class="pm-btn">PM</div>');
                        this.$amBtn.on("click", this._handleAmPmClick.bind(this)).appendTo(this.spanAmPm);
                        this.$pmBtn.on("click", this._handleAmPmClick.bind(this)).appendTo(this.spanAmPm);
                    }
                    this._buildHoursView();
                    this._buildMinutesView();
                    this._buildSVGClock();
                }
            },
            {
                key: "_buildSVGClock",
                value: function _buildSVGClock() {
                    // Draw clock hands and others
                    var dialRadius = this.options.dialRadius;
                    var tickRadius = this.options.tickRadius;
                    var diameter = dialRadius * 2;
                    var svg = Timepicker._createSVGEl("svg");
                    svg.setAttribute("class", "timepicker-svg");
                    svg.setAttribute("width", diameter);
                    svg.setAttribute("height", diameter);
                    var g = Timepicker._createSVGEl("g");
                    g.setAttribute("transform", "translate(" + dialRadius + "," + dialRadius + ")");
                    var bearing = Timepicker._createSVGEl("circle");
                    bearing.setAttribute("class", "timepicker-canvas-bearing");
                    bearing.setAttribute("cx", 0);
                    bearing.setAttribute("cy", 0);
                    bearing.setAttribute("r", 4);
                    var hand = Timepicker._createSVGEl("line");
                    hand.setAttribute("x1", 0);
                    hand.setAttribute("y1", 0);
                    var bg = Timepicker._createSVGEl("circle");
                    bg.setAttribute("class", "timepicker-canvas-bg");
                    bg.setAttribute("r", tickRadius);
                    g.appendChild(hand);
                    g.appendChild(bg);
                    g.appendChild(bearing);
                    svg.appendChild(g);
                    this._canvas.appendChild(svg);
                    this.hand = hand;
                    this.bg = bg;
                    this.bearing = bearing;
                    this.g = g;
                }
            },
            {
                key: "_buildHoursView",
                value: function _buildHoursView() {
                    var $tick = $1('<div class="timepicker-tick"></div>');
                    // Hours view
                    if (this.options.twelveHour) for(var i = 1; i < 13; i += 1){
                        var tick = $tick.clone();
                        var radian = i / 6 * Math.PI;
                        var radius = this.options.outerRadius;
                        tick.css({
                            left: this.options.dialRadius + Math.sin(radian) * radius - this.options.tickRadius + "px",
                            top: this.options.dialRadius - Math.cos(radian) * radius - this.options.tickRadius + "px"
                        });
                        tick.html(i === 0 ? "00" : i);
                        this.hoursView.appendChild(tick[0]);
                    // tick.on(mousedownEvent, mousedown);
                    }
                    else for(var _i2 = 0; _i2 < 24; _i2 += 1){
                        var _tick = $tick.clone();
                        var _radian = _i2 / 6 * Math.PI;
                        var inner = _i2 > 0 && _i2 < 13;
                        var _radius = inner ? this.options.innerRadius : this.options.outerRadius;
                        _tick.css({
                            left: this.options.dialRadius + Math.sin(_radian) * _radius - this.options.tickRadius + "px",
                            top: this.options.dialRadius - Math.cos(_radian) * _radius - this.options.tickRadius + "px"
                        });
                        _tick.html(_i2 === 0 ? "00" : _i2);
                        this.hoursView.appendChild(_tick[0]);
                    // tick.on(mousedownEvent, mousedown);
                    }
                }
            },
            {
                key: "_buildMinutesView",
                value: function _buildMinutesView() {
                    var $tick = $1('<div class="timepicker-tick"></div>');
                    // Minutes view
                    for(var i = 0; i < 60; i += 5){
                        var tick = $tick.clone();
                        var radian = i / 30 * Math.PI;
                        tick.css({
                            left: this.options.dialRadius + Math.sin(radian) * this.options.outerRadius - this.options.tickRadius + "px",
                            top: this.options.dialRadius - Math.cos(radian) * this.options.outerRadius - this.options.tickRadius + "px"
                        });
                        tick.html(Timepicker._addLeadingZero(i));
                        this.minutesView.appendChild(tick[0]);
                    }
                }
            },
            {
                key: "_handleAmPmClick",
                value: function _handleAmPmClick(e) {
                    var $btnClicked = $1(e.target);
                    this.amOrPm = $btnClicked.hasClass("am-btn") ? "AM" : "PM";
                    this._updateAmPmView();
                }
            },
            {
                key: "_updateAmPmView",
                value: function _updateAmPmView() {
                    if (this.options.twelveHour) {
                        this.$amBtn.toggleClass("text-primary", this.amOrPm === "AM");
                        this.$pmBtn.toggleClass("text-primary", this.amOrPm === "PM");
                    }
                }
            },
            {
                key: "_updateTimeFromInput",
                value: function _updateTimeFromInput() {
                    // Get the time
                    var value = ((this.el.value || this.options.defaultTime || "") + "").split(":");
                    if (this.options.twelveHour && !(typeof value[1] === "undefined")) {
                        if (value[1].toUpperCase().indexOf("AM") > 0) this.amOrPm = "AM";
                        else this.amOrPm = "PM";
                        value[1] = value[1].replace("AM", "").replace("PM", "");
                    }
                    if (value[0] === "now") {
                        var now = new Date(+new Date() + this.options.fromNow);
                        value = [
                            now.getHours(),
                            now.getMinutes()
                        ];
                        if (this.options.twelveHour) this.amOrPm = value[0] >= 12 && value[0] < 24 ? "PM" : "AM";
                    }
                    this.hours = +value[0] || 0;
                    this.minutes = +value[1] || 0;
                    this.spanHours.innerHTML = this.hours;
                    this.spanMinutes.innerHTML = Timepicker._addLeadingZero(this.minutes);
                    this._updateAmPmView();
                }
            },
            {
                key: "showView",
                value: function showView(view, delay) {
                    view === "minutes" && $1(this.hoursView).css("visibility");
                    var isHours = view === "hours", nextView = isHours ? this.hoursView : this.minutesView, hideView = isHours ? this.minutesView : this.hoursView;
                    this.currentView = view;
                    $1(this.spanHours).toggleClass("text-primary", isHours);
                    $1(this.spanMinutes).toggleClass("text-primary", !isHours);
                    // Transition view
                    hideView.classList.add("timepicker-dial-out");
                    $1(nextView).css("visibility", "visible").removeClass("timepicker-dial-out");
                    // Reset clock hand
                    this.resetClock(delay);
                    // After transitions ended
                    clearTimeout(this.toggleViewTimer);
                    this.toggleViewTimer = setTimeout(function() {
                        $1(hideView).css("visibility", "hidden");
                    }, this.options.duration);
                }
            },
            {
                key: "resetClock",
                value: function resetClock(delay) {
                    var view = this.currentView, value = this[view], isHours = view === "hours", unit = Math.PI / (isHours ? 6 : 30), radian = value * unit, radius = isHours && value > 0 && value < 13 ? this.options.innerRadius : this.options.outerRadius, x = Math.sin(radian) * radius, y = -Math.cos(radian) * radius, self = this;
                    if (delay) {
                        $1(this.canvas).addClass("timepicker-canvas-out");
                        setTimeout(function() {
                            $1(self.canvas).removeClass("timepicker-canvas-out");
                            self.setHand(x, y);
                        }, delay);
                    } else this.setHand(x, y);
                }
            },
            {
                key: "setHand",
                value: function setHand(x, y, roundBy5) {
                    var _this60 = this;
                    var radian = Math.atan2(x, -y), isHours = this.currentView === "hours", unit = Math.PI / (isHours || roundBy5 ? 6 : 30), z = Math.sqrt(x * x + y * y), inner = isHours && z < (this.options.outerRadius + this.options.innerRadius) / 2, radius = inner ? this.options.innerRadius : this.options.outerRadius;
                    if (this.options.twelveHour) radius = this.options.outerRadius;
                    // Radian should in range [0, 2PI]
                    if (radian < 0) radian = Math.PI * 2 + radian;
                    // Get the round value
                    var value = Math.round(radian / unit);
                    // Get the round radian
                    radian = value * unit;
                    // Correct the hours or minutes
                    if (this.options.twelveHour) {
                        if (isHours) {
                            if (value === 0) value = 12;
                        } else {
                            if (roundBy5) value *= 5;
                            if (value === 60) value = 0;
                        }
                    } else if (isHours) {
                        if (value === 12) value = 0;
                        value = inner ? value === 0 ? 12 : value : value === 0 ? 0 : value + 12;
                    } else {
                        if (roundBy5) value *= 5;
                        if (value === 60) value = 0;
                    }
                    // Once hours or minutes changed, vibrate the device
                    if (this[this.currentView] !== value) {
                        if (this.vibrate && this.options.vibrate) // Do not vibrate too frequently
                        {
                            if (!this.vibrateTimer) {
                                navigator[this.vibrate](10);
                                this.vibrateTimer = setTimeout(function() {
                                    _this60.vibrateTimer = null;
                                }, 100);
                            }
                        }
                    }
                    this[this.currentView] = value;
                    if (isHours) this["spanHours"].innerHTML = value;
                    else this["spanMinutes"].innerHTML = Timepicker._addLeadingZero(value);
                    // Set clock hand and others' position
                    var cx1 = Math.sin(radian) * (radius - this.options.tickRadius), cy1 = -Math.cos(radian) * (radius - this.options.tickRadius), cx2 = Math.sin(radian) * radius, cy2 = -Math.cos(radian) * radius;
                    this.hand.setAttribute("x2", cx1);
                    this.hand.setAttribute("y2", cy1);
                    this.bg.setAttribute("cx", cx2);
                    this.bg.setAttribute("cy", cy2);
                }
            },
            {
                key: "open",
                value: function open() {
                    if (this.isOpen) return;
                    this.isOpen = true;
                    this._updateTimeFromInput();
                    this.showView("hours");
                    this.modal.open();
                }
            },
            {
                key: "close",
                value: function close() {
                    if (!this.isOpen) return;
                    this.isOpen = false;
                    this.modal.close();
                }
            },
            {
                key: "done",
                value: function done(e, clearValue) {
                    // Set input value
                    var last = this.el.value;
                    var value = clearValue ? "" : Timepicker._addLeadingZero(this.hours) + ":" + Timepicker._addLeadingZero(this.minutes);
                    this.time = value;
                    if (!clearValue && this.options.twelveHour) value = value + " " + this.amOrPm;
                    this.el.value = value;
                    // Trigger change event
                    if (value !== last) this.$el.trigger("change");
                    this.close();
                    this.el.focus();
                }
            },
            {
                key: "clear",
                value: function clear() {
                    this.done(null, true);
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Timepicker.__proto__ || Object.getPrototypeOf(Timepicker), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "_addLeadingZero",
                value: function _addLeadingZero(num) {
                    return (num < 10 ? "0" : "") + num;
                }
            },
            {
                key: "_createSVGEl",
                value: function _createSVGEl(name1) {
                    var svgNS = "http://www.w3.org/2000/svg";
                    return document.createElementNS(svgNS, name1);
                }
            },
            {
                key: "_Pos",
                value: function _Pos(e) {
                    if (e.targetTouches && e.targetTouches.length >= 1) return {
                        x: e.targetTouches[0].clientX,
                        y: e.targetTouches[0].clientY
                    };
                    // mouse event
                    return {
                        x: e.clientX,
                        y: e.clientY
                    };
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Timepicker;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Timepicker;
    }(Component);
    Timepicker._template = [
        '<div class= "modal timepicker-modal">',
        '<div class="modal-content timepicker-container">',
        '<div class="timepicker-digital-display">',
        '<div class="timepicker-text-container">',
        '<div class="timepicker-display-column">',
        '<span class="timepicker-span-hours text-primary"></span>',
        ":",
        '<span class="timepicker-span-minutes"></span>',
        "</div>",
        '<div class="timepicker-display-column timepicker-display-am-pm">',
        '<div class="timepicker-span-am-pm"></div>',
        "</div>",
        "</div>",
        "</div>",
        '<div class="timepicker-analog-display">',
        '<div class="timepicker-plate">',
        '<div class="timepicker-canvas"></div>',
        '<div class="timepicker-dial timepicker-hours"></div>',
        '<div class="timepicker-dial timepicker-minutes timepicker-dial-out"></div>',
        "</div>",
        '<div class="timepicker-footer"></div>',
        "</div>",
        "</div>",
        "</div>"
    ].join("");
    M.Timepicker = Timepicker;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Timepicker, "timepicker", "M_Timepicker");
})(cash);
(function($1) {
    "use strict";
    var _defaults = {};
    /**
   * @class
   *
   */ var CharacterCounter = function(_Component17) {
        _inherits(CharacterCounter, _Component17);
        /**
     * Construct CharacterCounter instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function CharacterCounter(el, options) {
            _classCallCheck(this, CharacterCounter);
            var _this61 = _possibleConstructorReturn(this, (CharacterCounter.__proto__ || Object.getPrototypeOf(CharacterCounter)).call(this, CharacterCounter, el, options));
            _this61.el.M_CharacterCounter = _this61;
            /**
       * Options for the character counter
       */ _this61.options = $1.extend({}, CharacterCounter.defaults, options);
            _this61.isInvalid = false;
            _this61.isValidLength = false;
            _this61._setupCounter();
            _this61._setupEventHandlers();
            return _this61;
        }
        _createClass(CharacterCounter, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this._removeEventHandlers();
                    this.el.CharacterCounter = undefined;
                    this._removeCounter();
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    this._handleUpdateCounterBound = this.updateCounter.bind(this);
                    this.el.addEventListener("focus", this._handleUpdateCounterBound, true);
                    this.el.addEventListener("input", this._handleUpdateCounterBound, true);
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    this.el.removeEventListener("focus", this._handleUpdateCounterBound, true);
                    this.el.removeEventListener("input", this._handleUpdateCounterBound, true);
                }
            },
            {
                key: "_setupCounter",
                value: function _setupCounter() {
                    this.counterEl = document.createElement("span");
                    $1(this.counterEl).addClass("character-counter").css({
                        float: "right",
                        "font-size": "12px",
                        height: 1
                    });
                    this.$el.parent().append(this.counterEl);
                }
            },
            {
                key: "_removeCounter",
                value: function _removeCounter() {
                    $1(this.counterEl).remove();
                }
            },
            {
                key: "updateCounter",
                value: function updateCounter() {
                    var maxLength = +this.$el.attr("data-length"), actualLength = this.el.value.length;
                    this.isValidLength = actualLength <= maxLength;
                    var counterString = actualLength;
                    if (maxLength) {
                        counterString += "/" + maxLength;
                        this._validateInput();
                    }
                    $1(this.counterEl).html(counterString);
                }
            },
            {
                key: "_validateInput",
                value: function _validateInput() {
                    if (this.isValidLength && this.isInvalid) {
                        this.isInvalid = false;
                        this.$el.removeClass("invalid");
                    } else if (!this.isValidLength && !this.isInvalid) {
                        this.isInvalid = true;
                        this.$el.removeClass("valid");
                        this.$el.addClass("invalid");
                    }
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(CharacterCounter.__proto__ || Object.getPrototypeOf(CharacterCounter), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_CharacterCounter;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return CharacterCounter;
    }(Component);
    M.CharacterCounter = CharacterCounter;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(CharacterCounter, "characterCounter", "M_CharacterCounter");
})(cash);
(function($1) {
    "use strict";
    var _defaults = {
        duration: 200,
        dist: -100,
        shift: 0,
        padding: 0,
        numVisible: 5,
        fullWidth: false,
        indicators: false,
        noWrap: false,
        onCycleTo: null // Callback for when a new slide is cycled to.
    };
    /**
   * @class
   *
   */ var Carousel = function(_Component18) {
        _inherits(Carousel, _Component18);
        /**
     * Construct Carousel instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function Carousel(el, options) {
            _classCallCheck(this, Carousel);
            var _this62 = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).call(this, Carousel, el, options));
            _this62.el.M_Carousel = _this62;
            /**
       * Options for the carousel
       * @member Carousel#options
       * @prop {Number} duration
       * @prop {Number} dist
       * @prop {Number} shift
       * @prop {Number} padding
       * @prop {Number} numVisible
       * @prop {Boolean} fullWidth
       * @prop {Boolean} indicators
       * @prop {Boolean} noWrap
       * @prop {Function} onCycleTo
       */ _this62.options = $1.extend({}, Carousel.defaults, options);
            // Setup
            _this62.hasMultipleSlides = _this62.$el.find(".carousel-item").length > 1;
            _this62.showIndicators = _this62.options.indicators && _this62.hasMultipleSlides;
            _this62.noWrap = _this62.options.noWrap || !_this62.hasMultipleSlides;
            _this62.pressed = false;
            _this62.dragged = false;
            _this62.offset = _this62.target = 0;
            _this62.images = [];
            _this62.itemWidth = _this62.$el.find(".carousel-item").first().innerWidth();
            _this62.itemHeight = _this62.$el.find(".carousel-item").first().innerHeight();
            _this62.dim = _this62.itemWidth * 2 + _this62.options.padding || 1; // Make sure dim is non zero for divisions.
            _this62._autoScrollBound = _this62._autoScroll.bind(_this62);
            _this62._trackBound = _this62._track.bind(_this62);
            // Full Width carousel setup
            if (_this62.options.fullWidth) {
                _this62.options.dist = 0;
                _this62._setCarouselHeight();
                // Offset fixed items when indicators.
                if (_this62.showIndicators) _this62.$el.find(".carousel-fixed-item").addClass("with-indicators");
            }
            // Iterate through slides
            _this62.$indicators = $1('<ul class="indicators"></ul>');
            _this62.$el.find(".carousel-item").each(function(el, i) {
                _this62.images.push(el);
                if (_this62.showIndicators) {
                    var $indicator = $1('<li class="indicator-item"></li>');
                    // Add active to first by default.
                    if (i === 0) $indicator[0].classList.add("active");
                    _this62.$indicators.append($indicator);
                }
            });
            if (_this62.showIndicators) _this62.$el.append(_this62.$indicators);
            _this62.count = _this62.images.length;
            // Cap numVisible at count
            _this62.options.numVisible = Math.min(_this62.count, _this62.options.numVisible);
            // Setup cross browser string
            _this62.xform = "transform";
            [
                "webkit",
                "Moz",
                "O",
                "ms"
            ].every(function(prefix) {
                var e = prefix + "Transform";
                if (typeof document.body.style[e] !== "undefined") {
                    _this62.xform = e;
                    return false;
                }
                return true;
            });
            _this62._setupEventHandlers();
            _this62._scroll(_this62.offset);
            return _this62;
        }
        _createClass(Carousel, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this._removeEventHandlers();
                    this.el.M_Carousel = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    var _this63 = this;
                    this._handleCarouselTapBound = this._handleCarouselTap.bind(this);
                    this._handleCarouselDragBound = this._handleCarouselDrag.bind(this);
                    this._handleCarouselReleaseBound = this._handleCarouselRelease.bind(this);
                    this._handleCarouselClickBound = this._handleCarouselClick.bind(this);
                    if (typeof window.ontouchstart !== "undefined") {
                        this.el.addEventListener("touchstart", this._handleCarouselTapBound);
                        this.el.addEventListener("touchmove", this._handleCarouselDragBound);
                        this.el.addEventListener("touchend", this._handleCarouselReleaseBound);
                    }
                    this.el.addEventListener("mousedown", this._handleCarouselTapBound);
                    this.el.addEventListener("mousemove", this._handleCarouselDragBound);
                    this.el.addEventListener("mouseup", this._handleCarouselReleaseBound);
                    this.el.addEventListener("mouseleave", this._handleCarouselReleaseBound);
                    this.el.addEventListener("click", this._handleCarouselClickBound);
                    if (this.showIndicators && this.$indicators) {
                        this._handleIndicatorClickBound = this._handleIndicatorClick.bind(this);
                        this.$indicators.find(".indicator-item").each(function(el, i) {
                            el.addEventListener("click", _this63._handleIndicatorClickBound);
                        });
                    }
                    // Resize
                    var throttledResize = M.throttle(this._handleResize, 200);
                    this._handleThrottledResizeBound = throttledResize.bind(this);
                    window.addEventListener("resize", this._handleThrottledResizeBound);
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    var _this64 = this;
                    if (typeof window.ontouchstart !== "undefined") {
                        this.el.removeEventListener("touchstart", this._handleCarouselTapBound);
                        this.el.removeEventListener("touchmove", this._handleCarouselDragBound);
                        this.el.removeEventListener("touchend", this._handleCarouselReleaseBound);
                    }
                    this.el.removeEventListener("mousedown", this._handleCarouselTapBound);
                    this.el.removeEventListener("mousemove", this._handleCarouselDragBound);
                    this.el.removeEventListener("mouseup", this._handleCarouselReleaseBound);
                    this.el.removeEventListener("mouseleave", this._handleCarouselReleaseBound);
                    this.el.removeEventListener("click", this._handleCarouselClickBound);
                    if (this.showIndicators && this.$indicators) this.$indicators.find(".indicator-item").each(function(el, i) {
                        el.removeEventListener("click", _this64._handleIndicatorClickBound);
                    });
                    window.removeEventListener("resize", this._handleThrottledResizeBound);
                }
            },
            {
                key: "_handleCarouselTap",
                value: function _handleCarouselTap(e) {
                    // Fixes firefox draggable image bug
                    if (e.type === "mousedown" && $1(e.target).is("img")) e.preventDefault();
                    this.pressed = true;
                    this.dragged = false;
                    this.verticalDragged = false;
                    this.reference = this._xpos(e);
                    this.referenceY = this._ypos(e);
                    this.velocity = this.amplitude = 0;
                    this.frame = this.offset;
                    this.timestamp = Date.now();
                    clearInterval(this.ticker);
                    this.ticker = setInterval(this._trackBound, 100);
                }
            },
            {
                key: "_handleCarouselDrag",
                value: function _handleCarouselDrag(e) {
                    var x = void 0, y = void 0, delta = void 0, deltaY = void 0;
                    if (this.pressed) {
                        x = this._xpos(e);
                        y = this._ypos(e);
                        delta = this.reference - x;
                        deltaY = Math.abs(this.referenceY - y);
                        if (deltaY < 30 && !this.verticalDragged) // If vertical scrolling don't allow dragging.
                        {
                            if (delta > 2 || delta < -2) {
                                this.dragged = true;
                                this.reference = x;
                                this._scroll(this.offset + delta);
                            }
                        } else if (this.dragged) {
                            // If dragging don't allow vertical scroll.
                            e.preventDefault();
                            e.stopPropagation();
                            return false;
                        } else // Vertical scrolling.
                        this.verticalDragged = true;
                    }
                    if (this.dragged) {
                        // If dragging don't allow vertical scroll.
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    }
                }
            },
            {
                key: "_handleCarouselRelease",
                value: function _handleCarouselRelease(e) {
                    if (this.pressed) this.pressed = false;
                    else return;
                    clearInterval(this.ticker);
                    this.target = this.offset;
                    if (this.velocity > 10 || this.velocity < -10) {
                        this.amplitude = 0.9 * this.velocity;
                        this.target = this.offset + this.amplitude;
                    }
                    this.target = Math.round(this.target / this.dim) * this.dim;
                    // No wrap of items.
                    if (this.noWrap) {
                        if (this.target >= this.dim * (this.count - 1)) this.target = this.dim * (this.count - 1);
                        else if (this.target < 0) this.target = 0;
                    }
                    this.amplitude = this.target - this.offset;
                    this.timestamp = Date.now();
                    requestAnimationFrame(this._autoScrollBound);
                    if (this.dragged) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                    return false;
                }
            },
            {
                key: "_handleCarouselClick",
                value: function _handleCarouselClick(e) {
                    // Disable clicks if carousel was dragged.
                    if (this.dragged) {
                        e.preventDefault();
                        e.stopPropagation();
                        return false;
                    } else if (!this.options.fullWidth) {
                        var clickedIndex = $1(e.target).closest(".carousel-item").index();
                        var diff = this._wrap(this.center) - clickedIndex;
                        // Disable clicks if carousel was shifted by click
                        if (diff !== 0) {
                            e.preventDefault();
                            e.stopPropagation();
                        }
                        this._cycleTo(clickedIndex);
                    }
                }
            },
            {
                key: "_handleIndicatorClick",
                value: function _handleIndicatorClick(e) {
                    e.stopPropagation();
                    var indicator = $1(e.target).closest(".indicator-item");
                    if (indicator.length) this._cycleTo(indicator.index());
                }
            },
            {
                key: "_handleResize",
                value: function _handleResize(e) {
                    if (this.options.fullWidth) {
                        this.itemWidth = this.$el.find(".carousel-item").first().innerWidth();
                        this.imageHeight = this.$el.find(".carousel-item.active").height();
                        this.dim = this.itemWidth * 2 + this.options.padding;
                        this.offset = this.center * 2 * this.itemWidth;
                        this.target = this.offset;
                        this._setCarouselHeight(true);
                    } else this._scroll();
                }
            },
            {
                key: "_setCarouselHeight",
                value: function _setCarouselHeight(imageOnly) {
                    var _this65 = this;
                    var firstSlide = this.$el.find(".carousel-item.active").length ? this.$el.find(".carousel-item.active").first() : this.$el.find(".carousel-item").first();
                    var firstImage = firstSlide.find("img").first();
                    if (firstImage.length) {
                        if (firstImage[0].complete) {
                            // If image won't trigger the load event
                            var imageHeight = firstImage.height();
                            if (imageHeight > 0) this.$el.css("height", imageHeight + "px");
                            else {
                                // If image still has no height, use the natural dimensions to calculate
                                var naturalWidth = firstImage[0].naturalWidth;
                                var naturalHeight = firstImage[0].naturalHeight;
                                var adjustedHeight = this.$el.width() / naturalWidth * naturalHeight;
                                this.$el.css("height", adjustedHeight + "px");
                            }
                        } else // Get height when image is loaded normally
                        firstImage.one("load", function(el, i) {
                            _this65.$el.css("height", el.offsetHeight + "px");
                        });
                    } else if (!imageOnly) {
                        var slideHeight = firstSlide.height();
                        this.$el.css("height", slideHeight + "px");
                    }
                }
            },
            {
                key: "_xpos",
                value: function _xpos(e) {
                    // touch event
                    if (e.targetTouches && e.targetTouches.length >= 1) return e.targetTouches[0].clientX;
                    // mouse event
                    return e.clientX;
                }
            },
            {
                key: "_ypos",
                value: function _ypos(e) {
                    // touch event
                    if (e.targetTouches && e.targetTouches.length >= 1) return e.targetTouches[0].clientY;
                    // mouse event
                    return e.clientY;
                }
            },
            {
                key: "_wrap",
                value: function _wrap(x) {
                    return x >= this.count ? x % this.count : x < 0 ? this._wrap(this.count + x % this.count) : x;
                }
            },
            {
                key: "_track",
                value: function _track() {
                    var now = void 0, elapsed = void 0, delta = void 0, v = void 0;
                    now = Date.now();
                    elapsed = now - this.timestamp;
                    this.timestamp = now;
                    delta = this.offset - this.frame;
                    this.frame = this.offset;
                    v = 1000 * delta / (1 + elapsed);
                    this.velocity = 0.8 * v + 0.2 * this.velocity;
                }
            },
            {
                key: "_autoScroll",
                value: function _autoScroll() {
                    var elapsed = void 0, delta = void 0;
                    if (this.amplitude) {
                        elapsed = Date.now() - this.timestamp;
                        delta = this.amplitude * Math.exp(-elapsed / this.options.duration);
                        if (delta > 2 || delta < -2) {
                            this._scroll(this.target - delta);
                            requestAnimationFrame(this._autoScrollBound);
                        } else this._scroll(this.target);
                    }
                }
            },
            {
                key: "_scroll",
                value: function _scroll(x) {
                    var _this66 = this;
                    // Track scrolling state
                    if (!this.$el.hasClass("scrolling")) this.el.classList.add("scrolling");
                    if (this.scrollingTimeout != null) window.clearTimeout(this.scrollingTimeout);
                    this.scrollingTimeout = window.setTimeout(function() {
                        _this66.$el.removeClass("scrolling");
                    }, this.options.duration);
                    // Start actual scroll
                    var i = void 0, half = void 0, delta = void 0, dir = void 0, tween = void 0, el = void 0, alignment = void 0, zTranslation = void 0, tweenedOpacity = void 0, centerTweenedOpacity = void 0;
                    var lastCenter = this.center;
                    var numVisibleOffset = 1 / this.options.numVisible;
                    this.offset = typeof x === "number" ? x : this.offset;
                    this.center = Math.floor((this.offset + this.dim / 2) / this.dim);
                    delta = this.offset - this.center * this.dim;
                    dir = delta < 0 ? 1 : -1;
                    tween = -dir * delta * 2 / this.dim;
                    half = this.count >> 1;
                    if (this.options.fullWidth) {
                        alignment = "translateX(0)";
                        centerTweenedOpacity = 1;
                    } else {
                        alignment = "translateX(" + (this.el.clientWidth - this.itemWidth) / 2 + "px) ";
                        alignment += "translateY(" + (this.el.clientHeight - this.itemHeight) / 2 + "px)";
                        centerTweenedOpacity = 1 - numVisibleOffset * tween;
                    }
                    // Set indicator active
                    if (this.showIndicators) {
                        var diff = this.center % this.count;
                        var activeIndicator = this.$indicators.find(".indicator-item.active");
                        if (activeIndicator.index() !== diff) {
                            activeIndicator.removeClass("active");
                            this.$indicators.find(".indicator-item").eq(diff)[0].classList.add("active");
                        }
                    }
                    // center
                    // Don't show wrapped items.
                    if (!this.noWrap || this.center >= 0 && this.center < this.count) {
                        el = this.images[this._wrap(this.center)];
                        // Add active class to center item.
                        if (!$1(el).hasClass("active")) {
                            this.$el.find(".carousel-item").removeClass("active");
                            el.classList.add("active");
                        }
                        var transformString = alignment + " translateX(" + -delta / 2 + "px) translateX(" + dir * this.options.shift * tween * i + "px) translateZ(" + this.options.dist * tween + "px)";
                        this._updateItemStyle(el, centerTweenedOpacity, 0, transformString);
                    }
                    for(i = 1; i <= half; ++i){
                        // right side
                        if (this.options.fullWidth) {
                            zTranslation = this.options.dist;
                            tweenedOpacity = i === half && delta < 0 ? 1 - tween : 1;
                        } else {
                            zTranslation = this.options.dist * (i * 2 + tween * dir);
                            tweenedOpacity = 1 - numVisibleOffset * (i * 2 + tween * dir);
                        }
                        // Don't show wrapped items.
                        if (!this.noWrap || this.center + i < this.count) {
                            el = this.images[this._wrap(this.center + i)];
                            var _transformString = alignment + " translateX(" + (this.options.shift + (this.dim * i - delta) / 2) + "px) translateZ(" + zTranslation + "px)";
                            this._updateItemStyle(el, tweenedOpacity, -i, _transformString);
                        }
                        // left side
                        if (this.options.fullWidth) {
                            zTranslation = this.options.dist;
                            tweenedOpacity = i === half && delta > 0 ? 1 - tween : 1;
                        } else {
                            zTranslation = this.options.dist * (i * 2 - tween * dir);
                            tweenedOpacity = 1 - numVisibleOffset * (i * 2 - tween * dir);
                        }
                        // Don't show wrapped items.
                        if (!this.noWrap || this.center - i >= 0) {
                            el = this.images[this._wrap(this.center - i)];
                            var _transformString2 = alignment + " translateX(" + (-this.options.shift + (-this.dim * i - delta) / 2) + "px) translateZ(" + zTranslation + "px)";
                            this._updateItemStyle(el, tweenedOpacity, -i, _transformString2);
                        }
                    }
                    // center
                    // Don't show wrapped items.
                    if (!this.noWrap || this.center >= 0 && this.center < this.count) {
                        el = this.images[this._wrap(this.center)];
                        var _transformString3 = alignment + " translateX(" + -delta / 2 + "px) translateX(" + dir * this.options.shift * tween + "px) translateZ(" + this.options.dist * tween + "px)";
                        this._updateItemStyle(el, centerTweenedOpacity, 0, _transformString3);
                    }
                    // onCycleTo callback
                    var $currItem = this.$el.find(".carousel-item").eq(this._wrap(this.center));
                    if (lastCenter !== this.center && typeof this.options.onCycleTo === "function") this.options.onCycleTo.call(this, $currItem[0], this.dragged);
                    // One time callback
                    if (typeof this.oneTimeCallback === "function") {
                        this.oneTimeCallback.call(this, $currItem[0], this.dragged);
                        this.oneTimeCallback = null;
                    }
                }
            },
            {
                key: "_updateItemStyle",
                value: function _updateItemStyle(el, opacity, zIndex, transform) {
                    el.style[this.xform] = transform;
                    el.style.zIndex = zIndex;
                    el.style.opacity = opacity;
                    el.style.visibility = "visible";
                }
            },
            {
                key: "_cycleTo",
                value: function _cycleTo(n, callback) {
                    var diff = this.center % this.count - n;
                    // Account for wraparound.
                    if (!this.noWrap) {
                        if (diff < 0) {
                            if (Math.abs(diff + this.count) < Math.abs(diff)) diff += this.count;
                        } else if (diff > 0) {
                            if (Math.abs(diff - this.count) < diff) diff -= this.count;
                        }
                    }
                    this.target = this.dim * Math.round(this.offset / this.dim);
                    // Next
                    if (diff < 0) this.target += this.dim * Math.abs(diff);
                    else if (diff > 0) this.target -= this.dim * diff;
                    // Set one time callback
                    if (typeof callback === "function") this.oneTimeCallback = callback;
                    // Scroll
                    if (this.offset !== this.target) {
                        this.amplitude = this.target - this.offset;
                        this.timestamp = Date.now();
                        requestAnimationFrame(this._autoScrollBound);
                    }
                }
            },
            {
                key: "next",
                value: function next(n) {
                    if (n === undefined || isNaN(n)) n = 1;
                    var index = this.center + n;
                    if (index >= this.count || index < 0) {
                        if (this.noWrap) return;
                        index = this._wrap(index);
                    }
                    this._cycleTo(index);
                }
            },
            {
                key: "prev",
                value: function prev(n) {
                    if (n === undefined || isNaN(n)) n = 1;
                    var index = this.center - n;
                    if (index >= this.count || index < 0) {
                        if (this.noWrap) return;
                        index = this._wrap(index);
                    }
                    this._cycleTo(index);
                }
            },
            {
                key: "set",
                value: function set(n, callback) {
                    if (n === undefined || isNaN(n)) n = 0;
                    if (n > this.count || n < 0) {
                        if (this.noWrap) return;
                        n = this._wrap(n);
                    }
                    this._cycleTo(n, callback);
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Carousel.__proto__ || Object.getPrototypeOf(Carousel), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Carousel;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Carousel;
    }(Component);
    M.Carousel = Carousel;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Carousel, "carousel", "M_Carousel");
})(cash);
(function($1) {
    "use strict";
    var _defaults = {
        onOpen: undefined,
        onClose: undefined
    };
    /**
   * @class
   *
   */ var TapTarget = function(_Component19) {
        _inherits(TapTarget, _Component19);
        /**
     * Construct TapTarget instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function TapTarget(el, options) {
            _classCallCheck(this, TapTarget);
            var _this67 = _possibleConstructorReturn(this, (TapTarget.__proto__ || Object.getPrototypeOf(TapTarget)).call(this, TapTarget, el, options));
            _this67.el.M_TapTarget = _this67;
            /**
       * Options for the select
       * @member TapTarget#options
       * @prop {Function} onOpen - Callback function called when feature discovery is opened
       * @prop {Function} onClose - Callback function called when feature discovery is closed
       */ _this67.options = $1.extend({}, TapTarget.defaults, options);
            _this67.isOpen = false;
            // setup
            _this67.$origin = $1("#" + _this67.$el.attr("data-target"));
            _this67._setup();
            _this67._calculatePositioning();
            _this67._setupEventHandlers();
            return _this67;
        }
        _createClass(TapTarget, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this._removeEventHandlers();
                    this.el.TapTarget = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    this._handleDocumentClickBound = this._handleDocumentClick.bind(this);
                    this._handleTargetClickBound = this._handleTargetClick.bind(this);
                    this._handleOriginClickBound = this._handleOriginClick.bind(this);
                    this.el.addEventListener("click", this._handleTargetClickBound);
                    this.originEl.addEventListener("click", this._handleOriginClickBound);
                    // Resize
                    var throttledResize = M.throttle(this._handleResize, 200);
                    this._handleThrottledResizeBound = throttledResize.bind(this);
                    window.addEventListener("resize", this._handleThrottledResizeBound);
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    this.el.removeEventListener("click", this._handleTargetClickBound);
                    this.originEl.removeEventListener("click", this._handleOriginClickBound);
                    window.removeEventListener("resize", this._handleThrottledResizeBound);
                }
            },
            {
                key: "_handleTargetClick",
                value: function _handleTargetClick(e) {
                    this.open();
                }
            },
            {
                key: "_handleOriginClick",
                value: function _handleOriginClick(e) {
                    this.close();
                }
            },
            {
                key: "_handleResize",
                value: function _handleResize(e) {
                    this._calculatePositioning();
                }
            },
            {
                key: "_handleDocumentClick",
                value: function _handleDocumentClick(e) {
                    if (!$1(e.target).closest(".tap-target-wrapper").length) {
                        this.close();
                        e.preventDefault();
                        e.stopPropagation();
                    }
                }
            },
            {
                key: "_setup",
                value: function _setup() {
                    // Creating tap target
                    this.wrapper = this.$el.parent()[0];
                    this.waveEl = $1(this.wrapper).find(".tap-target-wave")[0];
                    this.originEl = $1(this.wrapper).find(".tap-target-origin")[0];
                    this.contentEl = this.$el.find(".tap-target-content")[0];
                    // Creating wrapper
                    if (!$1(this.wrapper).hasClass(".tap-target-wrapper")) {
                        this.wrapper = document.createElement("div");
                        this.wrapper.classList.add("tap-target-wrapper");
                        this.$el.before($1(this.wrapper));
                        this.wrapper.append(this.el);
                    }
                    // Creating content
                    if (!this.contentEl) {
                        this.contentEl = document.createElement("div");
                        this.contentEl.classList.add("tap-target-content");
                        this.$el.append(this.contentEl);
                    }
                    // Creating foreground wave
                    if (!this.waveEl) {
                        this.waveEl = document.createElement("div");
                        this.waveEl.classList.add("tap-target-wave");
                        // Creating origin
                        if (!this.originEl) {
                            this.originEl = this.$origin.clone(true, true);
                            this.originEl.addClass("tap-target-origin");
                            this.originEl.removeAttr("id");
                            this.originEl.removeAttr("style");
                            this.originEl = this.originEl[0];
                            this.waveEl.append(this.originEl);
                        }
                        this.wrapper.append(this.waveEl);
                    }
                }
            },
            {
                key: "_calculatePositioning",
                value: function _calculatePositioning() {
                    // Element or parent is fixed position?
                    var isFixed = this.$origin.css("position") === "fixed";
                    if (!isFixed) {
                        var parents = this.$origin.parents();
                        for(var i = 0; i < parents.length; i++){
                            isFixed = $1(parents[i]).css("position") == "fixed";
                            if (isFixed) break;
                        }
                    }
                    // Calculating origin
                    var originWidth = this.$origin.outerWidth();
                    var originHeight = this.$origin.outerHeight();
                    var originTop = isFixed ? this.$origin.offset().top - M.getDocumentScrollTop() : this.$origin.offset().top;
                    var originLeft = isFixed ? this.$origin.offset().left - M.getDocumentScrollLeft() : this.$origin.offset().left;
                    // Calculating screen
                    var windowWidth = window.innerWidth;
                    var windowHeight = window.innerHeight;
                    var centerX = windowWidth / 2;
                    var centerY = windowHeight / 2;
                    var isLeft = originLeft <= centerX;
                    var isRight = originLeft > centerX;
                    var isTop = originTop <= centerY;
                    var isBottom = originTop > centerY;
                    var isCenterX = originLeft >= windowWidth * 0.25 && originLeft <= windowWidth * 0.75;
                    // Calculating tap target
                    var tapTargetWidth = this.$el.outerWidth();
                    var tapTargetHeight = this.$el.outerHeight();
                    var tapTargetTop = originTop + originHeight / 2 - tapTargetHeight / 2;
                    var tapTargetLeft = originLeft + originWidth / 2 - tapTargetWidth / 2;
                    var tapTargetPosition = isFixed ? "fixed" : "absolute";
                    // Calculating content
                    var tapTargetTextWidth = isCenterX ? tapTargetWidth : tapTargetWidth / 2 + originWidth;
                    var tapTargetTextHeight = tapTargetHeight / 2;
                    var tapTargetTextTop = isTop ? tapTargetHeight / 2 : 0;
                    var tapTargetTextBottom = 0;
                    var tapTargetTextLeft = isLeft && !isCenterX ? tapTargetWidth / 2 - originWidth : 0;
                    var tapTargetTextRight = 0;
                    var tapTargetTextPadding = originWidth;
                    var tapTargetTextAlign = isBottom ? "bottom" : "top";
                    // Calculating wave
                    var tapTargetWaveWidth = originWidth > originHeight ? originWidth * 2 : originWidth * 2;
                    var tapTargetWaveHeight = tapTargetWaveWidth;
                    var tapTargetWaveTop = tapTargetHeight / 2 - tapTargetWaveHeight / 2;
                    var tapTargetWaveLeft = tapTargetWidth / 2 - tapTargetWaveWidth / 2;
                    // Setting tap target
                    var tapTargetWrapperCssObj = {};
                    tapTargetWrapperCssObj.top = isTop ? tapTargetTop + "px" : "";
                    tapTargetWrapperCssObj.right = isRight ? windowWidth - tapTargetLeft - tapTargetWidth + "px" : "";
                    tapTargetWrapperCssObj.bottom = isBottom ? windowHeight - tapTargetTop - tapTargetHeight + "px" : "";
                    tapTargetWrapperCssObj.left = isLeft ? tapTargetLeft + "px" : "";
                    tapTargetWrapperCssObj.position = tapTargetPosition;
                    $1(this.wrapper).css(tapTargetWrapperCssObj);
                    // Setting content
                    $1(this.contentEl).css({
                        width: tapTargetTextWidth + "px",
                        height: tapTargetTextHeight + "px",
                        top: tapTargetTextTop + "px",
                        right: tapTargetTextRight + "px",
                        bottom: tapTargetTextBottom + "px",
                        left: tapTargetTextLeft + "px",
                        padding: tapTargetTextPadding + "px",
                        verticalAlign: tapTargetTextAlign
                    });
                    // Setting wave
                    $1(this.waveEl).css({
                        top: tapTargetWaveTop + "px",
                        left: tapTargetWaveLeft + "px",
                        width: tapTargetWaveWidth + "px",
                        height: tapTargetWaveHeight + "px"
                    });
                }
            },
            {
                key: "open",
                value: function open() {
                    if (this.isOpen) return;
                    // onOpen callback
                    if (typeof this.options.onOpen === "function") this.options.onOpen.call(this, this.$origin[0]);
                    this.isOpen = true;
                    this.wrapper.classList.add("open");
                    document.body.addEventListener("click", this._handleDocumentClickBound, true);
                    document.body.addEventListener("touchend", this._handleDocumentClickBound);
                }
            },
            {
                key: "close",
                value: function close() {
                    if (!this.isOpen) return;
                    // onClose callback
                    if (typeof this.options.onClose === "function") this.options.onClose.call(this, this.$origin[0]);
                    this.isOpen = false;
                    this.wrapper.classList.remove("open");
                    document.body.removeEventListener("click", this._handleDocumentClickBound, true);
                    document.body.removeEventListener("touchend", this._handleDocumentClickBound);
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(TapTarget.__proto__ || Object.getPrototypeOf(TapTarget), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_TapTarget;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return TapTarget;
    }(Component);
    M.TapTarget = TapTarget;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(TapTarget, "tapTarget", "M_TapTarget");
})(cash);
(function($1) {
    "use strict";
    var _defaults = {
        classes: "",
        dropdownOptions: {}
    };
    /**
   * @class
   *
   */ var FormSelect = function(_Component20) {
        _inherits(FormSelect, _Component20);
        /**
     * Construct FormSelect instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function FormSelect(el, options) {
            _classCallCheck(this, FormSelect);
            // Don't init if browser default version
            var _this68 = _possibleConstructorReturn(this, (FormSelect.__proto__ || Object.getPrototypeOf(FormSelect)).call(this, FormSelect, el, options));
            if (_this68.$el.hasClass("browser-default")) return _possibleConstructorReturn(_this68);
            _this68.el.M_FormSelect = _this68;
            /**
       * Options for the select
       * @member FormSelect#options
       */ _this68.options = $1.extend({}, FormSelect.defaults, options);
            _this68.isMultiple = _this68.$el.prop("multiple");
            // Setup
            _this68.el.tabIndex = -1;
            _this68._keysSelected = {};
            _this68._valueDict = {}; // Maps key to original and generated option element.
            _this68._setupDropdown();
            _this68._setupEventHandlers();
            return _this68;
        }
        _createClass(FormSelect, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this._removeEventHandlers();
                    this._removeDropdown();
                    this.el.M_FormSelect = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    var _this69 = this;
                    this._handleSelectChangeBound = this._handleSelectChange.bind(this);
                    this._handleOptionClickBound = this._handleOptionClick.bind(this);
                    this._handleInputClickBound = this._handleInputClick.bind(this);
                    $1(this.dropdownOptions).find("li:not(.optgroup)").each(function(el) {
                        el.addEventListener("click", _this69._handleOptionClickBound);
                    });
                    this.el.addEventListener("change", this._handleSelectChangeBound);
                    this.input.addEventListener("click", this._handleInputClickBound);
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    var _this70 = this;
                    $1(this.dropdownOptions).find("li:not(.optgroup)").each(function(el) {
                        el.removeEventListener("click", _this70._handleOptionClickBound);
                    });
                    this.el.removeEventListener("change", this._handleSelectChangeBound);
                    this.input.removeEventListener("click", this._handleInputClickBound);
                }
            },
            {
                key: "_handleSelectChange",
                value: function _handleSelectChange(e) {
                    this._setValueToInput();
                }
            },
            {
                key: "_handleOptionClick",
                value: function _handleOptionClick(e) {
                    e.preventDefault();
                    var option = $1(e.target).closest("li")[0];
                    var key = option.id;
                    if (!$1(option).hasClass("disabled") && !$1(option).hasClass("optgroup") && key.length) {
                        var selected = true;
                        if (this.isMultiple) {
                            // Deselect placeholder option if still selected.
                            var placeholderOption = $1(this.dropdownOptions).find("li.disabled.selected");
                            if (placeholderOption.length) {
                                placeholderOption.removeClass("selected");
                                placeholderOption.find('input[type="checkbox"]').prop("checked", false);
                                this._toggleEntryFromArray(placeholderOption[0].id);
                            }
                            selected = this._toggleEntryFromArray(key);
                        } else {
                            $1(this.dropdownOptions).find("li").removeClass("selected");
                            $1(option).toggleClass("selected", selected);
                        }
                        // Set selected on original select option
                        // Only trigger if selected state changed
                        var prevSelected = $1(this._valueDict[key].el).prop("selected");
                        if (prevSelected !== selected) {
                            $1(this._valueDict[key].el).prop("selected", selected);
                            this.$el.trigger("change");
                        }
                    }
                    e.stopPropagation();
                }
            },
            {
                key: "_handleInputClick",
                value: function _handleInputClick() {
                    if (this.dropdown && this.dropdown.isOpen) {
                        this._setValueToInput();
                        this._setSelectedStates();
                    }
                }
            },
            {
                key: "_setupDropdown",
                value: function _setupDropdown() {
                    var _this71 = this;
                    this.wrapper = document.createElement("div");
                    $1(this.wrapper).addClass("select-wrapper " + this.options.classes);
                    this.$el.before($1(this.wrapper));
                    this.wrapper.appendChild(this.el);
                    if (this.el.disabled) this.wrapper.classList.add("disabled");
                    // Create dropdown
                    this.$selectOptions = this.$el.children("option, optgroup");
                    this.dropdownOptions = document.createElement("ul");
                    this.dropdownOptions.id = "select-options-" + M.guid();
                    $1(this.dropdownOptions).addClass("dropdown-content select-dropdown " + (this.isMultiple ? "multiple-select-dropdown" : ""));
                    // Create dropdown structure.
                    if (this.$selectOptions.length) this.$selectOptions.each(function(el) {
                        if ($1(el).is("option")) {
                            // Direct descendant option.
                            var optionEl = void 0;
                            if (_this71.isMultiple) optionEl = _this71._appendOptionWithIcon(_this71.$el, el, "multiple");
                            else optionEl = _this71._appendOptionWithIcon(_this71.$el, el);
                            _this71._addOptionToValueDict(el, optionEl);
                        } else if ($1(el).is("optgroup")) {
                            // Optgroup.
                            var selectOptions = $1(el).children("option");
                            $1(_this71.dropdownOptions).append($1('<li class="optgroup"><span>' + el.getAttribute("label") + "</span></li>")[0]);
                            selectOptions.each(function(el) {
                                var optionEl = _this71._appendOptionWithIcon(_this71.$el, el, "optgroup-option");
                                _this71._addOptionToValueDict(el, optionEl);
                            });
                        }
                    });
                    this.$el.after(this.dropdownOptions);
                    // Add input dropdown
                    this.input = document.createElement("input");
                    $1(this.input).addClass("select-dropdown dropdown-trigger");
                    this.input.setAttribute("type", "text");
                    this.input.setAttribute("readonly", "true");
                    this.input.setAttribute("data-target", this.dropdownOptions.id);
                    if (this.el.disabled) $1(this.input).prop("disabled", "true");
                    this.$el.before(this.input);
                    this._setValueToInput();
                    // Add caret
                    var dropdownIcon = $1('<svg class="caret" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/><path d="M0 0h24v24H0z" fill="none"/></svg>');
                    this.$el.before(dropdownIcon[0]);
                    // Initialize dropdown
                    if (!this.el.disabled) {
                        var dropdownOptions = $1.extend({}, this.options.dropdownOptions);
                        // Add callback for centering selected option when dropdown content is scrollable
                        dropdownOptions.onOpenEnd = function(el) {
                            var selectedOption = $1(_this71.dropdownOptions).find(".selected").first();
                            if (selectedOption.length) {
                                // Focus selected option in dropdown
                                M.keyDown = true;
                                _this71.dropdown.focusedIndex = selectedOption.index();
                                _this71.dropdown._focusFocusedItem();
                                M.keyDown = false;
                                // Handle scrolling to selected option
                                if (_this71.dropdown.isScrollable) {
                                    var scrollOffset = selectedOption[0].getBoundingClientRect().top - _this71.dropdownOptions.getBoundingClientRect().top; // scroll to selected option
                                    scrollOffset -= _this71.dropdownOptions.clientHeight / 2; // center in dropdown
                                    _this71.dropdownOptions.scrollTop = scrollOffset;
                                }
                            }
                        };
                        if (this.isMultiple) dropdownOptions.closeOnClick = false;
                        this.dropdown = M.Dropdown.init(this.input, dropdownOptions);
                    }
                    // Add initial selections
                    this._setSelectedStates();
                }
            },
            {
                key: "_addOptionToValueDict",
                value: function _addOptionToValueDict(el, optionEl) {
                    var index = Object.keys(this._valueDict).length;
                    var key = this.dropdownOptions.id + index;
                    var obj = {};
                    optionEl.id = key;
                    obj.el = el;
                    obj.optionEl = optionEl;
                    this._valueDict[key] = obj;
                }
            },
            {
                key: "_removeDropdown",
                value: function _removeDropdown() {
                    $1(this.wrapper).find(".caret").remove();
                    $1(this.input).remove();
                    $1(this.dropdownOptions).remove();
                    $1(this.wrapper).before(this.$el);
                    $1(this.wrapper).remove();
                }
            },
            {
                key: "_appendOptionWithIcon",
                value: function _appendOptionWithIcon(select, option, type) {
                    // Add disabled attr if disabled
                    var disabledClass = option.disabled ? "disabled " : "";
                    var optgroupClass = type === "optgroup-option" ? "optgroup-option " : "";
                    var multipleCheckbox = this.isMultiple ? '<label><input type="checkbox"' + disabledClass + '"/><span>' + option.innerHTML + "</span></label>" : option.innerHTML;
                    var liEl = $1("<li></li>");
                    var spanEl = $1("<span></span>");
                    spanEl.html(multipleCheckbox);
                    liEl.addClass(disabledClass + " " + optgroupClass);
                    liEl.append(spanEl);
                    // add icons
                    var iconUrl = option.getAttribute("data-icon");
                    if (!!iconUrl) {
                        var imgEl = $1('<img alt="" src="' + iconUrl + '">');
                        liEl.prepend(imgEl);
                    }
                    // Check for multiple type.
                    $1(this.dropdownOptions).append(liEl[0]);
                    return liEl[0];
                }
            },
            {
                key: "_toggleEntryFromArray",
                value: function _toggleEntryFromArray(key) {
                    var notAdded = !this._keysSelected.hasOwnProperty(key);
                    var $optionLi = $1(this._valueDict[key].optionEl);
                    if (notAdded) this._keysSelected[key] = true;
                    else delete this._keysSelected[key];
                    $optionLi.toggleClass("selected", notAdded);
                    // Set checkbox checked value
                    $optionLi.find('input[type="checkbox"]').prop("checked", notAdded);
                    // use notAdded instead of true (to detect if the option is selected or not)
                    $optionLi.prop("selected", notAdded);
                    return notAdded;
                }
            },
            {
                key: "_setValueToInput",
                value: function _setValueToInput() {
                    var values = [];
                    var options = this.$el.find("option");
                    options.each(function(el) {
                        if ($1(el).prop("selected")) {
                            var text = $1(el).text();
                            values.push(text);
                        }
                    });
                    if (!values.length) {
                        var firstDisabled = this.$el.find("option:disabled").eq(0);
                        if (firstDisabled.length && firstDisabled[0].value === "") values.push(firstDisabled.text());
                    }
                    this.input.value = values.join(", ");
                }
            },
            {
                key: "_setSelectedStates",
                value: function _setSelectedStates() {
                    this._keysSelected = {};
                    for(var key in this._valueDict){
                        var option = this._valueDict[key];
                        var optionIsSelected = $1(option.el).prop("selected");
                        $1(option.optionEl).find('input[type="checkbox"]').prop("checked", optionIsSelected);
                        if (optionIsSelected) {
                            this._activateOption($1(this.dropdownOptions), $1(option.optionEl));
                            this._keysSelected[key] = true;
                        } else $1(option.optionEl).removeClass("selected");
                    }
                }
            },
            {
                key: "_activateOption",
                value: function _activateOption(collection, newOption) {
                    if (newOption) {
                        if (!this.isMultiple) collection.find("li.selected").removeClass("selected");
                        var option = $1(newOption);
                        option.addClass("selected");
                    }
                }
            },
            {
                key: "getSelectedValues",
                value: function getSelectedValues() {
                    var selectedValues = [];
                    for(var key in this._keysSelected)selectedValues.push(this._valueDict[key].el.value);
                    return selectedValues;
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(FormSelect.__proto__ || Object.getPrototypeOf(FormSelect), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_FormSelect;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return FormSelect;
    }(Component);
    M.FormSelect = FormSelect;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(FormSelect, "formSelect", "M_FormSelect");
})(cash);
(function($1, anim) {
    "use strict";
    var _defaults = {};
    /**
   * @class
   *
   */ var Range = function(_Component21) {
        _inherits(Range, _Component21);
        /**
     * Construct Range instance
     * @constructor
     * @param {Element} el
     * @param {Object} options
     */ function Range(el, options) {
            _classCallCheck(this, Range);
            var _this72 = _possibleConstructorReturn(this, (Range.__proto__ || Object.getPrototypeOf(Range)).call(this, Range, el, options));
            _this72.el.M_Range = _this72;
            /**
       * Options for the range
       * @member Range#options
       */ _this72.options = $1.extend({}, Range.defaults, options);
            _this72._mousedown = false;
            // Setup
            _this72._setupThumb();
            _this72._setupEventHandlers();
            return _this72;
        }
        _createClass(Range, [
            {
                key: "destroy",
                /**
       * Teardown component
       */ value: function destroy() {
                    this._removeEventHandlers();
                    this._removeThumb();
                    this.el.M_Range = undefined;
                }
            },
            {
                key: "_setupEventHandlers",
                value: function _setupEventHandlers() {
                    this._handleRangeChangeBound = this._handleRangeChange.bind(this);
                    this._handleRangeMousedownTouchstartBound = this._handleRangeMousedownTouchstart.bind(this);
                    this._handleRangeInputMousemoveTouchmoveBound = this._handleRangeInputMousemoveTouchmove.bind(this);
                    this._handleRangeMouseupTouchendBound = this._handleRangeMouseupTouchend.bind(this);
                    this._handleRangeBlurMouseoutTouchleaveBound = this._handleRangeBlurMouseoutTouchleave.bind(this);
                    this.el.addEventListener("change", this._handleRangeChangeBound);
                    this.el.addEventListener("mousedown", this._handleRangeMousedownTouchstartBound);
                    this.el.addEventListener("touchstart", this._handleRangeMousedownTouchstartBound);
                    this.el.addEventListener("input", this._handleRangeInputMousemoveTouchmoveBound);
                    this.el.addEventListener("mousemove", this._handleRangeInputMousemoveTouchmoveBound);
                    this.el.addEventListener("touchmove", this._handleRangeInputMousemoveTouchmoveBound);
                    this.el.addEventListener("mouseup", this._handleRangeMouseupTouchendBound);
                    this.el.addEventListener("touchend", this._handleRangeMouseupTouchendBound);
                    this.el.addEventListener("blur", this._handleRangeBlurMouseoutTouchleaveBound);
                    this.el.addEventListener("mouseout", this._handleRangeBlurMouseoutTouchleaveBound);
                    this.el.addEventListener("touchleave", this._handleRangeBlurMouseoutTouchleaveBound);
                }
            },
            {
                key: "_removeEventHandlers",
                value: function _removeEventHandlers() {
                    this.el.removeEventListener("change", this._handleRangeChangeBound);
                    this.el.removeEventListener("mousedown", this._handleRangeMousedownTouchstartBound);
                    this.el.removeEventListener("touchstart", this._handleRangeMousedownTouchstartBound);
                    this.el.removeEventListener("input", this._handleRangeInputMousemoveTouchmoveBound);
                    this.el.removeEventListener("mousemove", this._handleRangeInputMousemoveTouchmoveBound);
                    this.el.removeEventListener("touchmove", this._handleRangeInputMousemoveTouchmoveBound);
                    this.el.removeEventListener("mouseup", this._handleRangeMouseupTouchendBound);
                    this.el.removeEventListener("touchend", this._handleRangeMouseupTouchendBound);
                    this.el.removeEventListener("blur", this._handleRangeBlurMouseoutTouchleaveBound);
                    this.el.removeEventListener("mouseout", this._handleRangeBlurMouseoutTouchleaveBound);
                    this.el.removeEventListener("touchleave", this._handleRangeBlurMouseoutTouchleaveBound);
                }
            },
            {
                key: "_handleRangeChange",
                value: function _handleRangeChange() {
                    $1(this.value).html(this.$el.val());
                    if (!$1(this.thumb).hasClass("active")) this._showRangeBubble();
                    var offsetLeft = this._calcRangeOffset();
                    $1(this.thumb).addClass("active").css("left", offsetLeft + "px");
                }
            },
            {
                key: "_handleRangeMousedownTouchstart",
                value: function _handleRangeMousedownTouchstart(e) {
                    // Set indicator value
                    $1(this.value).html(this.$el.val());
                    this._mousedown = true;
                    this.$el.addClass("active");
                    if (!$1(this.thumb).hasClass("active")) this._showRangeBubble();
                    if (e.type !== "input") {
                        var offsetLeft = this._calcRangeOffset();
                        $1(this.thumb).addClass("active").css("left", offsetLeft + "px");
                    }
                }
            },
            {
                key: "_handleRangeInputMousemoveTouchmove",
                value: function _handleRangeInputMousemoveTouchmove() {
                    if (this._mousedown) {
                        if (!$1(this.thumb).hasClass("active")) this._showRangeBubble();
                        var offsetLeft = this._calcRangeOffset();
                        $1(this.thumb).addClass("active").css("left", offsetLeft + "px");
                        $1(this.value).html(this.$el.val());
                    }
                }
            },
            {
                key: "_handleRangeMouseupTouchend",
                value: function _handleRangeMouseupTouchend() {
                    this._mousedown = false;
                    this.$el.removeClass("active");
                }
            },
            {
                key: "_handleRangeBlurMouseoutTouchleave",
                value: function _handleRangeBlurMouseoutTouchleave() {
                    if (!this._mousedown) {
                        var paddingLeft = parseInt(this.$el.css("padding-left"));
                        var marginLeft = 7 + paddingLeft + "px";
                        if ($1(this.thumb).hasClass("active")) {
                            anim.remove(this.thumb);
                            anim({
                                targets: this.thumb,
                                height: 0,
                                width: 0,
                                top: 10,
                                easing: "easeOutQuad",
                                marginLeft: marginLeft,
                                duration: 100
                            });
                        }
                        $1(this.thumb).removeClass("active");
                    }
                }
            },
            {
                key: "_setupThumb",
                value: function _setupThumb() {
                    this.thumb = document.createElement("span");
                    this.value = document.createElement("span");
                    $1(this.thumb).addClass("thumb");
                    $1(this.value).addClass("value");
                    $1(this.thumb).append(this.value);
                    this.$el.after(this.thumb);
                }
            },
            {
                key: "_removeThumb",
                value: function _removeThumb() {
                    $1(this.thumb).remove();
                }
            },
            {
                key: "_showRangeBubble",
                value: function _showRangeBubble() {
                    var paddingLeft = parseInt($1(this.thumb).parent().css("padding-left"));
                    var marginLeft = -7 + paddingLeft + "px"; // TODO: fix magic number?
                    anim.remove(this.thumb);
                    anim({
                        targets: this.thumb,
                        height: 30,
                        width: 30,
                        top: -30,
                        marginLeft: marginLeft,
                        duration: 300,
                        easing: "easeOutQuint"
                    });
                }
            },
            {
                key: "_calcRangeOffset",
                value: function _calcRangeOffset() {
                    var width = this.$el.width() - 15;
                    var max = parseFloat(this.$el.attr("max")) || 100; // Range default max
                    var min = parseFloat(this.$el.attr("min")) || 0; // Range default min
                    var percent = (parseFloat(this.$el.val()) - min) / (max - min);
                    return percent * width;
                }
            }
        ], [
            {
                key: "init",
                value: function init(els, options) {
                    return _get(Range.__proto__ || Object.getPrototypeOf(Range), "init", this).call(this, this, els, options);
                }
            },
            {
                key: "getInstance",
                value: function getInstance(el) {
                    var domElem = !!el.jquery ? el[0] : el;
                    return domElem.M_Range;
                }
            },
            {
                key: "defaults",
                get: function() {
                    return _defaults;
                }
            }
        ]);
        return Range;
    }(Component);
    M.Range = Range;
    if (M.jQueryLoaded) M.initializeJqueryWrapper(Range, "range", "M_Range");
    Range.init($1("input[type=range]"));
})(cash, M.anime);

});


/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $3233927aa82734f9$var$t = globalThis, $3233927aa82734f9$export$b4d10f6001c083c2 = $3233927aa82734f9$var$t.ShadowRoot && (void 0 === $3233927aa82734f9$var$t.ShadyCSS || $3233927aa82734f9$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $3233927aa82734f9$var$s = Symbol(), $3233927aa82734f9$var$o = new WeakMap;
class $3233927aa82734f9$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $3233927aa82734f9$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($3233927aa82734f9$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $3233927aa82734f9$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $3233927aa82734f9$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $3233927aa82734f9$export$8d80f9cac07cdb3 = (t)=>new $3233927aa82734f9$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $3233927aa82734f9$var$s), $3233927aa82734f9$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $3233927aa82734f9$export$505d1e8739bad805(o, t, $3233927aa82734f9$var$s);
}, $3233927aa82734f9$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($3233927aa82734f9$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $3233927aa82734f9$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $3233927aa82734f9$export$ee69dfd951e24778 = $3233927aa82734f9$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $3233927aa82734f9$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $27fcf98b67c2a783$var$i, defineProperty: $27fcf98b67c2a783$var$e, getOwnPropertyDescriptor: $27fcf98b67c2a783$var$r, getOwnPropertyNames: $27fcf98b67c2a783$var$h, getOwnPropertySymbols: $27fcf98b67c2a783$var$o, getPrototypeOf: $27fcf98b67c2a783$var$n } = Object, $27fcf98b67c2a783$var$a = globalThis, $27fcf98b67c2a783$var$c = $27fcf98b67c2a783$var$a.trustedTypes, $27fcf98b67c2a783$var$l = $27fcf98b67c2a783$var$c ? $27fcf98b67c2a783$var$c.emptyScript : "", $27fcf98b67c2a783$var$p = $27fcf98b67c2a783$var$a.reactiveElementPolyfillSupport, $27fcf98b67c2a783$var$d = (t, s)=>t, $27fcf98b67c2a783$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $27fcf98b67c2a783$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $27fcf98b67c2a783$export$53a6892c50694894 = (t, s)=>!$27fcf98b67c2a783$var$i(t, s), $27fcf98b67c2a783$var$y = {
    attribute: !0,
    type: String,
    converter: $27fcf98b67c2a783$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $27fcf98b67c2a783$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $27fcf98b67c2a783$var$a.litPropertyMetadata ??= new WeakMap;
class $27fcf98b67c2a783$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $27fcf98b67c2a783$var$y) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), r = this.getPropertyDescriptor(t, i, s);
            void 0 !== r && $27fcf98b67c2a783$var$e(this.prototype, t, r);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: h } = $27fcf98b67c2a783$var$r(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get () {
                return e?.call(this);
            },
            set (s) {
                const r = e?.call(this);
                h.call(this, s), this.requestUpdate(t, r, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $27fcf98b67c2a783$var$y;
    }
    static _$Ei() {
        if (this.hasOwnProperty($27fcf98b67c2a783$var$d("elementProperties"))) return;
        const t = $27fcf98b67c2a783$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($27fcf98b67c2a783$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($27fcf98b67c2a783$var$d("properties"))) {
            const t = this.properties, s = [
                ...$27fcf98b67c2a783$var$h(t),
                ...$27fcf98b67c2a783$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $3233927aa82734f9$export$ee69dfd951e24778)(s));
        } else void 0 !== s && i.push((0, $3233927aa82734f9$export$ee69dfd951e24778)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $3233927aa82734f9$export$2ca4a66ec4cecb90)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$EC(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const r = (void 0 !== i.converter?.toAttribute ? i.converter : $27fcf98b67c2a783$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == r ? this.removeAttribute(e) : this.setAttribute(e, r), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), r = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $27fcf98b67c2a783$export$7312b35fbf521afb;
            this._$Em = e, this[e] = r.fromAttribute(s, t.type), this._$Em = null;
        }
    }
    requestUpdate(t, s, i) {
        if (void 0 !== t) {
            if (i ??= this.constructor.getPropertyOptions(t), !(i.hasChanged ?? $27fcf98b67c2a783$export$53a6892c50694894)(this[t], s)) return;
            this.P(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$ET());
    }
    P(t, s, i) {
        this._$AL.has(t) || this._$AL.set(t, s), !0 === i.reflect && this._$Em !== t && (this._$Ej ??= new Set).add(t);
    }
    async _$ET() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t)!0 !== i.wrapped || this._$AL.has(s) || void 0 === this[s] || this.P(s, this[s], i);
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EU();
        } catch (s) {
            throw t = !1, this._$EU(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EU() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Ej &&= this._$Ej.forEach((t)=>this._$EC(t, this[t])), this._$EU();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$27fcf98b67c2a783$export$c7c07a37856565d.elementStyles = [], $27fcf98b67c2a783$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $27fcf98b67c2a783$export$c7c07a37856565d[$27fcf98b67c2a783$var$d("elementProperties")] = new Map, $27fcf98b67c2a783$export$c7c07a37856565d[$27fcf98b67c2a783$var$d("finalized")] = new Map, $27fcf98b67c2a783$var$p?.({
    ReactiveElement: $27fcf98b67c2a783$export$c7c07a37856565d
}), ($27fcf98b67c2a783$var$a.reactiveElementVersions ??= []).push("2.0.4");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e5ed8027d647799b$var$t = globalThis, $e5ed8027d647799b$var$i = $e5ed8027d647799b$var$t.trustedTypes, $e5ed8027d647799b$var$s = $e5ed8027d647799b$var$i ? $e5ed8027d647799b$var$i.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $e5ed8027d647799b$var$e = "$lit$", $e5ed8027d647799b$var$h = `lit$${Math.random().toFixed(9).slice(2)}$`, $e5ed8027d647799b$var$o = "?" + $e5ed8027d647799b$var$h, $e5ed8027d647799b$var$n = `<${$e5ed8027d647799b$var$o}>`, $e5ed8027d647799b$var$r = document, $e5ed8027d647799b$var$l = ()=>$e5ed8027d647799b$var$r.createComment(""), $e5ed8027d647799b$var$c = (t)=>null === t || "object" != typeof t && "function" != typeof t, $e5ed8027d647799b$var$a = Array.isArray, $e5ed8027d647799b$var$u = (t)=>$e5ed8027d647799b$var$a(t) || "function" == typeof t?.[Symbol.iterator], $e5ed8027d647799b$var$d = "[ 	\n\f\r]", $e5ed8027d647799b$var$f = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $e5ed8027d647799b$var$v = /-->/g, $e5ed8027d647799b$var$_ = />/g, $e5ed8027d647799b$var$m = RegExp(`>|${$e5ed8027d647799b$var$d}(?:([^\\s"'>=/]+)(${$e5ed8027d647799b$var$d}*=${$e5ed8027d647799b$var$d}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $e5ed8027d647799b$var$p = /'/g, $e5ed8027d647799b$var$g = /"/g, $e5ed8027d647799b$var$$ = /^(?:script|style|textarea|title)$/i, $e5ed8027d647799b$var$y = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $e5ed8027d647799b$export$c0bb0b647f701bb5 = $e5ed8027d647799b$var$y(1), $e5ed8027d647799b$export$7ed1367e7fa1ad68 = $e5ed8027d647799b$var$y(2), $e5ed8027d647799b$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $e5ed8027d647799b$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $e5ed8027d647799b$var$A = new WeakMap, $e5ed8027d647799b$var$E = $e5ed8027d647799b$var$r.createTreeWalker($e5ed8027d647799b$var$r, 129);
function $e5ed8027d647799b$var$C(t, i) {
    if (!Array.isArray(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $e5ed8027d647799b$var$s ? $e5ed8027d647799b$var$s.createHTML(i) : i;
}
const $e5ed8027d647799b$var$P = (t, i)=>{
    const s = t.length - 1, o = [];
    let r, l = 2 === i ? "<svg>" : "", c = $e5ed8027d647799b$var$f;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, y = 0;
        for(; y < s.length && (c.lastIndex = y, u = c.exec(s), null !== u);)y = c.lastIndex, c === $e5ed8027d647799b$var$f ? "!--" === u[1] ? c = $e5ed8027d647799b$var$v : void 0 !== u[1] ? c = $e5ed8027d647799b$var$_ : void 0 !== u[2] ? ($e5ed8027d647799b$var$$.test(u[2]) && (r = RegExp("</" + u[2], "g")), c = $e5ed8027d647799b$var$m) : void 0 !== u[3] && (c = $e5ed8027d647799b$var$m) : c === $e5ed8027d647799b$var$m ? ">" === u[0] ? (c = r ?? $e5ed8027d647799b$var$f, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $e5ed8027d647799b$var$m : '"' === u[3] ? $e5ed8027d647799b$var$g : $e5ed8027d647799b$var$p) : c === $e5ed8027d647799b$var$g || c === $e5ed8027d647799b$var$p ? c = $e5ed8027d647799b$var$m : c === $e5ed8027d647799b$var$v || c === $e5ed8027d647799b$var$_ ? c = $e5ed8027d647799b$var$f : (c = $e5ed8027d647799b$var$m, r = void 0);
        const x = c === $e5ed8027d647799b$var$m && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $e5ed8027d647799b$var$f ? s + $e5ed8027d647799b$var$n : d >= 0 ? (o.push(a), s.slice(0, d) + $e5ed8027d647799b$var$e + s.slice(d) + $e5ed8027d647799b$var$h + x) : s + $e5ed8027d647799b$var$h + (-2 === d ? i : x);
    }
    return [
        $e5ed8027d647799b$var$C(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : "")),
        o
    ];
};
class $e5ed8027d647799b$var$V {
    constructor({ strings: t, _$litType$: s }, n){
        let r;
        this.parts = [];
        let c = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $e5ed8027d647799b$var$P(t, s);
        if (this.el = $e5ed8027d647799b$var$V.createElement(f, n), $e5ed8027d647799b$var$E.currentNode = this.el.content, 2 === s) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $e5ed8027d647799b$var$E.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($e5ed8027d647799b$var$e)) {
                    const i = v[a++], s = r.getAttribute(t).split($e5ed8027d647799b$var$h), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: c,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $e5ed8027d647799b$var$k : "?" === e[1] ? $e5ed8027d647799b$var$H : "@" === e[1] ? $e5ed8027d647799b$var$I : $e5ed8027d647799b$var$R
                    }), r.removeAttribute(t);
                } else t.startsWith($e5ed8027d647799b$var$h) && (d.push({
                    type: 6,
                    index: c
                }), r.removeAttribute(t));
                if ($e5ed8027d647799b$var$$.test(r.tagName)) {
                    const t = r.textContent.split($e5ed8027d647799b$var$h), s = t.length - 1;
                    if (s > 0) {
                        r.textContent = $e5ed8027d647799b$var$i ? $e5ed8027d647799b$var$i.emptyScript : "";
                        for(let i = 0; i < s; i++)r.append(t[i], $e5ed8027d647799b$var$l()), $e5ed8027d647799b$var$E.nextNode(), d.push({
                            type: 2,
                            index: ++c
                        });
                        r.append(t[s], $e5ed8027d647799b$var$l());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $e5ed8027d647799b$var$o) d.push({
                    type: 2,
                    index: c
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($e5ed8027d647799b$var$h, t + 1));)d.push({
                        type: 7,
                        index: c
                    }), t += $e5ed8027d647799b$var$h.length - 1;
                }
            }
            c++;
        }
    }
    static createElement(t, i) {
        const s = $e5ed8027d647799b$var$r.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $e5ed8027d647799b$var$N(t, i, s = t, e) {
    if (i === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $e5ed8027d647799b$var$c(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $e5ed8027d647799b$var$N(t, h._$AS(t, i.values), h, e)), i;
}
class $e5ed8027d647799b$var$S {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $e5ed8027d647799b$var$r).importNode(i, !0);
        $e5ed8027d647799b$var$E.currentNode = e;
        let h = $e5ed8027d647799b$var$E.nextNode(), o = 0, n = 0, l = s[0];
        for(; void 0 !== l;){
            if (o === l.index) {
                let i;
                2 === l.type ? i = new $e5ed8027d647799b$var$M(h, h.nextSibling, this, t) : 1 === l.type ? i = new l.ctor(h, l.name, l.strings, this, t) : 6 === l.type && (i = new $e5ed8027d647799b$var$L(h, this, t)), this._$AV.push(i), l = s[++n];
            }
            o !== l?.index && (h = $e5ed8027d647799b$var$E.nextNode(), o++);
        }
        return $e5ed8027d647799b$var$E.currentNode = $e5ed8027d647799b$var$r, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $e5ed8027d647799b$var$M {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $e5ed8027d647799b$var$N(this, t, i), $e5ed8027d647799b$var$c(t) ? t === $e5ed8027d647799b$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && this._$AR(), this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee) : t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $e5ed8027d647799b$var$u(t) ? this.k(t) : this._(t);
    }
    S(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.S(t));
    }
    _(t) {
        this._$AH !== $e5ed8027d647799b$export$45b790e32b2810ee && $e5ed8027d647799b$var$c(this._$AH) ? this._$AA.nextSibling.data = t : this.T($e5ed8027d647799b$var$r.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $e5ed8027d647799b$var$V.createElement($e5ed8027d647799b$var$C(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $e5ed8027d647799b$var$S(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $e5ed8027d647799b$var$A.get(t.strings);
        return void 0 === i && $e5ed8027d647799b$var$A.set(t.strings, i = new $e5ed8027d647799b$var$V(t)), i;
    }
    k(t) {
        $e5ed8027d647799b$var$a(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $e5ed8027d647799b$var$M(this.S($e5ed8027d647799b$var$l()), this.S($e5ed8027d647799b$var$l()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $e5ed8027d647799b$var$R {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $e5ed8027d647799b$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $e5ed8027d647799b$var$N(this, t, i, 0), o = !$e5ed8027d647799b$var$c(t) || t !== this._$AH && t !== $e5ed8027d647799b$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $e5ed8027d647799b$var$N(this, e[s + n], i, n), r === $e5ed8027d647799b$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$e5ed8027d647799b$var$c(r) || r !== this._$AH[n], r === $e5ed8027d647799b$export$45b790e32b2810ee ? t = $e5ed8027d647799b$export$45b790e32b2810ee : t !== $e5ed8027d647799b$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $e5ed8027d647799b$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $e5ed8027d647799b$var$k extends $e5ed8027d647799b$var$R {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $e5ed8027d647799b$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $e5ed8027d647799b$var$H extends $e5ed8027d647799b$var$R {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $e5ed8027d647799b$export$45b790e32b2810ee);
    }
}
class $e5ed8027d647799b$var$I extends $e5ed8027d647799b$var$R {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $e5ed8027d647799b$var$N(this, t, i, 0) ?? $e5ed8027d647799b$export$45b790e32b2810ee) === $e5ed8027d647799b$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $e5ed8027d647799b$export$45b790e32b2810ee && s !== $e5ed8027d647799b$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $e5ed8027d647799b$export$45b790e32b2810ee && (s === $e5ed8027d647799b$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $e5ed8027d647799b$var$L {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $e5ed8027d647799b$var$N(this, t);
    }
}
const $e5ed8027d647799b$export$8613d1ca9052b22e = {
    P: $e5ed8027d647799b$var$e,
    A: $e5ed8027d647799b$var$h,
    C: $e5ed8027d647799b$var$o,
    M: 1,
    L: $e5ed8027d647799b$var$P,
    R: $e5ed8027d647799b$var$S,
    D: $e5ed8027d647799b$var$u,
    V: $e5ed8027d647799b$var$N,
    I: $e5ed8027d647799b$var$M,
    H: $e5ed8027d647799b$var$R,
    N: $e5ed8027d647799b$var$H,
    U: $e5ed8027d647799b$var$I,
    B: $e5ed8027d647799b$var$k,
    F: $e5ed8027d647799b$var$L
}, $e5ed8027d647799b$var$Z = $e5ed8027d647799b$var$t.litHtmlPolyfillSupport;
$e5ed8027d647799b$var$Z?.($e5ed8027d647799b$var$V, $e5ed8027d647799b$var$M), ($e5ed8027d647799b$var$t.litHtmlVersions ??= []).push("3.1.4");
const $e5ed8027d647799b$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $e5ed8027d647799b$var$M(i.insertBefore($e5ed8027d647799b$var$l(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $fe586ba0757c37f7$export$3f2f9f5909897157 extends (0, $27fcf98b67c2a783$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const i = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $e5ed8027d647799b$export$b3890eb0ae9dca99)(i, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, $e5ed8027d647799b$export$9c068ae9cc5db4e8;
    }
}
$fe586ba0757c37f7$export$3f2f9f5909897157._$litElement$ = !0, $fe586ba0757c37f7$export$3f2f9f5909897157["finalized"] = !0, globalThis.litElementHydrateSupport?.({
    LitElement: $fe586ba0757c37f7$export$3f2f9f5909897157
});
const $fe586ba0757c37f7$var$r = globalThis.litElementPolyfillSupport;
$fe586ba0757c37f7$var$r?.({
    LitElement: $fe586ba0757c37f7$export$3f2f9f5909897157
});
const $fe586ba0757c37f7$export$f5c524615a7708d6 = {
    _$AK: (t, e, i)=>{
        t._$AK(e, i);
    },
    _$AL: (t)=>t._$AL
};
(globalThis.litElementVersions ??= []).push("4.0.6");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $650ed036964a13b8$export$6acf61af03e62db = !1;






class $269cb425db2ec96d$var$ComponentBase extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    static get tagName() {
        return "ncx-base";
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
            __TO_BE_OVERWRITTEN__
        `;
    }
    createRenderRoot() {
        return this;
    }
    static Register() {
        customElements.define(this.tagName, this);
    }
}
var $269cb425db2ec96d$export$2e2bcd8739ae039 = $269cb425db2ec96d$var$ComponentBase;





class $76119ee70bd3b534$var$NcxSectionHero extends (0, $269cb425db2ec96d$export$2e2bcd8739ae039) {
    static get tagName() {
        return "ncx-section-hero";
    }
    constructor(){
        super();
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
            <div id="particles-js"></div>
            <div class="hero-text">
                <h1>inCassa</h1>
                <p>L'app che ti semplifica la sagra</p>
            </div>
        `;
    }
    firstUpdated() {
        particlesJS.load("particles-js", "/particles.json", ()=>{
            console.log("callback - particles.js config loaded");
        });
    }
}
$76119ee70bd3b534$var$NcxSectionHero.Register();
var $76119ee70bd3b534$export$2e2bcd8739ae039 = $76119ee70bd3b534$var$NcxSectionHero;





class $3668ca0b396e58be$var$NcxSectionDiscover extends (0, $269cb425db2ec96d$export$2e2bcd8739ae039) {
    static get tagName() {
        return "ncx-section-discover";
    }
    constructor(){
        super();
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
            <div>
                <h2>Di cosa si tratta</h2>
                <p>Benvenuti nell'applicativo per la gestione delle sagre!</p>
            </div>
            <div>
                <h4>Semplice ed intuitivo</h2>
                <p>Il nostro software offre una soluzione completa per facilitare l'ordinazione e la gestione degli ordini durante le sagre e gli eventi gastronomici.</p>
            </div>
            <div>
                <h4>Interfaccia user-friendly</h2>
                <p>Su tablet per la cassa e monitor TV per il monitoraggio degli ordini, semplifichiamo il processo di gestione, consentendo agli organizzatori di concentrarsi sulla soddisfazione dei clienti.</p>
            </div>
            <div>
                <p>Ottimizza il tuo evento con la nostra soluzione all'avanguardia per una gestione efficiente e senza problemi!</p>
            </div>
            <div>
                <h4>Come fare</h2>
                <p>Ci occupiamo dell'intera messa in opera del sistema, garantendo un'installazione rapida e senza intoppi.</p>
                <p>Forniamo tutte le attrezzature necessarie, come monitor TV, tablet e stampanti, qualora ne foste sprovvisti.</p>
                <p>Il nostro servizio è completo ed assicura che tu abbia tutto ciò di cui hai bisogno per gestire l'evento con successo, senza preoccupazioni tecniche.</p>
            </div>
        `;
    }
    firstUpdated() {
        this.carousel = this.querySelector(".carousel");
        this.instance = M.Carousel.init(this.carousel, {
            fullWidth: true,
            indicators: true
        });
    }
}
$3668ca0b396e58be$var$NcxSectionDiscover.Register();
var $3668ca0b396e58be$export$2e2bcd8739ae039 = $3668ca0b396e58be$var$NcxSectionDiscover;





"use strict";
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if ($c319b2c832c2914a$var$kindOf(val) !== "object") return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $c319b2c832c2914a$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $c319b2c832c2914a$var$isFunction(thing.append) && ((kind = $c319b2c832c2914a$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest("URLSearchParams");
const [$c319b2c832c2914a$var$isReadableStream, $c319b2c832c2914a$var$isRequest, $c319b2c832c2914a$var$isResponse, $c319b2c832c2914a$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($c319b2c832c2914a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $c319b2c832c2914a$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    const { caseless: caseless } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $c319b2c832c2914a$var$findKey(result, key) || key;
        if ($c319b2c832c2914a$var$isPlainObject(result[targetKey]) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(result[targetKey], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) a[key] = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest("HTMLFormElement");
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest("RegExp");
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const $c319b2c832c2914a$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $c319b2c832c2914a$var$DIGIT = "0123456789";
const $c319b2c832c2914a$var$ALPHABET = {
    DIGIT: $c319b2c832c2914a$var$DIGIT,
    ALPHA: $c319b2c832c2914a$var$ALPHA,
    ALPHA_DIGIT: $c319b2c832c2914a$var$ALPHA + $c319b2c832c2914a$var$ALPHA.toUpperCase() + $c319b2c832c2914a$var$DIGIT
};
const $c319b2c832c2914a$var$generateString = (size = 16, alphabet = $c319b2c832c2914a$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest("AsyncFunction");
const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
var $c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isReadableStream: $c319b2c832c2914a$var$isReadableStream,
    isRequest: $c319b2c832c2914a$var$isRequest,
    isResponse: $c319b2c832c2914a$var$isResponse,
    isHeaders: $c319b2c832c2914a$var$isHeaders,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    ALPHABET: $c319b2c832c2914a$var$ALPHABET,
    generateString: $c319b2c832c2914a$var$generateString,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $4e2395edb77acf3a$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($4e2395edb77acf3a$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $4e2395edb77acf3a$var$prototype = $4e2395edb77acf3a$var$AxiosError.prototype;
const $4e2395edb77acf3a$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $4e2395edb77acf3a$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($4e2395edb77acf3a$var$AxiosError, $4e2395edb77acf3a$var$descriptors);
Object.defineProperty($4e2395edb77acf3a$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$4e2395edb77acf3a$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($4e2395edb77acf3a$var$prototype);
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $4e2395edb77acf3a$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;


// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $eeb0961446aae8e3$export$6100ba28696e12de(buf);
    else return $eeb0961446aae8e3$export$6100ba28696e12de(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $7221566bd4d49f44$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7221566bd4d49f44$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $eeb0961446aae8e3$export$d622b2ad8d90c771($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $e6cbd383b18c9625$require$Buffer = $51861dfc7ca9d588$export$a143d493d941bafc;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject((0, $c319b2c832c2914a$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4023ac50ad132196$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $f66f8c7b4f247caf$var$encode);
    } : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $8df8fedf1c1e4428$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;





"use strict";
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039);


"use strict";
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $6eeff4490c995137$export$2e2bcd8739ae039,
        FormData: $86d275a264afb13f$export$2e2bcd8739ae039,
        Blob: $59c79e94740631e4$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $565e85ead8bde60a$exports = {};

$parcel$export($565e85ead8bde60a$exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
$parcel$export($565e85ead8bde60a$exports, "origin", () => $565e85ead8bde60a$export$f710a83a91838a36);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = ((product)=>{
    return $565e85ead8bde60a$export$c4996c4b7b93b0bf && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $565e85ead8bde60a$export$f710a83a91838a36 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";


var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$565e85ead8bde60a$exports,
    ...(0, $2f71637df772b183$export$2e2bcd8739ae039)
};


"use strict";
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(data, new (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).isNode && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $51466d41a76e5b4b$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $5f8142930b3b943f$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFile(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $f6f250f62cadb740$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isResponse(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $866cce54f6bdfb0c$var$$internals = Symbol("internals");
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : String(value);
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $fc026bbf9ee156f1$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;


"use strict";
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $843bf0209bc94df8$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $9fd0919e266b4fda$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($9fd0919e266b4fda$var$CanceledError, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;







"use strict";
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





"use strict";
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;


"use strict";
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $9b3ced92bc7bdc99$var$throttle(fn, freq) {
    let timestamp = 0;
    const threshold = 1000 / freq;
    let timer = null;
    return function throttled() {
        const force = this === true;
        const now = Date.now();
        if (force || now - timestamp > threshold) {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            timestamp = now;
            return fn.apply(null, arguments);
        }
        if (!timer) timer = setTimeout(()=>{
            timer = null;
            timestamp = Date.now();
            return fn.apply(null, arguments);
        }, threshold - (now - timestamp));
    };
}
var $9b3ced92bc7bdc99$export$2e2bcd8739ae039 = $9b3ced92bc7bdc99$var$throttle;


var $1a6c80b567b74091$export$2e2bcd8739ae039 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $4a9d49cd0e6b8acc$export$2e2bcd8739ae039)(50, 250);
    return (0, $9b3ced92bc7bdc99$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    }, freq);
};






"use strict";
var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();




var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


"use strict";
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $8fa91c1a59edb5d9$export$2e2bcd8739ae039)(requestedURL)) return (0, $b63e12c1e0b9e0be$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(target) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), true)
    };
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $ab4625fac3104691$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)((0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    let contentType;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || "multipart/form-data",
                ...tokens
            ].join("; "));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $5eb63b558e1fb85a$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $65cc14c0704b5541$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType } = _config;
        let onCanceled;
        function done() {
            if (_config.cancelToken) _config.cancelToken.unsubscribe(onCanceled);
            if (_config.signal) _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Request aborted", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, _config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Network Error", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, _config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, _config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (typeof _config.onDownloadProgress === "function") request.addEventListener("progress", (0, $1a6c80b567b74091$export$2e2bcd8739ae039)(_config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof _config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", (0, $1a6c80b567b74091$export$2e2bcd8739ae039)(_config.onUploadProgress));
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $23607f53e4fda918$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $bb8180acb278e187$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};







const $a052b9a6636aacdc$var$composeSignals = (signals, timeout)=>{
    let controller = new AbortController();
    let aborted;
    const onabort = function(cancel) {
        if (!aborted) {
            aborted = true;
            unsubscribe();
            const err = cancel instanceof Error ? cancel : this.reason;
            controller.abort(err instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039) ? err : new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
        }
    };
    let timer = timeout && setTimeout(()=>{
        onabort(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT));
    }, timeout);
    const unsubscribe = ()=>{
        if (signals) {
            timer && clearTimeout(timer);
            timer = null;
            signals.forEach((signal)=>{
                signal && (signal.removeEventListener ? signal.removeEventListener("abort", onabort) : signal.unsubscribe(onabort));
            });
            signals = null;
        }
    };
    signals.forEach((signal)=>signal && signal.addEventListener && signal.addEventListener("abort", onabort));
    const { signal: signal } = controller;
    signal.unsubscribe = unsubscribe;
    return [
        signal,
        ()=>{
            timer && clearTimeout(timer);
            timer = null;
        }
    ];
};
var $a052b9a6636aacdc$export$2e2bcd8739ae039 = $a052b9a6636aacdc$var$composeSignals;


const $c9465135abb26626$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c9465135abb26626$export$f9f241124ee3198e = async function*(iterable, chunkSize, encode) {
    for await (const chunk of iterable)yield* $c9465135abb26626$export$71b051935044bd5d(ArrayBuffer.isView(chunk) ? chunk : await encode(String(chunk)), chunkSize);
};
const $c9465135abb26626$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish, encode)=>{
    const iterator = $c9465135abb26626$export$f9f241124ee3198e(stream, chunkSize, encode);
    let bytes = 0;
    return new ReadableStream({
        type: "bytes",
        async pull (controller) {
            const { done: done, value: value } = await iterator.next();
            if (done) {
                controller.close();
                onFinish();
                return;
            }
            let len = value.byteLength;
            onProgress && onProgress(bytes += len);
            controller.enqueue(new Uint8Array(value));
        },
        cancel (reason) {
            onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $e52be20a9fc15e96$var$fetchProgressDecorator = (total, fn)=>{
    const lengthComputable = total != null;
    return (loaded)=>setTimeout(()=>fn({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }));
};
const $e52be20a9fc15e96$var$isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const $e52be20a9fc15e96$var$isReadableStreamSupported = $e52be20a9fc15e96$var$isFetchSupported && typeof ReadableStream === "function";
// used only inside the fetch adapter
const $e52be20a9fc15e96$var$encodeText = $e52be20a9fc15e96$var$isFetchSupported && (typeof TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $e52be20a9fc15e96$var$supportsRequestStream = $e52be20a9fc15e96$var$isReadableStreamSupported && (()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: "POST",
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
})();
const $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE = 65536;
const $e52be20a9fc15e96$var$supportsResponseStream = $e52be20a9fc15e96$var$isReadableStreamSupported && !!(()=>{
    try {
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(new Response("").body);
    } catch (err) {
    // return undefined
    }
})();
const $e52be20a9fc15e96$var$resolvers = {
    stream: $e52be20a9fc15e96$var$supportsResponseStream && ((res)=>res.body)
};
$e52be20a9fc15e96$var$isFetchSupported && ((res)=>{
    [
        "text",
        "arrayBuffer",
        "blob",
        "formData",
        "stream"
    ].forEach((type)=>{
        !$e52be20a9fc15e96$var$resolvers[type] && ($e52be20a9fc15e96$var$resolvers[type] = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $e52be20a9fc15e96$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(body)) return (await new Request(body).arrayBuffer()).byteLength;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(body)) return body.byteLength;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + "";
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(body)) return (await $e52be20a9fc15e96$var$encodeText(body)).byteLength;
};
const $e52be20a9fc15e96$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $e52be20a9fc15e96$var$getBodyLength(body) : length;
};
var $e52be20a9fc15e96$export$2e2bcd8739ae039 = $e52be20a9fc15e96$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions } = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + "").toLowerCase() : "text";
    let [composedSignal, stopTimeout] = signal || cancelToken || timeout ? (0, $a052b9a6636aacdc$export$2e2bcd8739ae039)([
        signal,
        cancelToken
    ], timeout) : [];
    let finished, request;
    const onFinish = ()=>{
        !finished && setTimeout(()=>{
            composedSignal && composedSignal.unsubscribe();
        });
        finished = true;
    };
    let requestContentLength;
    try {
        if (onUploadProgress && $e52be20a9fc15e96$var$supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await $e52be20a9fc15e96$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: "POST",
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
            if (_request.body) data = (0, $c9465135abb26626$export$b0119225647bd83)(_request.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, $e52be20a9fc15e96$var$fetchProgressDecorator(requestContentLength, (0, $1a6c80b567b74091$export$2e2bcd8739ae039)(onUploadProgress)), null, $e52be20a9fc15e96$var$encodeText);
        }
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? "cors" : "omit";
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            withCredentials: withCredentials
        });
        let response = await fetch(request);
        const isStreamResponse = $e52be20a9fc15e96$var$supportsResponseStream && (responseType === "stream" || responseType === "response");
        if ($e52be20a9fc15e96$var$supportsResponseStream && (onDownloadProgress || isStreamResponse)) {
            const options = {};
            [
                "status",
                "statusText",
                "headers"
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get("content-length"));
            response = new Response((0, $c9465135abb26626$export$b0119225647bd83)(response.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onDownloadProgress && $e52be20a9fc15e96$var$fetchProgressDecorator(responseContentLength, (0, $1a6c80b567b74091$export$2e2bcd8739ae039)(onDownloadProgress, true)), isStreamResponse && onFinish, $e52be20a9fc15e96$var$encodeText), options);
        }
        responseType = responseType || "text";
        let responseData = await $e52be20a9fc15e96$var$resolvers[(0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey($e52be20a9fc15e96$var$resolvers, responseType) || "text"](response, config);
        !isStreamResponse && onFinish();
        stopTimeout && stopTimeout();
        return await new Promise((resolve, reject)=>{
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        onFinish();
        if (err && err.name === "TypeError" && /fetch/i.test(err.message)) throw Object.assign(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Network Error", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $4023ac50ad132196$export$2e2bcd8739ae039),
    xhr: (0, $79f0a48d5eb7919b$export$2e2bcd8739ae039),
    fetch: (0, $e52be20a9fc15e96$export$2e2bcd8739ae039)
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($e8c8c7960873e9ee$var$renderReason).join("\n") : " " + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $e8c8c7960873e9ee$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $843bf0209bc94df8$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5a60afef8b0dd173$export$2e2bcd8739ae039)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.7.2";



"use strict";
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("options must be an object", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};



"use strict";
const $a93486d2307f31c3$var$validators = (0, $85f59389941e7907$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)(),
            response: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    $a93486d2307f31c3$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;






"use strict";
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $a93486d2307f31c3$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)((0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, (0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $843bf0209bc94df8$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $a93486d2307f31c3$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $9fd0919e266b4fda$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $fb81495929d8a282$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.isCancel = (0, $5a60afef8b0dd173$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.VERSION = (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132);
$57966c7e0affc4cb$var$axios.toFormData = (0, $e6cbd383b18c9625$export$2e2bcd8739ae039);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $4e2395edb77acf3a$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $089369673aa7c1c3$export$2e2bcd8739ae039);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $9db8da59db12cd94$export$2e2bcd8739ae039);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $5f8142930b3b943f$export$2e2bcd8739ae039)((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $f919374d785e9fb8$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a } = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039);


class $ef3baaf297e87c0b$var$NcxSectionContacts extends (0, $269cb425db2ec96d$export$2e2bcd8739ae039) {
    static get tagName() {
        return "ncx-section-contacts";
    }
    constructor(){
        super();
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
            <div class="text">
                <div class="form center-align">
                    <h1>Contatti</h1>
                    <div class="contacts-list">
                        <div><i class="material-icons">email</i> <a href="mailto:info@incassa.app">info@incassa.app</a></div>
                        <div><i class="material-icons">local_phone</i> <a href="tel:+393480197683">3480197683</a>&nbsp;(WhatsApp)</div>
                    </div>
                    <p>Compila il modulo qui sotto per essere ricontattato</p>
                    <form validate>
                        <div class="row">
                            <div class="input-field">
                                <input id="email" name="email" type="email" class="validate" required>
                                <label for="email">Email</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-field">
                                <input id="name" name="name" type="text">
                                <label for="name">Nome (opzionale)</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-field">
                                <input id="event_name" name="event_name" type="text">
                                <label for="event_name">Nome evento (opzionale)</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-field">
                                <input id="tel" name="tel" type="tel">
                                <label for="tel">Telefono (opzionale)</label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="input-field">
                                <textarea id="msg" class="materialize-textarea"></textarea>
                                <label for="msg">Messaggio (opzionale)</label>
                            </div>
                        </div>
                        <div class="success-message">Grazie! Ti ricontatteremo il prima possibile.</div>
                        <div class="error-message">Si è verificato un errore. Riprova.</div>
                        <button class="btn waves-effect waves-light" type="submit" name="action">
                            Invia
                            <i class="material-icons right">send</i>
                        </button>
                    </form>
                </div>
            </div>
        `;
    }
    firstUpdated() {
        const form = this.querySelector("form");
        const btn = this.querySelector("button");
        const emailField = form.querySelector("input#email");
        const nameField = form.querySelector("input#name");
        const eventNameField = form.querySelector("input#event_name");
        const telField = form.querySelector("input#tel");
        const msgField = form.querySelector("textarea#msg");
        form.onsubmit = async (evt)=>{
            evt.preventDefault();
            const data = {
                Name: nameField.value,
                Email: emailField.value,
                EventName: eventNameField.value,
                Tel: telField.value,
                Msg: msgField.value
            };
            try {
                btn.setAttribute("disabled", true);
                await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post("https://incassa-contact-form.fabio-blasizza.workers.dev/", data);
                emailField.value = "";
                emailField.classList.remove("valid");
                emailField.dispatchEvent(new Event("blur"));
                emailField.classList.remove("invalid");
                nameField.value = "";
                nameField.dispatchEvent(new Event("blur"));
                eventNameField.value = "";
                eventNameField.dispatchEvent(new Event("blur"));
                telField.value = "";
                telField.dispatchEvent(new Event("blur"));
                msgField.value = "";
                msgField.dispatchEvent(new Event("blur"));
                form.querySelector(".success-message").classList.add("visible");
                setTimeout(()=>{
                    form.querySelector(".success-message").classList.remove("visible");
                }, 3000);
            } catch (error) {
                form.querySelector(".error-message").classList.add("visible");
                setTimeout(()=>{
                    form.querySelector(".error-message").classList.remove("visible");
                }, 3000);
                console.error(error);
            } finally{
                btn.removeAttribute("disabled");
            }
        };
    }
}
$ef3baaf297e87c0b$var$NcxSectionContacts.Register();
var $ef3baaf297e87c0b$export$2e2bcd8739ae039 = $ef3baaf297e87c0b$var$NcxSectionContacts;





class $1517f8a9b8027278$var$NcxHeader extends (0, $269cb425db2ec96d$export$2e2bcd8739ae039) {
    static get tagName() {
        return "ncx-header";
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
            inCassa
        `;
    }
}
$1517f8a9b8027278$var$NcxHeader.Register();
var $1517f8a9b8027278$export$2e2bcd8739ae039 = $1517f8a9b8027278$var$NcxHeader;





class $d1a957997440ec44$var$NcxFooter extends (0, $269cb425db2ec96d$export$2e2bcd8739ae039) {
    static get tagName() {
        return "ncx-footer";
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
            &#169; ${new Date().getFullYear()} inCassa.
        `;
    }
}
$d1a957997440ec44$var$NcxFooter.Register();
var $d1a957997440ec44$export$2e2bcd8739ae039 = $d1a957997440ec44$var$NcxFooter;


class $e73bf42412feb220$var$App extends (0, $269cb425db2ec96d$export$2e2bcd8739ae039) {
    static get tagName() {
        return "ncx-app";
    }
    render() {
        return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`
            <!--ncx-header></ncx-header-->
            <ncx-section-hero></ncx-section-hero>
            <ncx-section-discover></ncx-section-discover>
            <ncx-section-contacts></ncx-section-contacts>
            <!--ncx-footer></ncx-footer-->
        `;
    }
}
$e73bf42412feb220$var$App.Register();
var $e73bf42412feb220$export$2e2bcd8739ae039 = $e73bf42412feb220$var$App;


parcelRequire("6PK7Y");


//# sourceMappingURL=index.b8bd467e.js.map
